
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("RPVlj", function(module, exports) {

$parcel$export(module.exports, "FullScreenQuad", () => $0a1d3a5a6a49de03$export$3983474c8e6e978b);

var $ilwiq = parcelRequire("ilwiq");
class $0a1d3a5a6a49de03$export$802bc10488da99c7 {
    constructor(){
        this.isPass = true;
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    setSize() {}
    render() {
        console.error("THREE.Pass: .render() must be implemented in derived pass.");
    }
    dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $0a1d3a5a6a49de03$var$_camera = new (0, $ilwiq.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry extends (0, $ilwiq.BufferGeometry) {
    constructor(){
        super();
        this.setAttribute("position", new (0, $ilwiq.Float32BufferAttribute)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute("uv", new (0, $ilwiq.Float32BufferAttribute)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}
const $0a1d3a5a6a49de03$var$_geometry = new $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry();
class $0a1d3a5a6a49de03$export$3983474c8e6e978b {
    constructor(material){
        this._mesh = new (0, $ilwiq.Mesh)($0a1d3a5a6a49de03$var$_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, $0a1d3a5a6a49de03$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}

});

parcelRegister("hWj76", function(module, exports) {

$parcel$export(module.exports, "PathTracingSceneGenerator", () => $d0f6adfc7402c638$export$245b5237bb7038ea);

var $ilwiq = parcelRequire("ilwiq");

var $6KVZ3 = parcelRequire("6KVZ3");
var $alNGj = parcelRequire("alNGj");

var $dCCOj = parcelRequire("dCCOj");

var $8LUnK = parcelRequire("8LUnK");
// collect the textures from the materials
function $d0f6adfc7402c638$var$getTextures(materials) {
    const textureSet = new Set();
    for(let i = 0, l = materials.length; i < l; i++){
        const material = materials[i];
        for(const key in material){
            const value = material[key];
            if (value && value.isTexture) textureSet.add(value);
        }
    }
    return Array.from(textureSet);
}
// collect the lights in the scene
function $d0f6adfc7402c638$var$getLights(objects) {
    const lights = [];
    const iesSet = new Set();
    for(let i = 0, l = objects.length; i < l; i++)objects[i].traverse((c)=>{
        if (c.visible) {
            if (c.isRectAreaLight || c.isSpotLight || c.isPointLight || c.isDirectionalLight) {
                lights.push(c);
                if (c.iesMap) iesSet.add(c.iesMap);
            }
        }
    });
    const iesTextures = Array.from(iesSet).sort((a, b)=>{
        if (a.uuid < b.uuid) return 1;
        if (a.uuid > b.uuid) return -1;
        return 0;
    });
    return {
        lights: lights,
        iesTextures: iesTextures
    };
}
class $d0f6adfc7402c638$export$245b5237bb7038ea {
    get initialized() {
        return Boolean(this.bvh);
    }
    constructor(objects){
        // options
        this.bvhOptions = {};
        this.attributes = [
            "position",
            "normal",
            "tangent",
            "color",
            "uv",
            "uv2"
        ];
        this.generateBVH = true;
        // state
        this.bvh = null;
        this.geometry = new (0, $ilwiq.BufferGeometry)();
        this.staticGeometryGenerator = new (0, $dCCOj.StaticGeometryGenerator)(objects);
        this._bvhWorker = null;
        this._pendingGenerate = null;
        this._buildAsync = false;
        this._materialUuids = null;
    }
    setObjects(objects) {
        this.staticGeometryGenerator.setObjects(objects);
    }
    setBVHWorker(bvhWorker) {
        this._bvhWorker = bvhWorker;
    }
    async generateAsync(onProgress = null) {
        if (!this._bvhWorker) throw new Error('PathTracingSceneGenerator: "setBVHWorker" must be called before "generateAsync" can be called.');
        if (this.bvh instanceof Promise) {
            // if a bvh is already being generated we can wait for that to finish
            // and build another with the latest data while sharing the results.
            if (!this._pendingGenerate) this._pendingGenerate = new Promise(async ()=>{
                await this.bvh;
                this._pendingGenerate = null;
                // TODO: support multiple callbacks queued?
                return this.generateAsync(onProgress);
            });
            return this._pendingGenerate;
        } else {
            this._buildAsync = true;
            const result = this.generate(onProgress);
            this._buildAsync = false;
            result.bvh = this.bvh = await result.bvh;
            return result;
        }
    }
    generate(onProgress = null) {
        const { staticGeometryGenerator: staticGeometryGenerator, geometry: geometry, attributes: attributes } = this;
        const objects = staticGeometryGenerator.objects;
        staticGeometryGenerator.attributes = attributes;
        // update the skeleton animations in case WebGLRenderer is not running
        // to update it.
        objects.forEach((o)=>{
            o.traverse((c)=>{
                if (c.isSkinnedMesh && c.skeleton) c.skeleton.update();
            });
        });
        // generate the geometry
        const result = staticGeometryGenerator.generate(geometry);
        const materials = result.materials;
        let needsMaterialIndexUpdate = result.changeType !== (0, $dCCOj.NO_CHANGE) || this._materialUuids === null || this._materialUuids.length !== length;
        if (!needsMaterialIndexUpdate) for(let i = 0, length1 = materials.length; i < length1; i++){
            const material = materials[i];
            if (material.uuid !== this._materialUuids[i]) {
                needsMaterialIndexUpdate = true;
                break;
            }
        }
        const textures = $d0f6adfc7402c638$var$getTextures(materials);
        const { lights: lights, iesTextures: iesTextures } = $d0f6adfc7402c638$var$getLights(objects);
        if (needsMaterialIndexUpdate) {
            (0, $8LUnK.updateMaterialIndexAttribute)(geometry, materials, materials);
            this._materialUuids = materials.map((material)=>material.uuid);
        }
        // only generate a new bvh if the objects used have changed
        if (this.generateBVH) {
            if (this.bvh instanceof Promise) throw new Error("PathTracingSceneGenerator: BVH is already building asynchronously.");
            if (result.changeType === (0, $dCCOj.GEOMETRY_REBUILT)) {
                const bvhOptions = {
                    strategy: (0, $alNGj.SAH),
                    maxLeafTris: 1,
                    indirect: true,
                    onProgress: onProgress,
                    ...this.bvhOptions
                };
                if (this._buildAsync) this.bvh = this._bvhWorker.generate(geometry, bvhOptions);
                else this.bvh = new (0, $6KVZ3.MeshBVH)(geometry, bvhOptions);
            } else if (result.changeType === (0, $dCCOj.GEOMETRY_ADJUSTED)) this.bvh.refit();
        }
        return {
            bvhChanged: result.changeType !== (0, $dCCOj.NO_CHANGE),
            bvh: this.bvh,
            needsMaterialIndexUpdate: needsMaterialIndexUpdate,
            lights: lights,
            iesTextures: iesTextures,
            geometry: geometry,
            materials: materials,
            textures: textures,
            objects: objects
        };
    }
}
class $d0f6adfc7402c638$export$b42762e2bf679e84 extends $d0f6adfc7402c638$export$245b5237bb7038ea {
    constructor(...args){
        super(...args);
        console.warn('DynamicPathTracingSceneGenerator has been deprecated and renamed to "PathTracingSceneGenerator".');
    }
}
class $d0f6adfc7402c638$export$5499aeafc5a5667b extends $d0f6adfc7402c638$export$245b5237bb7038ea {
    constructor(...args){
        super(...args);
        console.warn('PathTracingSceneWorker has been deprecated and renamed to "PathTracingSceneGenerator".');
    }
}

});
parcelRegister("6KVZ3", function(module, exports) {

$parcel$export(module.exports, "MeshBVH", () => $4eb4044e12c26831$export$9d614b3bc2c4eacf);

var $ilwiq = parcelRequire("ilwiq");

var $alNGj = parcelRequire("alNGj");

var $knbvI = parcelRequire("knbvI");

var $lenTA = parcelRequire("lenTA");

var $eADNI = parcelRequire("eADNI");

var $7EZfU = parcelRequire("7EZfU");

var $8hs00 = parcelRequire("8hs00");

var $8VlEg = parcelRequire("8VlEg");

var $9Kyri = parcelRequire("9Kyri");

var $ayHng = parcelRequire("ayHng");

var $laUNa = parcelRequire("laUNa");

var $1SnJR = parcelRequire("1SnJR");

var $dhXUU = parcelRequire("dhXUU");

var $dnRHH = parcelRequire("dnRHH");

var $gDpfV = parcelRequire("gDpfV");

var $iERXt = parcelRequire("iERXt");

var $kNP8c = parcelRequire("kNP8c");

var $ZxvHI = parcelRequire("ZxvHI");

var $bD1WL = parcelRequire("bD1WL");

var $gUrAj = parcelRequire("gUrAj");

var $cSOJe = parcelRequire("cSOJe");

var $dRxiJ = parcelRequire("dRxiJ");

var $f1zUR = parcelRequire("f1zUR");
const $4eb4044e12c26831$var$obb = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $4eb4044e12c26831$var$tempBox = /* @__PURE__ */ new (0, $ilwiq.Box3)();
const $4eb4044e12c26831$export$93ca5d3f8675ae4c = {
    strategy: (0, $alNGj.CENTER),
    maxDepth: 40,
    maxLeafTris: 10,
    useSharedArrayBuffer: false,
    setBoundingBox: true,
    onProgress: null,
    indirect: false,
    verbose: true
};
class $4eb4044e12c26831$export$9d614b3bc2c4eacf {
    static serialize(bvh, options = {}) {
        options = {
            cloneBuffers: true,
            ...options
        };
        const geometry = bvh.geometry;
        const rootData = bvh._roots;
        const indirectBuffer = bvh._indirectBuffer;
        const indexAttribute = geometry.getIndex();
        let result;
        if (options.cloneBuffers) result = {
            roots: rootData.map((root)=>root.slice()),
            index: indexAttribute ? indexAttribute.array.slice() : null,
            indirectBuffer: indirectBuffer ? indirectBuffer.slice() : null
        };
        else result = {
            roots: rootData,
            index: indexAttribute ? indexAttribute.array : null,
            indirectBuffer: indirectBuffer
        };
        return result;
    }
    static deserialize(data, geometry, options = {}) {
        options = {
            setIndex: true,
            indirect: Boolean(data.indirectBuffer),
            ...options
        };
        const { index: index, roots: roots, indirectBuffer: indirectBuffer } = data;
        const bvh = new $4eb4044e12c26831$export$9d614b3bc2c4eacf(geometry, {
            ...options,
            [(0, $alNGj.SKIP_GENERATION)]: true
        });
        bvh._roots = roots;
        bvh._indirectBuffer = indirectBuffer || null;
        if (options.setIndex) {
            const indexAttribute = geometry.getIndex();
            if (indexAttribute === null) {
                const newIndex = new (0, $ilwiq.BufferAttribute)(data.index, 1, false);
                geometry.setIndex(newIndex);
            } else if (indexAttribute.array !== index) {
                indexAttribute.array.set(index);
                indexAttribute.needsUpdate = true;
            }
        }
        return bvh;
    }
    get indirect() {
        return !!this._indirectBuffer;
    }
    constructor(geometry, options = {}){
        if (!geometry.isBufferGeometry) throw new Error("MeshBVH: Only BufferGeometries are supported.");
        else if (geometry.index && geometry.index.isInterleavedBufferAttribute) throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
        // default options
        options = Object.assign({
            ...$4eb4044e12c26831$export$93ca5d3f8675ae4c,
            // undocumented options
            // Whether to skip generating the tree. Used for deserialization.
            [(0, $alNGj.SKIP_GENERATION)]: false
        }, options);
        if (options.useSharedArrayBuffer && !(0, $cSOJe.isSharedArrayBufferSupported)()) throw new Error("MeshBVH: SharedArrayBuffer is not available.");
        // retain references to the geometry so we can use them it without having to
        // take a geometry reference in every function.
        this.geometry = geometry;
        this._roots = null;
        this._indirectBuffer = null;
        if (!options[0, $alNGj.SKIP_GENERATION]) {
            (0, $knbvI.buildPackedTree)(this, options);
            if (!geometry.boundingBox && options.setBoundingBox) geometry.boundingBox = this.getBoundingBox(new (0, $ilwiq.Box3)());
        }
        const { _indirectBuffer: _indirectBuffer } = this;
        this.resolveTriangleIndex = options.indirect ? (i)=>_indirectBuffer[i] : (i)=>i;
    }
    refit(nodeIndices = null) {
        const refitFunc = this.indirect ? (0, $iERXt.refit_indirect) : (0, $ayHng.refit);
        return refitFunc(this, nodeIndices);
    }
    traverse(callback, rootIndex = 0) {
        const buffer = this._roots[rootIndex];
        const uint32Array = new Uint32Array(buffer);
        const uint16Array = new Uint16Array(buffer);
        _traverse(0);
        function _traverse(node32Index, depth = 0) {
            const node16Index = node32Index * 2;
            const isLeaf = uint16Array[node16Index + 15] === (0, $alNGj.IS_LEAFNODE_FLAG);
            if (isLeaf) {
                const offset = uint32Array[node32Index + 6];
                const count = uint16Array[node16Index + 14];
                callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), offset, count);
            } else {
                // TODO: use node functions here
                const left = node32Index + (0, $alNGj.BYTES_PER_NODE) / 4;
                const right = uint32Array[node32Index + 6];
                const splitAxis = uint32Array[node32Index + 7];
                const stopTraversal = callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), splitAxis);
                if (!stopTraversal) {
                    _traverse(left, depth + 1);
                    _traverse(right, depth + 1);
                }
            }
        }
    }
    /* Core Cast Functions */ raycast(ray, materialOrSide = (0, $ilwiq.FrontSide)) {
        const roots = this._roots;
        const geometry = this.geometry;
        const intersects = [];
        const isMaterial = materialOrSide.isMaterial;
        const isArrayMaterial = Array.isArray(materialOrSide);
        const groups = geometry.groups;
        const side = isMaterial ? materialOrSide.side : materialOrSide;
        const raycastFunc = this.indirect ? (0, $kNP8c.raycast_indirect) : (0, $laUNa.raycast);
        for(let i = 0, l = roots.length; i < l; i++){
            const materialSide = isArrayMaterial ? materialOrSide[groups[i].materialIndex].side : side;
            const startCount = intersects.length;
            raycastFunc(this, i, materialSide, ray, intersects);
            if (isArrayMaterial) {
                const materialIndex = groups[i].materialIndex;
                for(let j = startCount, jl = intersects.length; j < jl; j++)intersects[j].face.materialIndex = materialIndex;
            }
        }
        return intersects;
    }
    raycastFirst(ray, materialOrSide = (0, $ilwiq.FrontSide)) {
        const roots = this._roots;
        const geometry = this.geometry;
        const isMaterial = materialOrSide.isMaterial;
        const isArrayMaterial = Array.isArray(materialOrSide);
        let closestResult = null;
        const groups = geometry.groups;
        const side = isMaterial ? materialOrSide.side : materialOrSide;
        const raycastFirstFunc = this.indirect ? (0, $ZxvHI.raycastFirst_indirect) : (0, $1SnJR.raycastFirst);
        for(let i = 0, l = roots.length; i < l; i++){
            const materialSide = isArrayMaterial ? materialOrSide[groups[i].materialIndex].side : side;
            const result = raycastFirstFunc(this, i, materialSide, ray);
            if (result != null && (closestResult == null || result.distance < closestResult.distance)) {
                closestResult = result;
                if (isArrayMaterial) result.face.materialIndex = groups[i].materialIndex;
            }
        }
        return closestResult;
    }
    intersectsGeometry(otherGeometry, geomToMesh) {
        let result = false;
        const roots = this._roots;
        const intersectsGeometryFunc = this.indirect ? (0, $bD1WL.intersectsGeometry_indirect) : (0, $dhXUU.intersectsGeometry);
        for(let i = 0, l = roots.length; i < l; i++){
            result = intersectsGeometryFunc(this, i, otherGeometry, geomToMesh);
            if (result) break;
        }
        return result;
    }
    shapecast(callbacks) {
        const triangle = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
        const iterateFunc = this.indirect ? (0, $gDpfV.iterateOverTriangles_indirect) : (0, $9Kyri.iterateOverTriangles);
        let { boundsTraverseOrder: boundsTraverseOrder, intersectsBounds: intersectsBounds, intersectsRange: intersectsRange, intersectsTriangle: intersectsTriangle } = callbacks;
        // wrap the intersectsRange function
        if (intersectsRange && intersectsTriangle) {
            const originalIntersectsRange = intersectsRange;
            intersectsRange = (offset, count, contained, depth, nodeIndex)=>{
                if (!originalIntersectsRange(offset, count, contained, depth, nodeIndex)) return iterateFunc(offset, count, this, intersectsTriangle, contained, depth, triangle);
                return true;
            };
        } else if (!intersectsRange) {
            if (intersectsTriangle) intersectsRange = (offset, count, contained, depth)=>{
                return iterateFunc(offset, count, this, intersectsTriangle, contained, depth, triangle);
            };
            else intersectsRange = (offset, count, contained)=>{
                return contained;
            };
        }
        // run shapecast
        let result = false;
        let byteOffset = 0;
        const roots = this._roots;
        for(let i = 0, l = roots.length; i < l; i++){
            const root = roots[i];
            result = (0, $8hs00.shapecast)(this, i, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
            if (result) break;
            byteOffset += root.byteLength;
        }
        (0, $7EZfU.ExtendedTrianglePool).releasePrimitive(triangle);
        return result;
    }
    bvhcast(otherBvh, matrixToLocal, callbacks) {
        let { intersectsRanges: intersectsRanges, intersectsTriangles: intersectsTriangles } = callbacks;
        const triangle1 = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
        const indexAttr1 = this.geometry.index;
        const positionAttr1 = this.geometry.attributes.position;
        const assignTriangle1 = this.indirect ? (i1)=>{
            const ti = this.resolveTriangleIndex(i1);
            (0, $dRxiJ.setTriangle)(triangle1, ti * 3, indexAttr1, positionAttr1);
        } : (i1)=>{
            (0, $dRxiJ.setTriangle)(triangle1, i1 * 3, indexAttr1, positionAttr1);
        };
        const triangle2 = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
        const indexAttr2 = otherBvh.geometry.index;
        const positionAttr2 = otherBvh.geometry.attributes.position;
        const assignTriangle2 = otherBvh.indirect ? (i2)=>{
            const ti2 = otherBvh.resolveTriangleIndex(i2);
            (0, $dRxiJ.setTriangle)(triangle2, ti2 * 3, indexAttr2, positionAttr2);
        } : (i2)=>{
            (0, $dRxiJ.setTriangle)(triangle2, i2 * 3, indexAttr2, positionAttr2);
        };
        // generate triangle callback if needed
        if (intersectsTriangles) {
            const iterateOverDoubleTriangles = (offset1, count1, offset2, count2, depth1, index1, depth2, index2)=>{
                for(let i2 = offset2, l2 = offset2 + count2; i2 < l2; i2++){
                    assignTriangle2(i2);
                    triangle2.a.applyMatrix4(matrixToLocal);
                    triangle2.b.applyMatrix4(matrixToLocal);
                    triangle2.c.applyMatrix4(matrixToLocal);
                    triangle2.needsUpdate = true;
                    for(let i1 = offset1, l1 = offset1 + count1; i1 < l1; i1++){
                        assignTriangle1(i1);
                        triangle1.needsUpdate = true;
                        if (intersectsTriangles(triangle1, triangle2, i1, i2, depth1, index1, depth2, index2)) return true;
                    }
                }
                return false;
            };
            if (intersectsRanges) {
                const originalIntersectsRanges = intersectsRanges;
                intersectsRanges = function(offset1, count1, offset2, count2, depth1, index1, depth2, index2) {
                    if (!originalIntersectsRanges(offset1, count1, offset2, count2, depth1, index1, depth2, index2)) return iterateOverDoubleTriangles(offset1, count1, offset2, count2, depth1, index1, depth2, index2);
                    return true;
                };
            } else intersectsRanges = iterateOverDoubleTriangles;
        }
        return (0, $f1zUR.bvhcast)(this, otherBvh, matrixToLocal, intersectsRanges);
    }
    /* Derived Cast Functions */ intersectsBox(box, boxToMesh) {
        $4eb4044e12c26831$var$obb.set(box.min, box.max, boxToMesh);
        $4eb4044e12c26831$var$obb.needsUpdate = true;
        return this.shapecast({
            intersectsBounds: (box)=>$4eb4044e12c26831$var$obb.intersectsBox(box),
            intersectsTriangle: (tri)=>$4eb4044e12c26831$var$obb.intersectsTriangle(tri)
        });
    }
    intersectsSphere(sphere) {
        return this.shapecast({
            intersectsBounds: (box)=>sphere.intersectsBox(box),
            intersectsTriangle: (tri)=>tri.intersectsSphere(sphere)
        });
    }
    closestPointToGeometry(otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
        const closestPointToGeometryFunc = this.indirect ? (0, $gUrAj.closestPointToGeometry_indirect) : (0, $dnRHH.closestPointToGeometry);
        return closestPointToGeometryFunc(this, otherGeometry, geometryToBvh, target1, target2, minThreshold, maxThreshold);
    }
    closestPointToPoint(point, target = {}, minThreshold = 0, maxThreshold = Infinity) {
        return (0, $8VlEg.closestPointToPoint)(this, point, target, minThreshold, maxThreshold);
    }
    getBoundingBox(target) {
        target.makeEmpty();
        const roots = this._roots;
        roots.forEach((buffer)=>{
            (0, $eADNI.arrayToBox)(0, new Float32Array(buffer), $4eb4044e12c26831$var$tempBox);
            target.union($4eb4044e12c26831$var$tempBox);
        });
        return target;
    }
}

});
parcelRegister("alNGj", function(module, exports) {

$parcel$export(module.exports, "CENTER", () => $78926744db4a8a3e$export$91c2158bc24c63d4);
$parcel$export(module.exports, "AVERAGE", () => $78926744db4a8a3e$export$d3bfe4097a2a8542);
$parcel$export(module.exports, "SAH", () => $78926744db4a8a3e$export$2b2cc3fb4f03d723);
$parcel$export(module.exports, "CONTAINED", () => $78926744db4a8a3e$export$82ad94f0a038b67a);
$parcel$export(module.exports, "TRIANGLE_INTERSECT_COST", () => $78926744db4a8a3e$export$22e1995328fd3cd9);
$parcel$export(module.exports, "TRAVERSAL_COST", () => $78926744db4a8a3e$export$f4b101accf1b23d1);
$parcel$export(module.exports, "BYTES_PER_NODE", () => $78926744db4a8a3e$export$a08e7d18fbc53be5);
$parcel$export(module.exports, "IS_LEAFNODE_FLAG", () => $78926744db4a8a3e$export$661fddb62bfe0e42);
$parcel$export(module.exports, "FLOAT32_EPSILON", () => $78926744db4a8a3e$export$859129fb5c8f4dc1);
$parcel$export(module.exports, "SKIP_GENERATION", () => $78926744db4a8a3e$export$abef70518a11a6ba);
// Split strategy constants
const $78926744db4a8a3e$export$91c2158bc24c63d4 = 0;
const $78926744db4a8a3e$export$d3bfe4097a2a8542 = 1;
const $78926744db4a8a3e$export$2b2cc3fb4f03d723 = 2;
const $78926744db4a8a3e$export$34b5498ca69d033 = 0;
const $78926744db4a8a3e$export$a26e00882057cd76 = 1;
const $78926744db4a8a3e$export$82ad94f0a038b67a = 2;
const $78926744db4a8a3e$export$22e1995328fd3cd9 = 1.25;
const $78926744db4a8a3e$export$f4b101accf1b23d1 = 1;
const $78926744db4a8a3e$export$a08e7d18fbc53be5 = 32;
const $78926744db4a8a3e$export$661fddb62bfe0e42 = 0xFFFF;
const $78926744db4a8a3e$export$859129fb5c8f4dc1 = Math.pow(2, -24);
const $78926744db4a8a3e$export$abef70518a11a6ba = Symbol("SKIP_GENERATION");

});

parcelRegister("knbvI", function(module, exports) {

$parcel$export(module.exports, "buildPackedTree", () => $ed4ee2639a9fd94e$export$e63bca57f220b8e3);

var $5Gkg5 = parcelRequire("5Gkg5");

var $6zZ33 = parcelRequire("6zZ33");

var $4rNvL = parcelRequire("4rNvL");

var $O2f62 = parcelRequire("O2f62");

var $alNGj = parcelRequire("alNGj");

var $8aRzr = parcelRequire("8aRzr");

var $fe03E = parcelRequire("fe03E");

var $8yQ90 = parcelRequire("8yQ90");
function $ed4ee2639a9fd94e$export$6008de7a0114426c(geometry, useSharedArrayBuffer) {
    const triCount = (geometry.index ? geometry.index.count : geometry.attributes.position.count) / 3;
    const useUint32 = triCount > 2 ** 16;
    const byteCount = useUint32 ? 4 : 2;
    const buffer = useSharedArrayBuffer ? new SharedArrayBuffer(triCount * byteCount) : new ArrayBuffer(triCount * byteCount);
    const indirectBuffer = useUint32 ? new Uint32Array(buffer) : new Uint16Array(buffer);
    for(let i = 0, l = indirectBuffer.length; i < l; i++)indirectBuffer[i] = i;
    return indirectBuffer;
}
function $ed4ee2639a9fd94e$export$9896244d8c99a4d0(bvh, triangleBounds, offset, count, options) {
    // epxand variables
    const { maxDepth: maxDepth, verbose: verbose, maxLeafTris: maxLeafTris, strategy: strategy, onProgress: onProgress, indirect: indirect } = options;
    const indirectBuffer = bvh._indirectBuffer;
    const geometry = bvh.geometry;
    const indexArray = geometry.index ? geometry.index.array : null;
    const partionFunc = indirect ? (0, $fe03E.partition_indirect) : (0, $8aRzr.partition);
    // generate intermediate variables
    const totalTriangles = (0, $5Gkg5.getTriCount)(geometry);
    const cacheCentroidBoundingData = new Float32Array(6);
    let reachedMaxDepth = false;
    const root = new (0, $O2f62.MeshBVHNode)();
    (0, $6zZ33.getBounds)(triangleBounds, offset, count, root.boundingData, cacheCentroidBoundingData);
    splitNode(root, offset, count, cacheCentroidBoundingData);
    return root;
    function triggerProgress(trianglesProcessed) {
        if (onProgress) onProgress(trianglesProcessed / totalTriangles);
    }
    // either recursively splits the given node, creating left and right subtrees for it, or makes it a leaf node,
    // recording the offset and count of its triangles and writing them into the reordered geometry index.
    function splitNode(node, offset, count, centroidBoundingData = null, depth = 0) {
        if (!reachedMaxDepth && depth >= maxDepth) {
            reachedMaxDepth = true;
            if (verbose) {
                console.warn(`MeshBVH: Max depth of ${maxDepth} reached when generating BVH. Consider increasing maxDepth.`);
                console.warn(geometry);
            }
        }
        // early out if we've met our capacity
        if (count <= maxLeafTris || depth >= maxDepth) {
            triggerProgress(offset + count);
            node.offset = offset;
            node.count = count;
            return node;
        }
        // Find where to split the volume
        const split = (0, $4rNvL.getOptimalSplit)(node.boundingData, centroidBoundingData, triangleBounds, offset, count, strategy);
        if (split.axis === -1) {
            triggerProgress(offset + count);
            node.offset = offset;
            node.count = count;
            return node;
        }
        const splitOffset = partionFunc(indirectBuffer, indexArray, triangleBounds, offset, count, split);
        // create the two new child nodes
        if (splitOffset === offset || splitOffset === offset + count) {
            triggerProgress(offset + count);
            node.offset = offset;
            node.count = count;
        } else {
            node.splitAxis = split.axis;
            // create the left child and compute its bounding box
            const left = new (0, $O2f62.MeshBVHNode)();
            const lstart = offset;
            const lcount = splitOffset - offset;
            node.left = left;
            (0, $6zZ33.getBounds)(triangleBounds, lstart, lcount, left.boundingData, cacheCentroidBoundingData);
            splitNode(left, lstart, lcount, cacheCentroidBoundingData, depth + 1);
            // repeat for right
            const right = new (0, $O2f62.MeshBVHNode)();
            const rstart = splitOffset;
            const rcount = count - lcount;
            node.right = right;
            (0, $6zZ33.getBounds)(triangleBounds, rstart, rcount, right.boundingData, cacheCentroidBoundingData);
            splitNode(right, rstart, rcount, cacheCentroidBoundingData, depth + 1);
        }
        return node;
    }
}
function $ed4ee2639a9fd94e$export$e63bca57f220b8e3(bvh, options) {
    const geometry = bvh.geometry;
    if (options.indirect) {
        bvh._indirectBuffer = $ed4ee2639a9fd94e$export$6008de7a0114426c(geometry, options.useSharedArrayBuffer);
        if ((0, $5Gkg5.hasGroupGaps)(geometry) && !options.verbose) console.warn('MeshBVH: Provided geometry contains groups that do not fully span the vertex contents while using the "indirect" option. BVH may incorrectly report intersections on unrendered portions of the geometry.');
    }
    if (!bvh._indirectBuffer) (0, $5Gkg5.ensureIndex)(geometry, options);
    const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    const triangleBounds = (0, $6zZ33.computeTriangleBounds)(geometry);
    const geometryRanges = options.indirect ? (0, $5Gkg5.getFullGeometryRange)(geometry) : (0, $5Gkg5.getRootIndexRanges)(geometry);
    bvh._roots = geometryRanges.map((range)=>{
        const root = $ed4ee2639a9fd94e$export$9896244d8c99a4d0(bvh, triangleBounds, range.offset, range.count, options);
        const nodeCount = (0, $8yQ90.countNodes)(root);
        const buffer = new BufferConstructor((0, $alNGj.BYTES_PER_NODE) * nodeCount);
        (0, $8yQ90.populateBuffer)(0, root, buffer);
        return buffer;
    });
}

});
parcelRegister("5Gkg5", function(module, exports) {

$parcel$export(module.exports, "getVertexCount", () => $423096e95cd96e19$export$bb010cc24ecaa644);
$parcel$export(module.exports, "getTriCount", () => $423096e95cd96e19$export$c56c51fae37b2d63);
$parcel$export(module.exports, "getIndexArray", () => $423096e95cd96e19$export$62808f0201824da2);
$parcel$export(module.exports, "ensureIndex", () => $423096e95cd96e19$export$90fd303420808ebb);
$parcel$export(module.exports, "getFullGeometryRange", () => $423096e95cd96e19$export$8c9d42783264c26e);
$parcel$export(module.exports, "getRootIndexRanges", () => $423096e95cd96e19$export$fd7a16c461f5043c);
$parcel$export(module.exports, "hasGroupGaps", () => $423096e95cd96e19$export$d3cf4eabab21775d);

var $ilwiq = parcelRequire("ilwiq");
function $423096e95cd96e19$export$bb010cc24ecaa644(geo) {
    return geo.index ? geo.index.count : geo.attributes.position.count;
}
function $423096e95cd96e19$export$c56c51fae37b2d63(geo) {
    return $423096e95cd96e19$export$bb010cc24ecaa644(geo) / 3;
}
function $423096e95cd96e19$export$62808f0201824da2(vertexCount, BufferConstructor = ArrayBuffer) {
    if (vertexCount > 65535) return new Uint32Array(new BufferConstructor(4 * vertexCount));
    else return new Uint16Array(new BufferConstructor(2 * vertexCount));
}
function $423096e95cd96e19$export$90fd303420808ebb(geo, options) {
    if (!geo.index) {
        const vertexCount = geo.attributes.position.count;
        const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
        const index = $423096e95cd96e19$export$62808f0201824da2(vertexCount, BufferConstructor);
        geo.setIndex(new (0, $ilwiq.BufferAttribute)(index, 1));
        for(let i = 0; i < vertexCount; i++)index[i] = i;
    }
}
function $423096e95cd96e19$export$8c9d42783264c26e(geo) {
    const triCount = $423096e95cd96e19$export$c56c51fae37b2d63(geo);
    const drawRange = geo.drawRange;
    const start = drawRange.start / 3;
    const end = (drawRange.start + drawRange.count) / 3;
    const offset = Math.max(0, start);
    const count = Math.min(triCount, end) - offset;
    return [
        {
            offset: Math.floor(offset),
            count: Math.floor(count)
        }
    ];
}
function $423096e95cd96e19$export$fd7a16c461f5043c(geo) {
    if (!geo.groups || !geo.groups.length) return $423096e95cd96e19$export$8c9d42783264c26e(geo);
    const ranges = [];
    const rangeBoundaries = new Set();
    const drawRange = geo.drawRange;
    const drawRangeStart = drawRange.start / 3;
    const drawRangeEnd = (drawRange.start + drawRange.count) / 3;
    for (const group of geo.groups){
        const groupStart = group.start / 3;
        const groupEnd = (group.start + group.count) / 3;
        rangeBoundaries.add(Math.max(drawRangeStart, groupStart));
        rangeBoundaries.add(Math.min(drawRangeEnd, groupEnd));
    }
    // note that if you don't pass in a comparator, it sorts them lexicographically as strings :-(
    const sortedBoundaries = Array.from(rangeBoundaries.values()).sort((a, b)=>a - b);
    for(let i = 0; i < sortedBoundaries.length - 1; i++){
        const start = sortedBoundaries[i];
        const end = sortedBoundaries[i + 1];
        ranges.push({
            offset: Math.floor(start),
            count: Math.floor(end - start)
        });
    }
    return ranges;
}
function $423096e95cd96e19$export$d3cf4eabab21775d(geometry) {
    if (geometry.groups.length === 0) return false;
    const vertexCount = $423096e95cd96e19$export$c56c51fae37b2d63(geometry);
    const groups = $423096e95cd96e19$export$fd7a16c461f5043c(geometry).sort((a, b)=>a.offset - b.offset);
    const finalGroup = groups[groups.length - 1];
    finalGroup.count = Math.min(vertexCount - finalGroup.offset, finalGroup.count);
    let total = 0;
    groups.forEach(({ count: count })=>total += count);
    return vertexCount !== total;
}

});

parcelRegister("6zZ33", function(module, exports) {

$parcel$export(module.exports, "getBounds", () => $4ca55de292e93eb1$export$becd1e645219fa23);
$parcel$export(module.exports, "computeTriangleBounds", () => $4ca55de292e93eb1$export$b3cc4d5d5179e78c);

var $alNGj = parcelRequire("alNGj");

var $5Gkg5 = parcelRequire("5Gkg5");
function $4ca55de292e93eb1$export$becd1e645219fa23(triangleBounds, offset, count, target, centroidTarget) {
    let minx = Infinity;
    let miny = Infinity;
    let minz = Infinity;
    let maxx = -Infinity;
    let maxy = -Infinity;
    let maxz = -Infinity;
    let cminx = Infinity;
    let cminy = Infinity;
    let cminz = Infinity;
    let cmaxx = -Infinity;
    let cmaxy = -Infinity;
    let cmaxz = -Infinity;
    for(let i = offset * 6, end = (offset + count) * 6; i < end; i += 6){
        const cx = triangleBounds[i + 0];
        const hx = triangleBounds[i + 1];
        const lx = cx - hx;
        const rx = cx + hx;
        if (lx < minx) minx = lx;
        if (rx > maxx) maxx = rx;
        if (cx < cminx) cminx = cx;
        if (cx > cmaxx) cmaxx = cx;
        const cy = triangleBounds[i + 2];
        const hy = triangleBounds[i + 3];
        const ly = cy - hy;
        const ry = cy + hy;
        if (ly < miny) miny = ly;
        if (ry > maxy) maxy = ry;
        if (cy < cminy) cminy = cy;
        if (cy > cmaxy) cmaxy = cy;
        const cz = triangleBounds[i + 4];
        const hz = triangleBounds[i + 5];
        const lz = cz - hz;
        const rz = cz + hz;
        if (lz < minz) minz = lz;
        if (rz > maxz) maxz = rz;
        if (cz < cminz) cminz = cz;
        if (cz > cmaxz) cmaxz = cz;
    }
    target[0] = minx;
    target[1] = miny;
    target[2] = minz;
    target[3] = maxx;
    target[4] = maxy;
    target[5] = maxz;
    centroidTarget[0] = cminx;
    centroidTarget[1] = cminy;
    centroidTarget[2] = cminz;
    centroidTarget[3] = cmaxx;
    centroidTarget[4] = cmaxy;
    centroidTarget[5] = cmaxz;
}
function $4ca55de292e93eb1$export$b3cc4d5d5179e78c(geo, target = null, offset = null, count = null) {
    const posAttr = geo.attributes.position;
    const index = geo.index ? geo.index.array : null;
    const triCount = (0, $5Gkg5.getTriCount)(geo);
    const normalized = posAttr.normalized;
    let triangleBounds;
    if (target === null) {
        triangleBounds = new Float32Array(triCount * 24);
        offset = 0;
        count = triCount;
    } else {
        triangleBounds = target;
        offset = offset || 0;
        count = count || triCount;
    }
    // used for non-normalized positions
    const posArr = posAttr.array;
    // support for an interleaved position buffer
    const bufferOffset = posAttr.offset || 0;
    let stride = 3;
    if (posAttr.isInterleavedBufferAttribute) stride = posAttr.data.stride;
    // used for normalized positions
    const getters = [
        "getX",
        "getY",
        "getZ"
    ];
    for(let tri = offset; tri < offset + count; tri++){
        const tri3 = tri * 3;
        const tri6 = tri * 6;
        let ai = tri3 + 0;
        let bi = tri3 + 1;
        let ci = tri3 + 2;
        if (index) {
            ai = index[ai];
            bi = index[bi];
            ci = index[ci];
        }
        // we add the stride and offset here since we access the array directly
        // below for the sake of performance
        if (!normalized) {
            ai = ai * stride + bufferOffset;
            bi = bi * stride + bufferOffset;
            ci = ci * stride + bufferOffset;
        }
        for(let el = 0; el < 3; el++){
            let a, b, c;
            if (normalized) {
                a = posAttr[getters[el]](ai);
                b = posAttr[getters[el]](bi);
                c = posAttr[getters[el]](ci);
            } else {
                a = posArr[ai + el];
                b = posArr[bi + el];
                c = posArr[ci + el];
            }
            let min = a;
            if (b < min) min = b;
            if (c < min) min = c;
            let max = a;
            if (b > max) max = b;
            if (c > max) max = c;
            // Increase the bounds size by float32 epsilon to avoid precision errors when
            // converting to 32 bit float. Scale the epsilon by the size of the numbers being
            // worked with.
            const halfExtents = (max - min) / 2;
            const el2 = el * 2;
            triangleBounds[tri6 + el2 + 0] = min + halfExtents;
            triangleBounds[tri6 + el2 + 1] = halfExtents + (Math.abs(min) + halfExtents) * (0, $alNGj.FLOAT32_EPSILON);
        }
    }
    return triangleBounds;
}

});

parcelRegister("4rNvL", function(module, exports) {

$parcel$export(module.exports, "getOptimalSplit", () => $33d016ef2ae8a9ff$export$9e40712018083c80);

var $eADNI = parcelRequire("eADNI");

var $alNGj = parcelRequire("alNGj");
const $33d016ef2ae8a9ff$var$BIN_COUNT = 32;
const $33d016ef2ae8a9ff$var$binsSort = (a, b)=>a.candidate - b.candidate;
const $33d016ef2ae8a9ff$var$sahBins = new Array($33d016ef2ae8a9ff$var$BIN_COUNT).fill().map(()=>{
    return {
        count: 0,
        bounds: new Float32Array(6),
        rightCacheBounds: new Float32Array(6),
        leftCacheBounds: new Float32Array(6),
        candidate: 0
    };
});
const $33d016ef2ae8a9ff$var$leftBounds = new Float32Array(6);
function $33d016ef2ae8a9ff$export$9e40712018083c80(nodeBoundingData, centroidBoundingData, triangleBounds, offset, count, strategy) {
    let axis = -1;
    let pos = 0;
    // Center
    if (strategy === (0, $alNGj.CENTER)) {
        axis = (0, $eADNI.getLongestEdgeIndex)(centroidBoundingData);
        if (axis !== -1) pos = (centroidBoundingData[axis] + centroidBoundingData[axis + 3]) / 2;
    } else if (strategy === (0, $alNGj.AVERAGE)) {
        axis = (0, $eADNI.getLongestEdgeIndex)(nodeBoundingData);
        if (axis !== -1) pos = $33d016ef2ae8a9ff$var$getAverage(triangleBounds, offset, count, axis);
    } else if (strategy === (0, $alNGj.SAH)) {
        const rootSurfaceArea = (0, $eADNI.computeSurfaceArea)(nodeBoundingData);
        let bestCost = (0, $alNGj.TRIANGLE_INTERSECT_COST) * count;
        // iterate over all axes
        const cStart = offset * 6;
        const cEnd = (offset + count) * 6;
        for(let a = 0; a < 3; a++){
            const axisLeft = centroidBoundingData[a];
            const axisRight = centroidBoundingData[a + 3];
            const axisLength = axisRight - axisLeft;
            const binWidth = axisLength / $33d016ef2ae8a9ff$var$BIN_COUNT;
            // If we have fewer triangles than we're planning to split then just check all
            // the triangle positions because it will be faster.
            if (count < $33d016ef2ae8a9ff$var$BIN_COUNT / 4) {
                // initialize the bin candidates
                const truncatedBins = [
                    ...$33d016ef2ae8a9ff$var$sahBins
                ];
                truncatedBins.length = count;
                // set the candidates
                let b = 0;
                for(let c = cStart; c < cEnd; c += 6, b++){
                    const bin = truncatedBins[b];
                    bin.candidate = triangleBounds[c + 2 * a];
                    bin.count = 0;
                    const { bounds: bounds, leftCacheBounds: leftCacheBounds, rightCacheBounds: rightCacheBounds } = bin;
                    for(let d = 0; d < 3; d++){
                        rightCacheBounds[d] = Infinity;
                        rightCacheBounds[d + 3] = -Infinity;
                        leftCacheBounds[d] = Infinity;
                        leftCacheBounds[d + 3] = -Infinity;
                        bounds[d] = Infinity;
                        bounds[d + 3] = -Infinity;
                    }
                    (0, $eADNI.expandByTriangleBounds)(c, triangleBounds, bounds);
                }
                truncatedBins.sort($33d016ef2ae8a9ff$var$binsSort);
                // remove redundant splits
                let splitCount = count;
                for(let bi = 0; bi < splitCount; bi++){
                    const bin = truncatedBins[bi];
                    while(bi + 1 < splitCount && truncatedBins[bi + 1].candidate === bin.candidate){
                        truncatedBins.splice(bi + 1, 1);
                        splitCount--;
                    }
                }
                // find the appropriate bin for each triangle and expand the bounds.
                for(let c = cStart; c < cEnd; c += 6){
                    const center = triangleBounds[c + 2 * a];
                    for(let bi = 0; bi < splitCount; bi++){
                        const bin = truncatedBins[bi];
                        if (center >= bin.candidate) (0, $eADNI.expandByTriangleBounds)(c, triangleBounds, bin.rightCacheBounds);
                        else {
                            (0, $eADNI.expandByTriangleBounds)(c, triangleBounds, bin.leftCacheBounds);
                            bin.count++;
                        }
                    }
                }
                // expand all the bounds
                for(let bi = 0; bi < splitCount; bi++){
                    const bin = truncatedBins[bi];
                    const leftCount = bin.count;
                    const rightCount = count - bin.count;
                    // check the cost of this split
                    const leftBounds = bin.leftCacheBounds;
                    const rightBounds = bin.rightCacheBounds;
                    let leftProb = 0;
                    if (leftCount !== 0) leftProb = (0, $eADNI.computeSurfaceArea)(leftBounds) / rootSurfaceArea;
                    let rightProb = 0;
                    if (rightCount !== 0) rightProb = (0, $eADNI.computeSurfaceArea)(rightBounds) / rootSurfaceArea;
                    const cost = (0, $alNGj.TRAVERSAL_COST) + (0, $alNGj.TRIANGLE_INTERSECT_COST) * (leftProb * leftCount + rightProb * rightCount);
                    if (cost < bestCost) {
                        axis = a;
                        bestCost = cost;
                        pos = bin.candidate;
                    }
                }
            } else {
                // reset the bins
                for(let i = 0; i < $33d016ef2ae8a9ff$var$BIN_COUNT; i++){
                    const bin = $33d016ef2ae8a9ff$var$sahBins[i];
                    bin.count = 0;
                    bin.candidate = axisLeft + binWidth + i * binWidth;
                    const bounds = bin.bounds;
                    for(let d = 0; d < 3; d++){
                        bounds[d] = Infinity;
                        bounds[d + 3] = -Infinity;
                    }
                }
                // iterate over all center positions
                for(let c = cStart; c < cEnd; c += 6){
                    const triCenter = triangleBounds[c + 2 * a];
                    const relativeCenter = triCenter - axisLeft;
                    // in the partition function if the centroid lies on the split plane then it is
                    // considered to be on the right side of the split
                    let binIndex = ~~(relativeCenter / binWidth);
                    if (binIndex >= $33d016ef2ae8a9ff$var$BIN_COUNT) binIndex = $33d016ef2ae8a9ff$var$BIN_COUNT - 1;
                    const bin = $33d016ef2ae8a9ff$var$sahBins[binIndex];
                    bin.count++;
                    (0, $eADNI.expandByTriangleBounds)(c, triangleBounds, bin.bounds);
                }
                // cache the unioned bounds from right to left so we don't have to regenerate them each time
                const lastBin = $33d016ef2ae8a9ff$var$sahBins[$33d016ef2ae8a9ff$var$BIN_COUNT - 1];
                (0, $eADNI.copyBounds)(lastBin.bounds, lastBin.rightCacheBounds);
                for(let i = $33d016ef2ae8a9ff$var$BIN_COUNT - 2; i >= 0; i--){
                    const bin = $33d016ef2ae8a9ff$var$sahBins[i];
                    const nextBin = $33d016ef2ae8a9ff$var$sahBins[i + 1];
                    (0, $eADNI.unionBounds)(bin.bounds, nextBin.rightCacheBounds, bin.rightCacheBounds);
                }
                let leftCount = 0;
                for(let i = 0; i < $33d016ef2ae8a9ff$var$BIN_COUNT - 1; i++){
                    const bin = $33d016ef2ae8a9ff$var$sahBins[i];
                    const binCount = bin.count;
                    const bounds = bin.bounds;
                    const nextBin = $33d016ef2ae8a9ff$var$sahBins[i + 1];
                    const rightBounds = nextBin.rightCacheBounds;
                    // don't do anything with the bounds if the new bounds have no triangles
                    if (binCount !== 0) {
                        if (leftCount === 0) (0, $eADNI.copyBounds)(bounds, $33d016ef2ae8a9ff$var$leftBounds);
                        else (0, $eADNI.unionBounds)(bounds, $33d016ef2ae8a9ff$var$leftBounds, $33d016ef2ae8a9ff$var$leftBounds);
                    }
                    leftCount += binCount;
                    // check the cost of this split
                    let leftProb = 0;
                    let rightProb = 0;
                    if (leftCount !== 0) leftProb = (0, $eADNI.computeSurfaceArea)($33d016ef2ae8a9ff$var$leftBounds) / rootSurfaceArea;
                    const rightCount = count - leftCount;
                    if (rightCount !== 0) rightProb = (0, $eADNI.computeSurfaceArea)(rightBounds) / rootSurfaceArea;
                    const cost = (0, $alNGj.TRAVERSAL_COST) + (0, $alNGj.TRIANGLE_INTERSECT_COST) * (leftProb * leftCount + rightProb * rightCount);
                    if (cost < bestCost) {
                        axis = a;
                        bestCost = cost;
                        pos = bin.candidate;
                    }
                }
            }
        }
    } else console.warn(`MeshBVH: Invalid build strategy value ${strategy} used.`);
    return {
        axis: axis,
        pos: pos
    };
}
// returns the average coordinate on the specified axis of the all the provided triangles
function $33d016ef2ae8a9ff$var$getAverage(triangleBounds, offset, count, axis) {
    let avg = 0;
    for(let i = offset, end = offset + count; i < end; i++)avg += triangleBounds[i * 6 + axis * 2];
    return avg / count;
}

});
parcelRegister("eADNI", function(module, exports) {

$parcel$export(module.exports, "arrayToBox", () => $a9f34d1ac25848aa$export$40b9a5e446bf11e0);
$parcel$export(module.exports, "getLongestEdgeIndex", () => $a9f34d1ac25848aa$export$dcdc414399b99746);
$parcel$export(module.exports, "copyBounds", () => $a9f34d1ac25848aa$export$14b050a767b4a3a7);
$parcel$export(module.exports, "unionBounds", () => $a9f34d1ac25848aa$export$a8a7063dce01a911);
$parcel$export(module.exports, "expandByTriangleBounds", () => $a9f34d1ac25848aa$export$c989e53c4b24c2f5);
$parcel$export(module.exports, "computeSurfaceArea", () => $a9f34d1ac25848aa$export$dbf4320364dc239e);
function $a9f34d1ac25848aa$export$40b9a5e446bf11e0(nodeIndex32, array, target) {
    target.min.x = array[nodeIndex32];
    target.min.y = array[nodeIndex32 + 1];
    target.min.z = array[nodeIndex32 + 2];
    target.max.x = array[nodeIndex32 + 3];
    target.max.y = array[nodeIndex32 + 4];
    target.max.z = array[nodeIndex32 + 5];
    return target;
}
function $a9f34d1ac25848aa$export$8737d658f04762d3(target) {
    target[0] = target[1] = target[2] = Infinity;
    target[3] = target[4] = target[5] = -Infinity;
}
function $a9f34d1ac25848aa$export$dcdc414399b99746(bounds) {
    let splitDimIdx = -1;
    let splitDist = -Infinity;
    for(let i = 0; i < 3; i++){
        const dist = bounds[i + 3] - bounds[i];
        if (dist > splitDist) {
            splitDist = dist;
            splitDimIdx = i;
        }
    }
    return splitDimIdx;
}
function $a9f34d1ac25848aa$export$14b050a767b4a3a7(source, target) {
    target.set(source);
}
function $a9f34d1ac25848aa$export$a8a7063dce01a911(a, b, target) {
    let aVal, bVal;
    for(let d = 0; d < 3; d++){
        const d3 = d + 3;
        // set the minimum values
        aVal = a[d];
        bVal = b[d];
        target[d] = aVal < bVal ? aVal : bVal;
        // set the max values
        aVal = a[d3];
        bVal = b[d3];
        target[d3] = aVal > bVal ? aVal : bVal;
    }
}
function $a9f34d1ac25848aa$export$c989e53c4b24c2f5(startIndex, triangleBounds, bounds) {
    for(let d = 0; d < 3; d++){
        const tCenter = triangleBounds[startIndex + 2 * d];
        const tHalf = triangleBounds[startIndex + 2 * d + 1];
        const tMin = tCenter - tHalf;
        const tMax = tCenter + tHalf;
        if (tMin < bounds[d]) bounds[d] = tMin;
        if (tMax > bounds[d + 3]) bounds[d + 3] = tMax;
    }
}
function $a9f34d1ac25848aa$export$dbf4320364dc239e(bounds) {
    const d0 = bounds[3] - bounds[0];
    const d1 = bounds[4] - bounds[1];
    const d2 = bounds[5] - bounds[2];
    return 2 * (d0 * d1 + d1 * d2 + d2 * d0);
}

});


parcelRegister("O2f62", function(module, exports) {

$parcel$export(module.exports, "MeshBVHNode", () => $096668f03fbb5645$export$6f473cc5f89b0a1c);
class $096668f03fbb5645$export$6f473cc5f89b0a1c {
    constructor(){
        // internal nodes have boundingData, left, right, and splitAxis
        // leaf nodes have offset and count (referring to primitives in the mesh geometry)
        this.boundingData = new Float32Array(6);
    }
}

});

parcelRegister("8aRzr", function(module, exports) {

$parcel$export(module.exports, "partition", () => $5f38cfeb5f7666c7$export$b29f828819edca8d);
/********************************************************/ /* This file is generated from "sortUtils.template.js". */ /********************************************************/ // reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.
function $5f38cfeb5f7666c7$export$b29f828819edca8d(indirectBuffer, index, triangleBounds, offset, count, split) {
    let left = offset;
    let right = offset + count - 1;
    const pos = split.pos;
    const axisOffset = split.axis * 2;
    // hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme
    while(true){
        while(left <= right && triangleBounds[left * 6 + axisOffset] < pos)left++;
        // if a triangle center lies on the partition plane it is considered to be on the right side
        while(left <= right && triangleBounds[right * 6 + axisOffset] >= pos)right--;
        if (left < right) {
            // we need to swap all of the information associated with the triangles at index
            // left and right; that's the verts in the geometry index, the bounds,
            // and perhaps the SAH planes
            for(let i = 0; i < 3; i++){
                let t0 = index[left * 3 + i];
                index[left * 3 + i] = index[right * 3 + i];
                index[right * 3 + i] = t0;
            }
            // swap bounds
            for(let i = 0; i < 6; i++){
                let tb = triangleBounds[left * 6 + i];
                triangleBounds[left * 6 + i] = triangleBounds[right * 6 + i];
                triangleBounds[right * 6 + i] = tb;
            }
            left++;
            right--;
        } else return left;
    }
}

});

parcelRegister("fe03E", function(module, exports) {

$parcel$export(module.exports, "partition_indirect", () => $b1583556301b54a3$export$7cee363d477551d0);
/********************************************************/ /* This file is generated from "sortUtils.template.js". */ /********************************************************/ // reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.
function $b1583556301b54a3$export$7cee363d477551d0(indirectBuffer, index, triangleBounds, offset, count, split) {
    let left = offset;
    let right = offset + count - 1;
    const pos = split.pos;
    const axisOffset = split.axis * 2;
    // hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme
    while(true){
        while(left <= right && triangleBounds[left * 6 + axisOffset] < pos)left++;
        // if a triangle center lies on the partition plane it is considered to be on the right side
        while(left <= right && triangleBounds[right * 6 + axisOffset] >= pos)right--;
        if (left < right) {
            // we need to swap all of the information associated with the triangles at index
            // left and right; that's the verts in the geometry index, the bounds,
            // and perhaps the SAH planes
            let t = indirectBuffer[left];
            indirectBuffer[left] = indirectBuffer[right];
            indirectBuffer[right] = t;
            // swap bounds
            for(let i = 0; i < 6; i++){
                let tb = triangleBounds[left * 6 + i];
                triangleBounds[left * 6 + i] = triangleBounds[right * 6 + i];
                triangleBounds[right * 6 + i] = tb;
            }
            left++;
            right--;
        } else return left;
    }
}

});

parcelRegister("8yQ90", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $63b9f27945e6e48e$export$1daf15cbaf649dad);
$parcel$export(module.exports, "populateBuffer", () => $63b9f27945e6e48e$export$faac1b763a0eceb5);

var $alNGj = parcelRequire("alNGj");

var $8x2iv = parcelRequire("8x2iv");
let $63b9f27945e6e48e$var$float32Array, $63b9f27945e6e48e$var$uint32Array, $63b9f27945e6e48e$var$uint16Array, $63b9f27945e6e48e$var$uint8Array;
const $63b9f27945e6e48e$var$MAX_POINTER = Math.pow(2, 32);
function $63b9f27945e6e48e$export$1daf15cbaf649dad(node) {
    if ("count" in node) return 1;
    else return 1 + $63b9f27945e6e48e$export$1daf15cbaf649dad(node.left) + $63b9f27945e6e48e$export$1daf15cbaf649dad(node.right);
}
function $63b9f27945e6e48e$export$faac1b763a0eceb5(byteOffset, node, buffer) {
    $63b9f27945e6e48e$var$float32Array = new Float32Array(buffer);
    $63b9f27945e6e48e$var$uint32Array = new Uint32Array(buffer);
    $63b9f27945e6e48e$var$uint16Array = new Uint16Array(buffer);
    $63b9f27945e6e48e$var$uint8Array = new Uint8Array(buffer);
    return $63b9f27945e6e48e$var$_populateBuffer(byteOffset, node);
}
// pack structure
// boundingData  				: 6 float32
// right / offset 				: 1 uint32
// splitAxis / isLeaf + count 	: 1 uint32 / 2 uint16
function $63b9f27945e6e48e$var$_populateBuffer(byteOffset, node) {
    const stride4Offset = byteOffset / 4;
    const stride2Offset = byteOffset / 2;
    const isLeaf = "count" in node;
    const boundingData = node.boundingData;
    for(let i = 0; i < 6; i++)$63b9f27945e6e48e$var$float32Array[stride4Offset + i] = boundingData[i];
    if (isLeaf) {
        if (node.buffer) {
            const buffer = node.buffer;
            $63b9f27945e6e48e$var$uint8Array.set(new Uint8Array(buffer), byteOffset);
            for(let offset = byteOffset, l = byteOffset + buffer.byteLength; offset < l; offset += (0, $alNGj.BYTES_PER_NODE)){
                const offset2 = offset / 2;
                if (!(0, $8x2iv.IS_LEAF)(offset2, $63b9f27945e6e48e$var$uint16Array)) $63b9f27945e6e48e$var$uint32Array[offset / 4 + 6] += stride4Offset;
            }
            return byteOffset + buffer.byteLength;
        } else {
            const offset = node.offset;
            const count = node.count;
            $63b9f27945e6e48e$var$uint32Array[stride4Offset + 6] = offset;
            $63b9f27945e6e48e$var$uint16Array[stride2Offset + 14] = count;
            $63b9f27945e6e48e$var$uint16Array[stride2Offset + 15] = (0, $alNGj.IS_LEAFNODE_FLAG);
            return byteOffset + (0, $alNGj.BYTES_PER_NODE);
        }
    } else {
        const left = node.left;
        const right = node.right;
        const splitAxis = node.splitAxis;
        let nextUnusedPointer;
        nextUnusedPointer = $63b9f27945e6e48e$var$_populateBuffer(byteOffset + (0, $alNGj.BYTES_PER_NODE), left);
        if (nextUnusedPointer / 4 > $63b9f27945e6e48e$var$MAX_POINTER) throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
        $63b9f27945e6e48e$var$uint32Array[stride4Offset + 6] = nextUnusedPointer / 4;
        nextUnusedPointer = $63b9f27945e6e48e$var$_populateBuffer(nextUnusedPointer, right);
        $63b9f27945e6e48e$var$uint32Array[stride4Offset + 7] = splitAxis;
        return nextUnusedPointer;
    }
}

});
parcelRegister("8x2iv", function(module, exports) {

$parcel$export(module.exports, "IS_LEAF", () => $6363300ccf15b961$export$bc7cbaf27fbe938e);
$parcel$export(module.exports, "OFFSET", () => $6363300ccf15b961$export$3231e969238304f3);
$parcel$export(module.exports, "COUNT", () => $6363300ccf15b961$export$d61684373eacdf61);
$parcel$export(module.exports, "LEFT_NODE", () => $6363300ccf15b961$export$7a68bc00425859d);
$parcel$export(module.exports, "RIGHT_NODE", () => $6363300ccf15b961$export$4f44f52d9f75fa31);
$parcel$export(module.exports, "SPLIT_AXIS", () => $6363300ccf15b961$export$b43717b3ca95505);
$parcel$export(module.exports, "BOUNDING_DATA_INDEX", () => $6363300ccf15b961$export$b5b7e27a1440579d);
function $6363300ccf15b961$export$bc7cbaf27fbe938e(n16, uint16Array) {
    return uint16Array[n16 + 15] === 0xFFFF;
}
function $6363300ccf15b961$export$3231e969238304f3(n32, uint32Array) {
    return uint32Array[n32 + 6];
}
function $6363300ccf15b961$export$d61684373eacdf61(n16, uint16Array) {
    return uint16Array[n16 + 14];
}
function $6363300ccf15b961$export$7a68bc00425859d(n32) {
    return n32 + 8;
}
function $6363300ccf15b961$export$4f44f52d9f75fa31(n32, uint32Array) {
    return uint32Array[n32 + 6];
}
function $6363300ccf15b961$export$b43717b3ca95505(n32, uint32Array) {
    return uint32Array[n32 + 7];
}
function $6363300ccf15b961$export$b5b7e27a1440579d(n32) {
    return n32;
}

});



parcelRegister("lenTA", function(module, exports) {

$parcel$export(module.exports, "OrientedBox", () => $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58);

var $ilwiq = parcelRequire("ilwiq");

var $2OKGW = parcelRequire("2OKGW");

var $8VYkb = parcelRequire("8VYkb");

var $f56Km = parcelRequire("f56Km");
class $f74d70f31e44d1f9$export$4ccecd8ac6ee0e58 {
    constructor(min, max, matrix){
        this.isOrientedBox = true;
        this.min = new (0, $ilwiq.Vector3)();
        this.max = new (0, $ilwiq.Vector3)();
        this.matrix = new (0, $ilwiq.Matrix4)();
        this.invMatrix = new (0, $ilwiq.Matrix4)();
        this.points = new Array(8).fill().map(()=>new (0, $ilwiq.Vector3)());
        this.satAxes = new Array(3).fill().map(()=>new (0, $ilwiq.Vector3)());
        this.satBounds = new Array(3).fill().map(()=>new (0, $2OKGW.SeparatingAxisBounds)());
        this.alignedSatBounds = new Array(3).fill().map(()=>new (0, $2OKGW.SeparatingAxisBounds)());
        this.needsUpdate = false;
        if (min) this.min.copy(min);
        if (max) this.max.copy(max);
        if (matrix) this.matrix.copy(matrix);
    }
    set(min, max, matrix) {
        this.min.copy(min);
        this.max.copy(max);
        this.matrix.copy(matrix);
        this.needsUpdate = true;
    }
    copy(other) {
        this.min.copy(other.min);
        this.max.copy(other.max);
        this.matrix.copy(other.matrix);
        this.needsUpdate = true;
    }
}
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.update = function() {
    return function update() {
        const matrix = this.matrix;
        const min = this.min;
        const max = this.max;
        const points = this.points;
        for(let x = 0; x <= 1; x++){
            for(let y = 0; y <= 1; y++)for(let z = 0; z <= 1; z++){
                const i = 1 * x | 2 * y | 4 * z;
                const v = points[i];
                v.x = x ? max.x : min.x;
                v.y = y ? max.y : min.y;
                v.z = z ? max.z : min.z;
                v.applyMatrix4(matrix);
            }
        }
        const satBounds = this.satBounds;
        const satAxes = this.satAxes;
        const minVec = points[0];
        for(let i = 0; i < 3; i++){
            const axis = satAxes[i];
            const sb = satBounds[i];
            const index = 1 << i;
            const pi = points[index];
            axis.subVectors(minVec, pi);
            sb.setFromPoints(axis, points);
        }
        const alignedSatBounds = this.alignedSatBounds;
        alignedSatBounds[0].setFromPointsField(points, "x");
        alignedSatBounds[1].setFromPointsField(points, "y");
        alignedSatBounds[2].setFromPointsField(points, "z");
        this.invMatrix.copy(this.matrix).invert();
        this.needsUpdate = false;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.intersectsBox = function() {
    const aabbBounds = new (0, $2OKGW.SeparatingAxisBounds)();
    return function intersectsBox(box) {
        // TODO: should this be doing SAT against the AABB?
        if (this.needsUpdate) this.update();
        const min = box.min;
        const max = box.max;
        const satBounds = this.satBounds;
        const satAxes = this.satAxes;
        const alignedSatBounds = this.alignedSatBounds;
        aabbBounds.min = min.x;
        aabbBounds.max = max.x;
        if (alignedSatBounds[0].isSeparated(aabbBounds)) return false;
        aabbBounds.min = min.y;
        aabbBounds.max = max.y;
        if (alignedSatBounds[1].isSeparated(aabbBounds)) return false;
        aabbBounds.min = min.z;
        aabbBounds.max = max.z;
        if (alignedSatBounds[2].isSeparated(aabbBounds)) return false;
        for(let i = 0; i < 3; i++){
            const axis = satAxes[i];
            const sb = satBounds[i];
            aabbBounds.setFromBox(axis, box);
            if (sb.isSeparated(aabbBounds)) return false;
        }
        return true;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.intersectsTriangle = function() {
    const saTri = new (0, $8VYkb.ExtendedTriangle)();
    const pointsArr = new Array(3);
    const cachedSatBounds = new (0, $2OKGW.SeparatingAxisBounds)();
    const cachedSatBounds2 = new (0, $2OKGW.SeparatingAxisBounds)();
    const cachedAxis = new (0, $ilwiq.Vector3)();
    return function intersectsTriangle(triangle) {
        if (this.needsUpdate) this.update();
        if (!triangle.isExtendedTriangle) {
            saTri.copy(triangle);
            saTri.update();
            triangle = saTri;
        } else if (triangle.needsUpdate) triangle.update();
        const satBounds = this.satBounds;
        const satAxes = this.satAxes;
        pointsArr[0] = triangle.a;
        pointsArr[1] = triangle.b;
        pointsArr[2] = triangle.c;
        for(let i = 0; i < 3; i++){
            const sb = satBounds[i];
            const sa = satAxes[i];
            cachedSatBounds.setFromPoints(sa, pointsArr);
            if (sb.isSeparated(cachedSatBounds)) return false;
        }
        const triSatBounds = triangle.satBounds;
        const triSatAxes = triangle.satAxes;
        const points = this.points;
        for(let i = 0; i < 3; i++){
            const sb = triSatBounds[i];
            const sa = triSatAxes[i];
            cachedSatBounds.setFromPoints(sa, points);
            if (sb.isSeparated(cachedSatBounds)) return false;
        }
        // check crossed axes
        for(let i = 0; i < 3; i++){
            const sa1 = satAxes[i];
            for(let i2 = 0; i2 < 4; i2++){
                const sa2 = triSatAxes[i2];
                cachedAxis.crossVectors(sa1, sa2);
                cachedSatBounds.setFromPoints(cachedAxis, pointsArr);
                cachedSatBounds2.setFromPoints(cachedAxis, points);
                if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
            }
        }
        return true;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.closestPointToPoint = function() {
    return function closestPointToPoint(point, target1) {
        if (this.needsUpdate) this.update();
        target1.copy(point).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix);
        return target1;
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.distanceToPoint = function() {
    const target = new (0, $ilwiq.Vector3)();
    return function distanceToPoint(point) {
        this.closestPointToPoint(point, target);
        return point.distanceTo(target);
    };
}();
$f74d70f31e44d1f9$export$4ccecd8ac6ee0e58.prototype.distanceToBox = function() {
    const xyzFields = [
        "x",
        "y",
        "z"
    ];
    const segments1 = new Array(12).fill().map(()=>new (0, $ilwiq.Line3)());
    const segments2 = new Array(12).fill().map(()=>new (0, $ilwiq.Line3)());
    const point1 = new (0, $ilwiq.Vector3)();
    const point2 = new (0, $ilwiq.Vector3)();
    // early out if we find a value below threshold
    return function distanceToBox(box, threshold = 0, target1 = null, target2 = null) {
        if (this.needsUpdate) this.update();
        if (this.intersectsBox(box)) {
            if (target1 || target2) {
                box.getCenter(point2);
                this.closestPointToPoint(point2, point1);
                box.closestPointToPoint(point1, point2);
                if (target1) target1.copy(point1);
                if (target2) target2.copy(point2);
            }
            return 0;
        }
        const threshold2 = threshold * threshold;
        const min = box.min;
        const max = box.max;
        const points = this.points;
        // iterate over every edge and compare distances
        let closestDistanceSq = Infinity;
        // check over all these points
        for(let i = 0; i < 8; i++){
            const p = points[i];
            point2.copy(p).clamp(min, max);
            const dist = p.distanceToSquared(point2);
            if (dist < closestDistanceSq) {
                closestDistanceSq = dist;
                if (target1) target1.copy(p);
                if (target2) target2.copy(point2);
                if (dist < threshold2) return Math.sqrt(dist);
            }
        }
        // generate and check all line segment distances
        let count = 0;
        for(let i = 0; i < 3; i++){
            for(let i1 = 0; i1 <= 1; i1++)for(let i2 = 0; i2 <= 1; i2++){
                const nextIndex = (i + 1) % 3;
                const nextIndex2 = (i + 2) % 3;
                // get obb line segments
                const index = i1 << nextIndex | i2 << nextIndex2;
                const index2 = 1 << i | i1 << nextIndex | i2 << nextIndex2;
                const p1 = points[index];
                const p2 = points[index2];
                const line1 = segments1[count];
                line1.set(p1, p2);
                // get aabb line segments
                const f1 = xyzFields[i];
                const f2 = xyzFields[nextIndex];
                const f3 = xyzFields[nextIndex2];
                const line2 = segments2[count];
                const start = line2.start;
                const end = line2.end;
                start[f1] = min[f1];
                start[f2] = i1 ? min[f2] : max[f2];
                start[f3] = i2 ? min[f3] : max[f2];
                end[f1] = max[f1];
                end[f2] = i1 ? min[f2] : max[f2];
                end[f3] = i2 ? min[f3] : max[f2];
                count++;
            }
        }
        // check all the other boxes point
        for(let x = 0; x <= 1; x++){
            for(let y = 0; y <= 1; y++)for(let z = 0; z <= 1; z++){
                point2.x = x ? max.x : min.x;
                point2.y = y ? max.y : min.y;
                point2.z = z ? max.z : min.z;
                this.closestPointToPoint(point2, point1);
                const dist = point2.distanceToSquared(point1);
                if (dist < closestDistanceSq) {
                    closestDistanceSq = dist;
                    if (target1) target1.copy(point1);
                    if (target2) target2.copy(point2);
                    if (dist < threshold2) return Math.sqrt(dist);
                }
            }
        }
        for(let i = 0; i < 12; i++){
            const l1 = segments1[i];
            for(let i2 = 0; i2 < 12; i2++){
                const l2 = segments2[i2];
                (0, $f56Km.closestPointsSegmentToSegment)(l1, l2, point1, point2);
                const dist = point1.distanceToSquared(point2);
                if (dist < closestDistanceSq) {
                    closestDistanceSq = dist;
                    if (target1) target1.copy(point1);
                    if (target2) target2.copy(point2);
                    if (dist < threshold2) return Math.sqrt(dist);
                }
            }
        }
        return Math.sqrt(closestDistanceSq);
    };
}();

});
parcelRegister("2OKGW", function(module, exports) {

$parcel$export(module.exports, "SeparatingAxisBounds", () => $20d478469c10be0c$export$f758e41ecdcd8e69);

var $ilwiq = parcelRequire("ilwiq");
class $20d478469c10be0c$export$f758e41ecdcd8e69 {
    constructor(){
        this.min = Infinity;
        this.max = -Infinity;
    }
    setFromPointsField(points, field) {
        let min = Infinity;
        let max = -Infinity;
        for(let i = 0, l = points.length; i < l; i++){
            const p = points[i];
            const val = p[field];
            min = val < min ? val : min;
            max = val > max ? val : max;
        }
        this.min = min;
        this.max = max;
    }
    setFromPoints(axis, points) {
        let min = Infinity;
        let max = -Infinity;
        for(let i = 0, l = points.length; i < l; i++){
            const p = points[i];
            const val = axis.dot(p);
            min = val < min ? val : min;
            max = val > max ? val : max;
        }
        this.min = min;
        this.max = max;
    }
    isSeparated(other) {
        return this.min > other.max || other.min > this.max;
    }
}
$20d478469c10be0c$export$f758e41ecdcd8e69.prototype.setFromBox = function() {
    const p = new (0, $ilwiq.Vector3)();
    return function setFromBox(axis, box) {
        const boxMin = box.min;
        const boxMax = box.max;
        let min = Infinity;
        let max = -Infinity;
        for(let x = 0; x <= 1; x++){
            for(let y = 0; y <= 1; y++)for(let z = 0; z <= 1; z++){
                p.x = boxMin.x * x + boxMax.x * (1 - x);
                p.y = boxMin.y * y + boxMax.y * (1 - y);
                p.z = boxMin.z * z + boxMax.z * (1 - z);
                const val = axis.dot(p);
                min = Math.min(val, min);
                max = Math.max(val, max);
            }
        }
        this.min = min;
        this.max = max;
    };
}();
const $20d478469c10be0c$export$e086b7be1b4d1d36 = function() {
    const cacheSatBounds = new $20d478469c10be0c$export$f758e41ecdcd8e69();
    return function areIntersecting(shape1, shape2) {
        const points1 = shape1.points;
        const satAxes1 = shape1.satAxes;
        const satBounds1 = shape1.satBounds;
        const points2 = shape2.points;
        const satAxes2 = shape2.satAxes;
        const satBounds2 = shape2.satBounds;
        // check axes of the first shape
        for(let i = 0; i < 3; i++){
            const sb = satBounds1[i];
            const sa = satAxes1[i];
            cacheSatBounds.setFromPoints(sa, points2);
            if (sb.isSeparated(cacheSatBounds)) return false;
        }
        // check axes of the second shape
        for(let i = 0; i < 3; i++){
            const sb = satBounds2[i];
            const sa = satAxes2[i];
            cacheSatBounds.setFromPoints(sa, points1);
            if (sb.isSeparated(cacheSatBounds)) return false;
        }
    };
}();

});

parcelRegister("8VYkb", function(module, exports) {

$parcel$export(module.exports, "ExtendedTriangle", () => $681270c6f2e9ebff$export$a37f7ec1c23dfacf);

var $ilwiq = parcelRequire("ilwiq");

var $2OKGW = parcelRequire("2OKGW");

var $f56Km = parcelRequire("f56Km");
const $681270c6f2e9ebff$var$ZERO_EPSILON = 1e-15;
function $681270c6f2e9ebff$var$isNearZero(value) {
    return Math.abs(value) < $681270c6f2e9ebff$var$ZERO_EPSILON;
}
class $681270c6f2e9ebff$export$a37f7ec1c23dfacf extends (0, $ilwiq.Triangle) {
    constructor(...args){
        super(...args);
        this.isExtendedTriangle = true;
        this.satAxes = new Array(4).fill().map(()=>new (0, $ilwiq.Vector3)());
        this.satBounds = new Array(4).fill().map(()=>new (0, $2OKGW.SeparatingAxisBounds)());
        this.points = [
            this.a,
            this.b,
            this.c
        ];
        this.sphere = new (0, $ilwiq.Sphere)();
        this.plane = new (0, $ilwiq.Plane)();
        this.needsUpdate = true;
    }
    intersectsSphere(sphere) {
        return (0, $f56Km.sphereIntersectTriangle)(sphere, this);
    }
    update() {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const points = this.points;
        const satAxes = this.satAxes;
        const satBounds = this.satBounds;
        const axis0 = satAxes[0];
        const sab0 = satBounds[0];
        this.getNormal(axis0);
        sab0.setFromPoints(axis0, points);
        const axis1 = satAxes[1];
        const sab1 = satBounds[1];
        axis1.subVectors(a, b);
        sab1.setFromPoints(axis1, points);
        const axis2 = satAxes[2];
        const sab2 = satBounds[2];
        axis2.subVectors(b, c);
        sab2.setFromPoints(axis2, points);
        const axis3 = satAxes[3];
        const sab3 = satBounds[3];
        axis3.subVectors(c, a);
        sab3.setFromPoints(axis3, points);
        this.sphere.setFromPoints(this.points);
        this.plane.setFromNormalAndCoplanarPoint(axis0, a);
        this.needsUpdate = false;
    }
}
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.closestPointToSegment = function() {
    const point1 = new (0, $ilwiq.Vector3)();
    const point2 = new (0, $ilwiq.Vector3)();
    const edge = new (0, $ilwiq.Line3)();
    return function distanceToSegment(segment, target1 = null, target2 = null) {
        const { start: start, end: end } = segment;
        const points = this.points;
        let distSq;
        let closestDistanceSq = Infinity;
        // check the triangle edges
        for(let i = 0; i < 3; i++){
            const nexti = (i + 1) % 3;
            edge.start.copy(points[i]);
            edge.end.copy(points[nexti]);
            (0, $f56Km.closestPointsSegmentToSegment)(edge, segment, point1, point2);
            distSq = point1.distanceToSquared(point2);
            if (distSq < closestDistanceSq) {
                closestDistanceSq = distSq;
                if (target1) target1.copy(point1);
                if (target2) target2.copy(point2);
            }
        }
        // check end points
        this.closestPointToPoint(start, point1);
        distSq = start.distanceToSquared(point1);
        if (distSq < closestDistanceSq) {
            closestDistanceSq = distSq;
            if (target1) target1.copy(point1);
            if (target2) target2.copy(start);
        }
        this.closestPointToPoint(end, point1);
        distSq = end.distanceToSquared(point1);
        if (distSq < closestDistanceSq) {
            closestDistanceSq = distSq;
            if (target1) target1.copy(point1);
            if (target2) target2.copy(end);
        }
        return Math.sqrt(closestDistanceSq);
    };
}();
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.intersectsTriangle = function() {
    const saTri2 = new $681270c6f2e9ebff$export$a37f7ec1c23dfacf();
    const arr1 = new Array(3);
    const arr2 = new Array(3);
    const cachedSatBounds = new (0, $2OKGW.SeparatingAxisBounds)();
    const cachedSatBounds2 = new (0, $2OKGW.SeparatingAxisBounds)();
    const cachedAxis = new (0, $ilwiq.Vector3)();
    const dir = new (0, $ilwiq.Vector3)();
    const dir1 = new (0, $ilwiq.Vector3)();
    const dir2 = new (0, $ilwiq.Vector3)();
    const tempDir = new (0, $ilwiq.Vector3)();
    const edge = new (0, $ilwiq.Line3)();
    const edge1 = new (0, $ilwiq.Line3)();
    const edge2 = new (0, $ilwiq.Line3)();
    const tempPoint = new (0, $ilwiq.Vector3)();
    function triIntersectPlane(tri, plane, targetEdge) {
        // find the edge that intersects the other triangle plane
        const points = tri.points;
        let count = 0;
        let startPointIntersection = -1;
        for(let i = 0; i < 3; i++){
            const { start: start, end: end } = edge;
            start.copy(points[i]);
            end.copy(points[(i + 1) % 3]);
            edge.delta(dir);
            const startIntersects = $681270c6f2e9ebff$var$isNearZero(plane.distanceToPoint(start));
            if ($681270c6f2e9ebff$var$isNearZero(plane.normal.dot(dir)) && startIntersects) {
                // if the edge lies on the plane then take the line
                targetEdge.copy(edge);
                count = 2;
                break;
            }
            // check if the start point is near the plane because "intersectLine" is not robust to that case
            const doesIntersect = plane.intersectLine(edge, tempPoint);
            if (!doesIntersect && startIntersects) tempPoint.copy(start);
            // ignore the end point
            if ((doesIntersect || startIntersects) && !$681270c6f2e9ebff$var$isNearZero(tempPoint.distanceTo(end))) {
                if (count <= 1) {
                    // assign to the start or end point and save which index was snapped to
                    // the start point if necessary
                    const point = count === 1 ? targetEdge.start : targetEdge.end;
                    point.copy(tempPoint);
                    if (startIntersects) startPointIntersection = count;
                } else if (count >= 2) {
                    // if we're here that means that there must have been one point that had
                    // snapped to the start point so replace it here
                    const point = startPointIntersection === 1 ? targetEdge.start : targetEdge.end;
                    point.copy(tempPoint);
                    count = 2;
                    break;
                }
                count++;
                if (count === 2 && startPointIntersection === -1) break;
            }
        }
        return count;
    }
    // TODO: If the triangles are coplanar and intersecting the target is nonsensical. It should at least
    // be a line contained by both triangles if not a different special case somehow represented in the return result.
    return function intersectsTriangle(other, target = null, suppressLog = false) {
        if (this.needsUpdate) this.update();
        if (!other.isExtendedTriangle) {
            saTri2.copy(other);
            saTri2.update();
            other = saTri2;
        } else if (other.needsUpdate) other.update();
        const plane1 = this.plane;
        const plane2 = other.plane;
        if (Math.abs(plane1.normal.dot(plane2.normal)) > 1.0 - 1e-10) {
            // perform separating axis intersection test only for coplanar triangles
            const satBounds1 = this.satBounds;
            const satAxes1 = this.satAxes;
            arr2[0] = other.a;
            arr2[1] = other.b;
            arr2[2] = other.c;
            for(let i = 0; i < 4; i++){
                const sb = satBounds1[i];
                const sa = satAxes1[i];
                cachedSatBounds.setFromPoints(sa, arr2);
                if (sb.isSeparated(cachedSatBounds)) return false;
            }
            const satBounds2 = other.satBounds;
            const satAxes2 = other.satAxes;
            arr1[0] = this.a;
            arr1[1] = this.b;
            arr1[2] = this.c;
            for(let i = 0; i < 4; i++){
                const sb = satBounds2[i];
                const sa = satAxes2[i];
                cachedSatBounds.setFromPoints(sa, arr1);
                if (sb.isSeparated(cachedSatBounds)) return false;
            }
            // check crossed axes
            for(let i = 0; i < 4; i++){
                const sa1 = satAxes1[i];
                for(let i2 = 0; i2 < 4; i2++){
                    const sa2 = satAxes2[i2];
                    cachedAxis.crossVectors(sa1, sa2);
                    cachedSatBounds.setFromPoints(cachedAxis, arr1);
                    cachedSatBounds2.setFromPoints(cachedAxis, arr2);
                    if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
                }
            }
            if (target) {
                // TODO find two points that intersect on the edges and make that the result
                if (!suppressLog) console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.");
                target.start.set(0, 0, 0);
                target.end.set(0, 0, 0);
            }
            return true;
        } else {
            // find the edge that intersects the other triangle plane
            const count1 = triIntersectPlane(this, plane2, edge1);
            if (count1 === 1 && other.containsPoint(edge1.end)) {
                if (target) {
                    target.start.copy(edge1.end);
                    target.end.copy(edge1.end);
                }
                return true;
            } else if (count1 !== 2) return false;
            // find the other triangles edge that intersects this plane
            const count2 = triIntersectPlane(other, plane1, edge2);
            if (count2 === 1 && this.containsPoint(edge2.end)) {
                if (target) {
                    target.start.copy(edge2.end);
                    target.end.copy(edge2.end);
                }
                return true;
            } else if (count2 !== 2) return false;
            // find swap the second edge so both lines are running the same direction
            edge1.delta(dir1);
            edge2.delta(dir2);
            if (dir1.dot(dir2) < 0) {
                let tmp = edge2.start;
                edge2.start = edge2.end;
                edge2.end = tmp;
            }
            // check if the edges are overlapping
            const s1 = edge1.start.dot(dir1);
            const e1 = edge1.end.dot(dir1);
            const s2 = edge2.start.dot(dir1);
            const e2 = edge2.end.dot(dir1);
            const separated1 = e1 < s2;
            const separated2 = s1 < e2;
            if (s1 !== e2 && s2 !== e1 && separated1 === separated2) return false;
            // assign the target output
            if (target) {
                tempDir.subVectors(edge1.start, edge2.start);
                if (tempDir.dot(dir1) > 0) target.start.copy(edge1.start);
                else target.start.copy(edge2.start);
                tempDir.subVectors(edge1.end, edge2.end);
                if (tempDir.dot(dir1) < 0) target.end.copy(edge1.end);
                else target.end.copy(edge2.end);
            }
            return true;
        }
    };
}();
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.distanceToPoint = function() {
    const target = new (0, $ilwiq.Vector3)();
    return function distanceToPoint(point) {
        this.closestPointToPoint(point, target);
        return point.distanceTo(target);
    };
}();
$681270c6f2e9ebff$export$a37f7ec1c23dfacf.prototype.distanceToTriangle = function() {
    const point = new (0, $ilwiq.Vector3)();
    const point2 = new (0, $ilwiq.Vector3)();
    const cornerFields = [
        "a",
        "b",
        "c"
    ];
    const line1 = new (0, $ilwiq.Line3)();
    const line2 = new (0, $ilwiq.Line3)();
    return function distanceToTriangle(other, target1 = null, target2 = null) {
        const lineTarget = target1 || target2 ? line1 : null;
        if (this.intersectsTriangle(other, lineTarget)) {
            if (target1 || target2) {
                if (target1) lineTarget.getCenter(target1);
                if (target2) lineTarget.getCenter(target2);
            }
            return 0;
        }
        let closestDistanceSq = Infinity;
        // check all point distances
        for(let i = 0; i < 3; i++){
            let dist;
            const field = cornerFields[i];
            const otherVec = other[field];
            this.closestPointToPoint(otherVec, point);
            dist = otherVec.distanceToSquared(point);
            if (dist < closestDistanceSq) {
                closestDistanceSq = dist;
                if (target1) target1.copy(point);
                if (target2) target2.copy(otherVec);
            }
            const thisVec = this[field];
            other.closestPointToPoint(thisVec, point);
            dist = thisVec.distanceToSquared(point);
            if (dist < closestDistanceSq) {
                closestDistanceSq = dist;
                if (target1) target1.copy(thisVec);
                if (target2) target2.copy(point);
            }
        }
        for(let i = 0; i < 3; i++){
            const f11 = cornerFields[i];
            const f12 = cornerFields[(i + 1) % 3];
            line1.set(this[f11], this[f12]);
            for(let i2 = 0; i2 < 3; i2++){
                const f21 = cornerFields[i2];
                const f22 = cornerFields[(i2 + 1) % 3];
                line2.set(other[f21], other[f22]);
                (0, $f56Km.closestPointsSegmentToSegment)(line1, line2, point, point2);
                const dist = point.distanceToSquared(point2);
                if (dist < closestDistanceSq) {
                    closestDistanceSq = dist;
                    if (target1) target1.copy(point);
                    if (target2) target2.copy(point2);
                }
            }
        }
        return Math.sqrt(closestDistanceSq);
    };
}();

});
parcelRegister("f56Km", function(module, exports) {

$parcel$export(module.exports, "closestPointsSegmentToSegment", () => $afac8e64b68760a8$export$b09f296caca7547a);
$parcel$export(module.exports, "sphereIntersectTriangle", () => $afac8e64b68760a8$export$eed3a6606b3adc41);

var $ilwiq = parcelRequire("ilwiq");
const $afac8e64b68760a8$export$479eef7c8f1b846c = function() {
    // https://github.com/juj/MathGeoLib/blob/master/src/Geometry/Line.cpp#L56
    const dir1 = new (0, $ilwiq.Vector3)();
    const dir2 = new (0, $ilwiq.Vector3)();
    const v02 = new (0, $ilwiq.Vector3)();
    return function closestPointLineToLine(l1, l2, result) {
        const v0 = l1.start;
        const v10 = dir1;
        const v2 = l2.start;
        const v32 = dir2;
        v02.subVectors(v0, v2);
        dir1.subVectors(l1.end, l1.start);
        dir2.subVectors(l2.end, l2.start);
        // float d0232 = v02.Dot(v32);
        const d0232 = v02.dot(v32);
        // float d3210 = v32.Dot(v10);
        const d3210 = v32.dot(v10);
        // float d3232 = v32.Dot(v32);
        const d3232 = v32.dot(v32);
        // float d0210 = v02.Dot(v10);
        const d0210 = v02.dot(v10);
        // float d1010 = v10.Dot(v10);
        const d1010 = v10.dot(v10);
        // float denom = d1010*d3232 - d3210*d3210;
        const denom = d1010 * d3232 - d3210 * d3210;
        let d, d2;
        if (denom !== 0) d = (d0232 * d3210 - d0210 * d3232) / denom;
        else d = 0;
        d2 = (d0232 + d * d3210) / d3232;
        result.x = d;
        result.y = d2;
    };
}();
const $afac8e64b68760a8$export$b09f296caca7547a = function() {
    // https://github.com/juj/MathGeoLib/blob/master/src/Geometry/LineSegment.cpp#L187
    const paramResult = new (0, $ilwiq.Vector2)();
    const temp1 = new (0, $ilwiq.Vector3)();
    const temp2 = new (0, $ilwiq.Vector3)();
    return function closestPointsSegmentToSegment(l1, l2, target1, target2) {
        $afac8e64b68760a8$export$479eef7c8f1b846c(l1, l2, paramResult);
        let d = paramResult.x;
        let d2 = paramResult.y;
        if (d >= 0 && d <= 1 && d2 >= 0 && d2 <= 1) {
            l1.at(d, target1);
            l2.at(d2, target2);
            return;
        } else if (d >= 0 && d <= 1) {
            // Only d2 is out of bounds.
            if (d2 < 0) l2.at(0, target2);
            else l2.at(1, target2);
            l1.closestPointToPoint(target2, true, target1);
            return;
        } else if (d2 >= 0 && d2 <= 1) {
            // Only d is out of bounds.
            if (d < 0) l1.at(0, target1);
            else l1.at(1, target1);
            l2.closestPointToPoint(target1, true, target2);
            return;
        } else {
            // Both u and u2 are out of bounds.
            let p;
            if (d < 0) p = l1.start;
            else p = l1.end;
            let p2;
            if (d2 < 0) p2 = l2.start;
            else p2 = l2.end;
            const closestPoint = temp1;
            const closestPoint2 = temp2;
            l1.closestPointToPoint(p2, true, temp1);
            l2.closestPointToPoint(p, true, temp2);
            if (closestPoint.distanceToSquared(p2) <= closestPoint2.distanceToSquared(p)) {
                target1.copy(closestPoint);
                target2.copy(p2);
                return;
            } else {
                target1.copy(p);
                target2.copy(closestPoint2);
                return;
            }
        }
    };
}();
const $afac8e64b68760a8$export$eed3a6606b3adc41 = function() {
    // https://stackoverflow.com/questions/34043955/detect-collision-between-sphere-and-triangle-in-three-js
    const closestPointTemp = new (0, $ilwiq.Vector3)();
    const projectedPointTemp = new (0, $ilwiq.Vector3)();
    const planeTemp = new (0, $ilwiq.Plane)();
    const lineTemp = new (0, $ilwiq.Line3)();
    return function sphereIntersectTriangle(sphere, triangle) {
        const { radius: radius, center: center } = sphere;
        const { a: a, b: b, c: c } = triangle;
        // phase 1
        lineTemp.start = a;
        lineTemp.end = b;
        const closestPoint1 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
        if (closestPoint1.distanceTo(center) <= radius) return true;
        lineTemp.start = a;
        lineTemp.end = c;
        const closestPoint2 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
        if (closestPoint2.distanceTo(center) <= radius) return true;
        lineTemp.start = b;
        lineTemp.end = c;
        const closestPoint3 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
        if (closestPoint3.distanceTo(center) <= radius) return true;
        // phase 2
        const plane = triangle.getPlane(planeTemp);
        const dp = Math.abs(plane.distanceToPoint(center));
        if (dp <= radius) {
            const pp = plane.projectPoint(center, projectedPointTemp);
            const cp = triangle.containsPoint(pp);
            if (cp) return true;
        }
        return false;
    };
}();

});



parcelRegister("7EZfU", function(module, exports) {

$parcel$export(module.exports, "ExtendedTrianglePool", () => $593bc8ef8d1a55fc$export$2622f4315304edad);

var $8VYkb = parcelRequire("8VYkb");

var $1l8b2 = parcelRequire("1l8b2");
class $593bc8ef8d1a55fc$var$ExtendedTrianglePoolBase extends (0, $1l8b2.PrimitivePool) {
    constructor(){
        super(()=>new (0, $8VYkb.ExtendedTriangle)());
    }
}
const $593bc8ef8d1a55fc$export$2622f4315304edad = /* @__PURE__ */ new $593bc8ef8d1a55fc$var$ExtendedTrianglePoolBase();

});
parcelRegister("1l8b2", function(module, exports) {

$parcel$export(module.exports, "PrimitivePool", () => $0f9e1864656e7fae$export$bf300c504651112a);
class $0f9e1864656e7fae$export$bf300c504651112a {
    constructor(getNewPrimitive){
        this._getNewPrimitive = getNewPrimitive;
        this._primitives = [];
    }
    getPrimitive() {
        const primitives = this._primitives;
        if (primitives.length === 0) return this._getNewPrimitive();
        else return primitives.pop();
    }
    releasePrimitive(primitive) {
        this._primitives.push(primitive);
    }
}

});


parcelRegister("8hs00", function(module, exports) {

$parcel$export(module.exports, "shapecast", () => $6075a1513b66f4c0$export$963c78622ed2c172);

var $ilwiq = parcelRequire("ilwiq");

var $alNGj = parcelRequire("alNGj");

var $eADNI = parcelRequire("eADNI");

var $1l8b2 = parcelRequire("1l8b2");

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");
let $6075a1513b66f4c0$var$_box1, $6075a1513b66f4c0$var$_box2;
const $6075a1513b66f4c0$var$boxStack = [];
const $6075a1513b66f4c0$var$boxPool = /* @__PURE__ */ new (0, $1l8b2.PrimitivePool)(()=>new (0, $ilwiq.Box3)());
function $6075a1513b66f4c0$export$963c78622ed2c172(bvh, root, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset) {
    // setup
    $6075a1513b66f4c0$var$_box1 = $6075a1513b66f4c0$var$boxPool.getPrimitive();
    $6075a1513b66f4c0$var$_box2 = $6075a1513b66f4c0$var$boxPool.getPrimitive();
    $6075a1513b66f4c0$var$boxStack.push($6075a1513b66f4c0$var$_box1, $6075a1513b66f4c0$var$_box2);
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    const result = $6075a1513b66f4c0$var$shapecastTraverse(0, bvh.geometry, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
    // cleanup
    (0, $xqrrD.BufferStack).clearBuffer();
    $6075a1513b66f4c0$var$boxPool.releasePrimitive($6075a1513b66f4c0$var$_box1);
    $6075a1513b66f4c0$var$boxPool.releasePrimitive($6075a1513b66f4c0$var$_box2);
    $6075a1513b66f4c0$var$boxStack.pop();
    $6075a1513b66f4c0$var$boxStack.pop();
    const length = $6075a1513b66f4c0$var$boxStack.length;
    if (length > 0) {
        $6075a1513b66f4c0$var$_box2 = $6075a1513b66f4c0$var$boxStack[length - 1];
        $6075a1513b66f4c0$var$_box1 = $6075a1513b66f4c0$var$boxStack[length - 2];
    }
    return result;
}
function $6075a1513b66f4c0$var$shapecastTraverse(nodeIndex32, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc = null, nodeIndexByteOffset = 0, depth = 0) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    let nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(nodeIndex32), float32Array, $6075a1513b66f4c0$var$_box1);
        return intersectsRangeFunc(offset, count, false, depth, nodeIndexByteOffset + nodeIndex32, $6075a1513b66f4c0$var$_box1);
    } else {
        const left = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
        const right = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
        let c1 = left;
        let c2 = right;
        let score1, score2;
        let box1, box2;
        if (nodeScoreFunc) {
            box1 = $6075a1513b66f4c0$var$_box1;
            box2 = $6075a1513b66f4c0$var$_box2;
            // bounding data is not offset
            (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(c1), float32Array, box1);
            (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(c2), float32Array, box2);
            score1 = nodeScoreFunc(box1);
            score2 = nodeScoreFunc(box2);
            if (score2 < score1) {
                c1 = right;
                c2 = left;
                const temp = score1;
                score1 = score2;
                score2 = temp;
                box1 = box2;
            // box2 is always set before use below
            }
        }
        // Check box 1 intersection
        if (!box1) {
            box1 = $6075a1513b66f4c0$var$_box1;
            (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(c1), float32Array, box1);
        }
        const isC1Leaf = (0, $8x2iv.IS_LEAF)(c1 * 2, uint16Array);
        const c1Intersection = intersectsBoundsFunc(box1, isC1Leaf, score1, depth + 1, nodeIndexByteOffset + c1);
        let c1StopTraversal;
        if (c1Intersection === (0, $alNGj.CONTAINED)) {
            const offset = getLeftOffset(c1);
            const end = getRightEndOffset(c1);
            const count = end - offset;
            c1StopTraversal = intersectsRangeFunc(offset, count, true, depth + 1, nodeIndexByteOffset + c1, box1);
        } else c1StopTraversal = c1Intersection && $6075a1513b66f4c0$var$shapecastTraverse(c1, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc, nodeIndexByteOffset, depth + 1);
        if (c1StopTraversal) return true;
        // Check box 2 intersection
        // cached box2 will have been overwritten by previous traversal
        box2 = $6075a1513b66f4c0$var$_box2;
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(c2), float32Array, box2);
        const isC2Leaf = (0, $8x2iv.IS_LEAF)(c2 * 2, uint16Array);
        const c2Intersection = intersectsBoundsFunc(box2, isC2Leaf, score2, depth + 1, nodeIndexByteOffset + c2);
        let c2StopTraversal;
        if (c2Intersection === (0, $alNGj.CONTAINED)) {
            const offset = getLeftOffset(c2);
            const end = getRightEndOffset(c2);
            const count = end - offset;
            c2StopTraversal = intersectsRangeFunc(offset, count, true, depth + 1, nodeIndexByteOffset + c2, box2);
        } else c2StopTraversal = c2Intersection && $6075a1513b66f4c0$var$shapecastTraverse(c2, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc, nodeIndexByteOffset, depth + 1);
        if (c2StopTraversal) return true;
        return false;
        // Define these inside the function so it has access to the local variables needed
        // when converting to the buffer equivalents
        function getLeftOffset(nodeIndex32) {
            const { uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
            let nodeIndex16 = nodeIndex32 * 2;
            // traverse until we find a leaf
            while(!(0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array)){
                nodeIndex32 = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
                nodeIndex16 = nodeIndex32 * 2;
            }
            return (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        }
        function getRightEndOffset(nodeIndex32) {
            const { uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
            let nodeIndex16 = nodeIndex32 * 2;
            // traverse until we find a leaf
            while(!(0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array)){
                // adjust offset to point to the right node
                nodeIndex32 = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
                nodeIndex16 = nodeIndex32 * 2;
            }
            // return the end offset of the triangle range
            return (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array) + (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        }
    }
}

});
parcelRegister("xqrrD", function(module, exports) {

$parcel$export(module.exports, "BufferStack", () => $064797f1cfb48450$export$7451c73ce907854f);
class $064797f1cfb48450$var$_BufferStack {
    constructor(){
        this.float32Array = null;
        this.uint16Array = null;
        this.uint32Array = null;
        const stack = [];
        let prevBuffer = null;
        this.setBuffer = (buffer)=>{
            if (prevBuffer) stack.push(prevBuffer);
            prevBuffer = buffer;
            this.float32Array = new Float32Array(buffer);
            this.uint16Array = new Uint16Array(buffer);
            this.uint32Array = new Uint32Array(buffer);
        };
        this.clearBuffer = ()=>{
            prevBuffer = null;
            this.float32Array = null;
            this.uint16Array = null;
            this.uint32Array = null;
            if (stack.length !== 0) this.setBuffer(stack.pop());
        };
    }
}
const $064797f1cfb48450$export$7451c73ce907854f = new $064797f1cfb48450$var$_BufferStack();

});


parcelRegister("8VlEg", function(module, exports) {

$parcel$export(module.exports, "closestPointToPoint", () => $67f4708097c33efc$export$96ec44700e587d99);

var $ilwiq = parcelRequire("ilwiq");
const $67f4708097c33efc$var$temp = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $67f4708097c33efc$var$temp1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $67f4708097c33efc$export$96ec44700e587d99(bvh, point, target = {}, minThreshold = 0, maxThreshold = Infinity) {
    // early out if under minThreshold
    // skip checking if over maxThreshold
    // set minThreshold = maxThreshold to quickly check if a point is within a threshold
    // returns Infinity if no value found
    const minThresholdSq = minThreshold * minThreshold;
    const maxThresholdSq = maxThreshold * maxThreshold;
    let closestDistanceSq = Infinity;
    let closestDistanceTriIndex = null;
    bvh.shapecast({
        boundsTraverseOrder: (box)=>{
            $67f4708097c33efc$var$temp.copy(point).clamp(box.min, box.max);
            return $67f4708097c33efc$var$temp.distanceToSquared(point);
        },
        intersectsBounds: (box, isLeaf, score)=>{
            return score < closestDistanceSq && score < maxThresholdSq;
        },
        intersectsTriangle: (tri, triIndex)=>{
            tri.closestPointToPoint(point, $67f4708097c33efc$var$temp);
            const distSq = point.distanceToSquared($67f4708097c33efc$var$temp);
            if (distSq < closestDistanceSq) {
                $67f4708097c33efc$var$temp1.copy($67f4708097c33efc$var$temp);
                closestDistanceSq = distSq;
                closestDistanceTriIndex = triIndex;
            }
            if (distSq < minThresholdSq) return true;
            else return false;
        }
    });
    if (closestDistanceSq === Infinity) return null;
    const closestDistance = Math.sqrt(closestDistanceSq);
    if (!target.point) target.point = $67f4708097c33efc$var$temp1.clone();
    else target.point.copy($67f4708097c33efc$var$temp1);
    target.distance = closestDistance, target.faceIndex = closestDistanceTriIndex;
    return target;
}

});

parcelRegister("9Kyri", function(module, exports) {

$parcel$export(module.exports, "intersectTris", () => $01d4f4206273ed95$export$6f0a8fc5d2775a51);
$parcel$export(module.exports, "intersectClosestTri", () => $01d4f4206273ed95$export$4331f2604b0bca4);
$parcel$export(module.exports, "iterateOverTriangles", () => $01d4f4206273ed95$export$be1391b7aa79c0f6);

var $7pS02 = parcelRequire("7pS02");

var $dRxiJ = parcelRequire("dRxiJ");
/*************************************************************/ /* This file is generated from "iterationUtils.template.js". */ /*************************************************************/ /* eslint-disable indent */ function $01d4f4206273ed95$export$6f0a8fc5d2775a51(bvh, side, ray, offset, count, intersections) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    for(let i = offset, end = offset + count; i < end; i++)(0, $7pS02.intersectTri)(geometry, side, ray, i, intersections);
}
function $01d4f4206273ed95$export$4331f2604b0bca4(bvh, side, ray, offset, count) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    let dist = Infinity;
    let res = null;
    for(let i = offset, end = offset + count; i < end; i++){
        let intersection;
        intersection = (0, $7pS02.intersectTri)(geometry, side, ray, i);
        if (intersection && intersection.distance < dist) {
            res = intersection;
            dist = intersection.distance;
        }
    }
    return res;
}
function $01d4f4206273ed95$export$be1391b7aa79c0f6(offset, count, bvh, intersectsTriangleFunc, contained, depth, triangle) {
    const { geometry: geometry } = bvh;
    const { index: index } = geometry;
    const pos = geometry.attributes.position;
    for(let i = offset, l = count + offset; i < l; i++){
        let tri;
        tri = i;
        (0, $dRxiJ.setTriangle)(triangle, tri * 3, index, pos);
        triangle.needsUpdate = true;
        if (intersectsTriangleFunc(triangle, tri, contained, depth)) return true;
    }
    return false;
}

});
parcelRegister("7pS02", function(module, exports) {

$parcel$export(module.exports, "intersectTri", () => $5664c169f49816c4$export$1a557053019a130b);

var $ilwiq = parcelRequire("ilwiq");
// Ripped and modified From THREE.js Mesh raycast
// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L115
const $5664c169f49816c4$var$_vA = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_vB = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_vC = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_uvA = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $5664c169f49816c4$var$_uvB = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $5664c169f49816c4$var$_uvC = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $5664c169f49816c4$var$_normalA = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_normalB = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_normalC = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $5664c169f49816c4$var$_intersectionPoint = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $5664c169f49816c4$var$checkIntersection(ray, pA, pB, pC, point, side) {
    let intersect;
    if (side === (0, $ilwiq.BackSide)) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, side !== (0, $ilwiq.DoubleSide), point);
    if (intersect === null) return null;
    const distance = ray.origin.distanceTo(point);
    return {
        distance: distance,
        point: point.clone()
    };
}
function $5664c169f49816c4$var$checkBufferGeometryIntersection(ray, position, normal, uv, uv1, a, b, c, side) {
    $5664c169f49816c4$var$_vA.fromBufferAttribute(position, a);
    $5664c169f49816c4$var$_vB.fromBufferAttribute(position, b);
    $5664c169f49816c4$var$_vC.fromBufferAttribute(position, c);
    const intersection = $5664c169f49816c4$var$checkIntersection(ray, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_intersectionPoint, side);
    if (intersection) {
        if (uv) {
            $5664c169f49816c4$var$_uvA.fromBufferAttribute(uv, a);
            $5664c169f49816c4$var$_uvB.fromBufferAttribute(uv, b);
            $5664c169f49816c4$var$_uvC.fromBufferAttribute(uv, c);
            intersection.uv = (0, $ilwiq.Triangle).getInterpolation($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_uvA, $5664c169f49816c4$var$_uvB, $5664c169f49816c4$var$_uvC, new (0, $ilwiq.Vector2)());
        }
        if (uv1) {
            $5664c169f49816c4$var$_uvA.fromBufferAttribute(uv1, a);
            $5664c169f49816c4$var$_uvB.fromBufferAttribute(uv1, b);
            $5664c169f49816c4$var$_uvC.fromBufferAttribute(uv1, c);
            intersection.uv1 = (0, $ilwiq.Triangle).getInterpolation($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_uvA, $5664c169f49816c4$var$_uvB, $5664c169f49816c4$var$_uvC, new (0, $ilwiq.Vector2)());
        }
        if (normal) {
            $5664c169f49816c4$var$_normalA.fromBufferAttribute(normal, a);
            $5664c169f49816c4$var$_normalB.fromBufferAttribute(normal, b);
            $5664c169f49816c4$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = (0, $ilwiq.Triangle).getInterpolation($5664c169f49816c4$var$_intersectionPoint, $5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, $5664c169f49816c4$var$_normalA, $5664c169f49816c4$var$_normalB, $5664c169f49816c4$var$_normalC, new (0, $ilwiq.Vector3)());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new (0, $ilwiq.Vector3)(),
            materialIndex: 0
        };
        (0, $ilwiq.Triangle).getNormal($5664c169f49816c4$var$_vA, $5664c169f49816c4$var$_vB, $5664c169f49816c4$var$_vC, face.normal);
        intersection.face = face;
        intersection.faceIndex = a;
    }
    return intersection;
}
// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L258
function $5664c169f49816c4$export$1a557053019a130b(geo, side, ray, tri, intersections) {
    const triOffset = tri * 3;
    let a = triOffset + 0;
    let b = triOffset + 1;
    let c = triOffset + 2;
    const index = geo.index;
    if (geo.index) {
        a = index.getX(a);
        b = index.getX(b);
        c = index.getX(c);
    }
    const { position: position, normal: normal, uv: uv, uv1: uv1 } = geo.attributes;
    const intersection = $5664c169f49816c4$var$checkBufferGeometryIntersection(ray, position, normal, uv, uv1, a, b, c, side);
    if (intersection) {
        intersection.faceIndex = tri;
        if (intersections) intersections.push(intersection);
        return intersection;
    }
    return null;
}

});

parcelRegister("dRxiJ", function(module, exports) {

$parcel$export(module.exports, "setTriangle", () => $a17a0e7ef0b826e6$export$32f7fa781964ae30);

var $ilwiq = parcelRequire("ilwiq");
function $a17a0e7ef0b826e6$export$32f7fa781964ae30(tri, i, index, pos) {
    const ta = tri.a;
    const tb = tri.b;
    const tc = tri.c;
    let i0 = i;
    let i1 = i + 1;
    let i2 = i + 2;
    if (index) {
        i0 = index.getX(i0);
        i1 = index.getX(i1);
        i2 = index.getX(i2);
    }
    ta.x = pos.getX(i0);
    ta.y = pos.getY(i0);
    ta.z = pos.getZ(i0);
    tb.x = pos.getX(i1);
    tb.y = pos.getY(i1);
    tb.z = pos.getZ(i1);
    tc.x = pos.getX(i2);
    tc.y = pos.getY(i2);
    tc.z = pos.getZ(i2);
}
const $a17a0e7ef0b826e6$var$tempV1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $a17a0e7ef0b826e6$var$tempV2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $a17a0e7ef0b826e6$var$tempV3 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $a17a0e7ef0b826e6$var$tempUV1 = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $a17a0e7ef0b826e6$var$tempUV2 = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
const $a17a0e7ef0b826e6$var$tempUV3 = /* @__PURE__ */ new (0, $ilwiq.Vector2)();
function $a17a0e7ef0b826e6$export$d3cf03f2575167ef(point, geometry, triangleIndex, target) {
    const indices = geometry.getIndex().array;
    const positions = geometry.getAttribute("position");
    const uvs = geometry.getAttribute("uv");
    const a = indices[triangleIndex * 3];
    const b = indices[triangleIndex * 3 + 1];
    const c = indices[triangleIndex * 3 + 2];
    $a17a0e7ef0b826e6$var$tempV1.fromBufferAttribute(positions, a);
    $a17a0e7ef0b826e6$var$tempV2.fromBufferAttribute(positions, b);
    $a17a0e7ef0b826e6$var$tempV3.fromBufferAttribute(positions, c);
    // find the associated material index
    let materialIndex = 0;
    const groups = geometry.groups;
    const firstVertexIndex = triangleIndex * 3;
    for(let i = 0, l = groups.length; i < l; i++){
        const group = groups[i];
        const { start: start, count: count } = group;
        if (firstVertexIndex >= start && firstVertexIndex < start + count) {
            materialIndex = group.materialIndex;
            break;
        }
    }
    // extract uvs
    let uv = null;
    if (uvs) {
        $a17a0e7ef0b826e6$var$tempUV1.fromBufferAttribute(uvs, a);
        $a17a0e7ef0b826e6$var$tempUV2.fromBufferAttribute(uvs, b);
        $a17a0e7ef0b826e6$var$tempUV3.fromBufferAttribute(uvs, c);
        if (target && target.uv) uv = target.uv;
        else uv = new (0, $ilwiq.Vector2)();
        (0, $ilwiq.Triangle).getInterpolation(point, $a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, $a17a0e7ef0b826e6$var$tempUV1, $a17a0e7ef0b826e6$var$tempUV2, $a17a0e7ef0b826e6$var$tempUV3, uv);
    }
    // adjust the provided target or create a new one
    if (target) {
        if (!target.face) target.face = {};
        target.face.a = a;
        target.face.b = b;
        target.face.c = c;
        target.face.materialIndex = materialIndex;
        if (!target.face.normal) target.face.normal = new (0, $ilwiq.Vector3)();
        (0, $ilwiq.Triangle).getNormal($a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, target.face.normal);
        if (uv) target.uv = uv;
        return target;
    } else return {
        face: {
            a: a,
            b: b,
            c: c,
            materialIndex: materialIndex,
            normal: (0, $ilwiq.Triangle).getNormal($a17a0e7ef0b826e6$var$tempV1, $a17a0e7ef0b826e6$var$tempV2, $a17a0e7ef0b826e6$var$tempV3, new (0, $ilwiq.Vector3)())
        },
        uv: uv
    };
}

});


parcelRegister("ayHng", function(module, exports) {

$parcel$export(module.exports, "refit", () => $7afeb992771d32d5$export$8eb1eda96b2e6d7a);

var $alNGj = parcelRequire("alNGj");
/****************************************************/ /* This file is generated from "refit.template.js". */ /****************************************************/ function $7afeb992771d32d5$export$8eb1eda96b2e6d7a(bvh, nodeIndices = null) {
    if (nodeIndices && Array.isArray(nodeIndices)) nodeIndices = new Set(nodeIndices);
    const geometry = bvh.geometry;
    const indexArr = geometry.index ? geometry.index.array : null;
    const posAttr = geometry.attributes.position;
    let buffer, uint32Array, uint16Array, float32Array;
    let byteOffset = 0;
    const roots = bvh._roots;
    for(let i = 0, l = roots.length; i < l; i++){
        buffer = roots[i];
        uint32Array = new Uint32Array(buffer);
        uint16Array = new Uint16Array(buffer);
        float32Array = new Float32Array(buffer);
        _traverse(0, byteOffset);
        byteOffset += buffer.byteLength;
    }
    function _traverse(node32Index, byteOffset, force = false) {
        const node16Index = node32Index * 2;
        const isLeaf = uint16Array[node16Index + 15] === (0, $alNGj.IS_LEAFNODE_FLAG);
        if (isLeaf) {
            const offset = uint32Array[node32Index + 6];
            const count = uint16Array[node16Index + 14];
            let minx = Infinity;
            let miny = Infinity;
            let minz = Infinity;
            let maxx = -Infinity;
            let maxy = -Infinity;
            let maxz = -Infinity;
            for(let i = 3 * offset, l = 3 * (offset + count); i < l; i++){
                let index = indexArr[i];
                const x = posAttr.getX(index);
                const y = posAttr.getY(index);
                const z = posAttr.getZ(index);
                if (x < minx) minx = x;
                if (x > maxx) maxx = x;
                if (y < miny) miny = y;
                if (y > maxy) maxy = y;
                if (z < minz) minz = z;
                if (z > maxz) maxz = z;
            }
            if (float32Array[node32Index + 0] !== minx || float32Array[node32Index + 1] !== miny || float32Array[node32Index + 2] !== minz || float32Array[node32Index + 3] !== maxx || float32Array[node32Index + 4] !== maxy || float32Array[node32Index + 5] !== maxz) {
                float32Array[node32Index + 0] = minx;
                float32Array[node32Index + 1] = miny;
                float32Array[node32Index + 2] = minz;
                float32Array[node32Index + 3] = maxx;
                float32Array[node32Index + 4] = maxy;
                float32Array[node32Index + 5] = maxz;
                return true;
            } else return false;
        } else {
            const left = node32Index + 8;
            const right = uint32Array[node32Index + 6];
            // the identifying node indices provided by the shapecast function include offsets of all
            // root buffers to guarantee they're unique between roots so offset left and right indices here.
            const offsetLeft = left + byteOffset;
            const offsetRight = right + byteOffset;
            let forceChildren = force;
            let includesLeft = false;
            let includesRight = false;
            if (nodeIndices) // if we see that neither the left or right child are included in the set that need to be updated
            // then we assume that all children need to be updated.
            {
                if (!forceChildren) {
                    includesLeft = nodeIndices.has(offsetLeft);
                    includesRight = nodeIndices.has(offsetRight);
                    forceChildren = !includesLeft && !includesRight;
                }
            } else {
                includesLeft = true;
                includesRight = true;
            }
            const traverseLeft = forceChildren || includesLeft;
            const traverseRight = forceChildren || includesRight;
            let leftChange = false;
            if (traverseLeft) leftChange = _traverse(left, byteOffset, forceChildren);
            let rightChange = false;
            if (traverseRight) rightChange = _traverse(right, byteOffset, forceChildren);
            const didChange = leftChange || rightChange;
            if (didChange) for(let i = 0; i < 3; i++){
                const lefti = left + i;
                const righti = right + i;
                const minLeftValue = float32Array[lefti];
                const maxLeftValue = float32Array[lefti + 3];
                const minRightValue = float32Array[righti];
                const maxRightValue = float32Array[righti + 3];
                float32Array[node32Index + i] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
                float32Array[node32Index + i + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
            }
            return didChange;
        }
    }
}

});

parcelRegister("laUNa", function(module, exports) {

$parcel$export(module.exports, "raycast", () => $f6a695dbb681b4c5$export$630e89aab3ddc1d6);

var $d4vta = parcelRequire("d4vta");

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");

var $9Kyri = parcelRequire("9Kyri");

/******************************************************/ /* This file is generated from "raycast.template.js". */ /******************************************************/ function $f6a695dbb681b4c5$export$630e89aab3ddc1d6(bvh, root, side, ray, intersects) {
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    $f6a695dbb681b4c5$var$_raycast(0, bvh, side, ray, intersects);
    (0, $xqrrD.BufferStack).clearBuffer();
}
function $f6a695dbb681b4c5$var$_raycast(nodeIndex32, bvh, side, ray, intersects) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    const nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        (0, $9Kyri.intersectTris)(bvh, side, ray, offset, count, intersects);
    } else {
        const leftIndex = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
        if ((0, $d4vta.intersectRay)(leftIndex, float32Array, ray)) $f6a695dbb681b4c5$var$_raycast(leftIndex, bvh, side, ray, intersects);
        const rightIndex = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
        if ((0, $d4vta.intersectRay)(rightIndex, float32Array, ray)) $f6a695dbb681b4c5$var$_raycast(rightIndex, bvh, side, ray, intersects);
    }
}

});
parcelRegister("d4vta", function(module, exports) {

$parcel$export(module.exports, "intersectRay", () => $98440f459aa220f3$export$d5a069a08bb68982);
/**
 * This function performs intersection tests similar to Ray.intersectBox in three.js,
 * with the difference that the box values are read from an array to improve performance.
 */ function $98440f459aa220f3$export$d5a069a08bb68982(nodeIndex32, array, ray) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / ray.direction.x, invdiry = 1 / ray.direction.y, invdirz = 1 / ray.direction.z;
    const ox = ray.origin.x;
    const oy = ray.origin.y;
    const oz = ray.origin.z;
    let minx = array[nodeIndex32];
    let maxx = array[nodeIndex32 + 3];
    let miny = array[nodeIndex32 + 1];
    let maxy = array[nodeIndex32 + 3 + 1];
    let minz = array[nodeIndex32 + 2];
    let maxz = array[nodeIndex32 + 3 + 2];
    if (invdirx >= 0) {
        tmin = (minx - ox) * invdirx;
        tmax = (maxx - ox) * invdirx;
    } else {
        tmin = (maxx - ox) * invdirx;
        tmax = (minx - ox) * invdirx;
    }
    if (invdiry >= 0) {
        tymin = (miny - oy) * invdiry;
        tymax = (maxy - oy) * invdiry;
    } else {
        tymin = (maxy - oy) * invdiry;
        tymax = (miny - oy) * invdiry;
    }
    if (tmin > tymax || tymin > tmax) return false;
    if (tymin > tmin || isNaN(tmin)) tmin = tymin;
    if (tymax < tmax || isNaN(tmax)) tmax = tymax;
    if (invdirz >= 0) {
        tzmin = (minz - oz) * invdirz;
        tzmax = (maxz - oz) * invdirz;
    } else {
        tzmin = (maxz - oz) * invdirz;
        tzmax = (minz - oz) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax) return false;
    // if ( tzmin > tmin || tmin !== tmin ) tmin = tzmin; // Uncomment this line if add the distance check
    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
    //return point closest to the ray (positive side)
    if (tmax < 0) return false;
    return true;
}

});


parcelRegister("1SnJR", function(module, exports) {

$parcel$export(module.exports, "raycastFirst", () => $15dd3f9915d1b1ff$export$1fa457bc72ef1a2a);

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");

var $d4vta = parcelRequire("d4vta");

var $9Kyri = parcelRequire("9Kyri");

/***********************************************************/ /* This file is generated from "raycastFirst.template.js". */ /***********************************************************/ const $15dd3f9915d1b1ff$var$_xyzFields = [
    "x",
    "y",
    "z"
];
function $15dd3f9915d1b1ff$export$1fa457bc72ef1a2a(bvh, root, side, ray) {
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    const result = $15dd3f9915d1b1ff$var$_raycastFirst(0, bvh, side, ray);
    (0, $xqrrD.BufferStack).clearBuffer();
    return result;
}
function $15dd3f9915d1b1ff$var$_raycastFirst(nodeIndex32, bvh, side, ray) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    let nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        return (0, $9Kyri.intersectClosestTri)(bvh, side, ray, offset, count);
    } else {
        // consider the position of the split plane with respect to the oncoming ray; whichever direction
        // the ray is coming from, look for an intersection among that side of the tree first
        const splitAxis = (0, $8x2iv.SPLIT_AXIS)(nodeIndex32, uint32Array);
        const xyzAxis = $15dd3f9915d1b1ff$var$_xyzFields[splitAxis];
        const rayDir = ray.direction[xyzAxis];
        const leftToRight = rayDir >= 0;
        // c1 is the child to check first
        let c1, c2;
        if (leftToRight) {
            c1 = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
            c2 = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
        } else {
            c1 = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
            c2 = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
        }
        const c1Intersection = (0, $d4vta.intersectRay)(c1, float32Array, ray);
        const c1Result = c1Intersection ? $15dd3f9915d1b1ff$var$_raycastFirst(c1, bvh, side, ray) : null;
        // if we got an intersection in the first node and it's closer than the second node's bounding
        // box, we don't need to consider the second node because it couldn't possibly be a better result
        if (c1Result) {
            // check if the point is within the second bounds
            // "point" is in the local frame of the bvh
            const point = c1Result.point[xyzAxis];
            const isOutside = leftToRight ? point <= float32Array[c2 + splitAxis] : point >= float32Array[c2 + splitAxis + 3]; // max bounding data
            if (isOutside) return c1Result;
        }
        // either there was no intersection in the first node, or there could still be a closer
        // intersection in the second, so check the second node and then take the better of the two
        const c2Intersection = (0, $d4vta.intersectRay)(c2, float32Array, ray);
        const c2Result = c2Intersection ? $15dd3f9915d1b1ff$var$_raycastFirst(c2, bvh, side, ray) : null;
        if (c1Result && c2Result) return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
        else return c1Result || c2Result || null;
    }
}

});

parcelRegister("dhXUU", function(module, exports) {

$parcel$export(module.exports, "intersectsGeometry", () => $9acb57256233c065$export$b2f96b0abaf94e0a);

var $ilwiq = parcelRequire("ilwiq");

var $lenTA = parcelRequire("lenTA");

var $8VYkb = parcelRequire("8VYkb");

var $dRxiJ = parcelRequire("dRxiJ");

var $eADNI = parcelRequire("eADNI");

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");
/*****************************************************************/ /* This file is generated from "intersectsGeometry.template.js". */ /*****************************************************************/ /* eslint-disable indent */ const $9acb57256233c065$var$boundingBox = /* @__PURE__ */ new (0, $ilwiq.Box3)();
const $9acb57256233c065$var$triangle = /* @__PURE__ */ new (0, $8VYkb.ExtendedTriangle)();
const $9acb57256233c065$var$triangle2 = /* @__PURE__ */ new (0, $8VYkb.ExtendedTriangle)();
const $9acb57256233c065$var$invertedMat = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $9acb57256233c065$var$obb = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $9acb57256233c065$var$obb2 = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
function $9acb57256233c065$export$b2f96b0abaf94e0a(bvh, root, otherGeometry, geometryToBvh) {
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    const result = $9acb57256233c065$var$_intersectsGeometry(0, bvh, otherGeometry, geometryToBvh);
    (0, $xqrrD.BufferStack).clearBuffer();
    return result;
}
function $9acb57256233c065$var$_intersectsGeometry(nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    let nodeIndex16 = nodeIndex32 * 2;
    if (cachedObb === null) {
        if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
        $9acb57256233c065$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
        cachedObb = $9acb57256233c065$var$obb;
    }
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const thisGeometry = bvh.geometry;
        const thisIndex = thisGeometry.index;
        const thisPos = thisGeometry.attributes.position;
        const index = otherGeometry.index;
        const pos = otherGeometry.attributes.position;
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        // get the inverse of the geometry matrix so we can transform our triangles into the
        // geometry space we're trying to test. We assume there are fewer triangles being checked
        // here.
        $9acb57256233c065$var$invertedMat.copy(geometryToBvh).invert();
        if (otherGeometry.boundsTree) {
            // if there's a bounds tree
            (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(nodeIndex32), float32Array, $9acb57256233c065$var$obb2);
            $9acb57256233c065$var$obb2.matrix.copy($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$obb2.needsUpdate = true;
            // TODO: use a triangle iteration function here
            const res = otherGeometry.boundsTree.shapecast({
                intersectsBounds: (box)=>$9acb57256233c065$var$obb2.intersectsBox(box),
                intersectsTriangle: (tri)=>{
                    tri.a.applyMatrix4(geometryToBvh);
                    tri.b.applyMatrix4(geometryToBvh);
                    tri.c.applyMatrix4(geometryToBvh);
                    tri.needsUpdate = true;
                    for(let i = offset * 3, l = (count + offset) * 3; i < l; i += 3){
                        // this triangle needs to be transformed into the current BVH coordinate frame
                        (0, $dRxiJ.setTriangle)($9acb57256233c065$var$triangle2, i, thisIndex, thisPos);
                        $9acb57256233c065$var$triangle2.needsUpdate = true;
                        if (tri.intersectsTriangle($9acb57256233c065$var$triangle2)) return true;
                    }
                    return false;
                }
            });
            return res;
        } else // if we're just dealing with raw geometry
        for(let i = offset * 3, l = (count + offset) * 3; i < l; i += 3){
            // this triangle needs to be transformed into the current BVH coordinate frame
            (0, $dRxiJ.setTriangle)($9acb57256233c065$var$triangle, i, thisIndex, thisPos);
            $9acb57256233c065$var$triangle.a.applyMatrix4($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$triangle.b.applyMatrix4($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$triangle.c.applyMatrix4($9acb57256233c065$var$invertedMat);
            $9acb57256233c065$var$triangle.needsUpdate = true;
            for(let i2 = 0, l2 = index.count; i2 < l2; i2 += 3){
                (0, $dRxiJ.setTriangle)($9acb57256233c065$var$triangle2, i2, index, pos);
                $9acb57256233c065$var$triangle2.needsUpdate = true;
                if ($9acb57256233c065$var$triangle.intersectsTriangle($9acb57256233c065$var$triangle2)) return true;
            }
        }
    } else {
        const left = nodeIndex32 + 8;
        const right = uint32Array[nodeIndex32 + 6];
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(left), float32Array, $9acb57256233c065$var$boundingBox);
        const leftIntersection = cachedObb.intersectsBox($9acb57256233c065$var$boundingBox) && $9acb57256233c065$var$_intersectsGeometry(left, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (leftIntersection) return true;
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(right), float32Array, $9acb57256233c065$var$boundingBox);
        const rightIntersection = cachedObb.intersectsBox($9acb57256233c065$var$boundingBox) && $9acb57256233c065$var$_intersectsGeometry(right, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (rightIntersection) return true;
        return false;
    }
}

});

parcelRegister("dnRHH", function(module, exports) {

$parcel$export(module.exports, "closestPointToGeometry", () => $9be714d2e19cc068$export$5912902c175a555e);

var $ilwiq = parcelRequire("ilwiq");

var $lenTA = parcelRequire("lenTA");

var $dRxiJ = parcelRequire("dRxiJ");

var $5Gkg5 = parcelRequire("5Gkg5");

var $7EZfU = parcelRequire("7EZfU");
/*********************************************************************/ /* This file is generated from "closestPointToGeometry.template.js". */ /*********************************************************************/ const $9be714d2e19cc068$var$tempMatrix = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $9be714d2e19cc068$var$obb = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $9be714d2e19cc068$var$obb2 = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $9be714d2e19cc068$var$temp1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $9be714d2e19cc068$var$temp2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $9be714d2e19cc068$var$temp3 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $9be714d2e19cc068$var$temp4 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $9be714d2e19cc068$export$5912902c175a555e(bvh, otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
    if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
    $9be714d2e19cc068$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
    $9be714d2e19cc068$var$obb.needsUpdate = true;
    const geometry = bvh.geometry;
    const pos = geometry.attributes.position;
    const index = geometry.index;
    const otherPos = otherGeometry.attributes.position;
    const otherIndex = otherGeometry.index;
    const triangle = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
    const triangle2 = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
    let tempTarget1 = $9be714d2e19cc068$var$temp1;
    let tempTargetDest1 = $9be714d2e19cc068$var$temp2;
    let tempTarget2 = null;
    let tempTargetDest2 = null;
    if (target2) {
        tempTarget2 = $9be714d2e19cc068$var$temp3;
        tempTargetDest2 = $9be714d2e19cc068$var$temp4;
    }
    let closestDistance = Infinity;
    let closestDistanceTriIndex = null;
    let closestDistanceOtherTriIndex = null;
    $9be714d2e19cc068$var$tempMatrix.copy(geometryToBvh).invert();
    $9be714d2e19cc068$var$obb2.matrix.copy($9be714d2e19cc068$var$tempMatrix);
    bvh.shapecast({
        boundsTraverseOrder: (box)=>{
            return $9be714d2e19cc068$var$obb.distanceToBox(box);
        },
        intersectsBounds: (box, isLeaf, score)=>{
            if (score < closestDistance && score < maxThreshold) {
                // if we know the triangles of this bounds will be intersected next then
                // save the bounds to use during triangle checks.
                if (isLeaf) {
                    $9be714d2e19cc068$var$obb2.min.copy(box.min);
                    $9be714d2e19cc068$var$obb2.max.copy(box.max);
                    $9be714d2e19cc068$var$obb2.needsUpdate = true;
                }
                return true;
            }
            return false;
        },
        intersectsRange: (offset, count)=>{
            if (otherGeometry.boundsTree) {
                // if the other geometry has a bvh then use the accelerated path where we use shapecast to find
                // the closest bounds in the other geometry to check.
                const otherBvh = otherGeometry.boundsTree;
                return otherBvh.shapecast({
                    boundsTraverseOrder: (box)=>{
                        return $9be714d2e19cc068$var$obb2.distanceToBox(box);
                    },
                    intersectsBounds: (box, isLeaf, score)=>{
                        return score < closestDistance && score < maxThreshold;
                    },
                    intersectsRange: (otherOffset, otherCount)=>{
                        for(let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2++){
                            (0, $dRxiJ.setTriangle)(triangle2, 3 * i2, otherIndex, otherPos);
                            triangle2.a.applyMatrix4(geometryToBvh);
                            triangle2.b.applyMatrix4(geometryToBvh);
                            triangle2.c.applyMatrix4(geometryToBvh);
                            triangle2.needsUpdate = true;
                            for(let i = offset, l = offset + count; i < l; i++){
                                (0, $dRxiJ.setTriangle)(triangle, 3 * i, index, pos);
                                triangle.needsUpdate = true;
                                const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                                if (dist < closestDistance) {
                                    tempTargetDest1.copy(tempTarget1);
                                    if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                                    closestDistance = dist;
                                    closestDistanceTriIndex = i;
                                    closestDistanceOtherTriIndex = i2;
                                }
                                // stop traversal if we find a point that's under the given threshold
                                if (dist < minThreshold) return true;
                            }
                        }
                    }
                });
            } else {
                // If no bounds tree then we'll just check every triangle.
                const triCount = (0, $5Gkg5.getTriCount)(otherGeometry);
                for(let i2 = 0, l2 = triCount; i2 < l2; i2++){
                    (0, $dRxiJ.setTriangle)(triangle2, 3 * i2, otherIndex, otherPos);
                    triangle2.a.applyMatrix4(geometryToBvh);
                    triangle2.b.applyMatrix4(geometryToBvh);
                    triangle2.c.applyMatrix4(geometryToBvh);
                    triangle2.needsUpdate = true;
                    for(let i = offset, l = offset + count; i < l; i++){
                        (0, $dRxiJ.setTriangle)(triangle, 3 * i, index, pos);
                        triangle.needsUpdate = true;
                        const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                        if (dist < closestDistance) {
                            tempTargetDest1.copy(tempTarget1);
                            if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                            closestDistance = dist;
                            closestDistanceTriIndex = i;
                            closestDistanceOtherTriIndex = i2;
                        }
                        // stop traversal if we find a point that's under the given threshold
                        if (dist < minThreshold) return true;
                    }
                }
            }
        }
    });
    (0, $7EZfU.ExtendedTrianglePool).releasePrimitive(triangle);
    (0, $7EZfU.ExtendedTrianglePool).releasePrimitive(triangle2);
    if (closestDistance === Infinity) return null;
    if (!target1.point) target1.point = tempTargetDest1.clone();
    else target1.point.copy(tempTargetDest1);
    target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;
    if (target2) {
        if (!target2.point) target2.point = tempTargetDest2.clone();
        else target2.point.copy(tempTargetDest2);
        target2.point.applyMatrix4($9be714d2e19cc068$var$tempMatrix);
        tempTargetDest1.applyMatrix4($9be714d2e19cc068$var$tempMatrix);
        target2.distance = tempTargetDest1.sub(target2.point).length();
        target2.faceIndex = closestDistanceOtherTriIndex;
    }
    return target1;
}

});

parcelRegister("gDpfV", function(module, exports) {

$parcel$export(module.exports, "intersectTris_indirect", () => $c1c3e12524864241$export$7e7412b9f4f11a5c);
$parcel$export(module.exports, "intersectClosestTri_indirect", () => $c1c3e12524864241$export$dddff414156655a1);
$parcel$export(module.exports, "iterateOverTriangles_indirect", () => $c1c3e12524864241$export$dae1f8efdced590b);

var $7pS02 = parcelRequire("7pS02");

var $dRxiJ = parcelRequire("dRxiJ");
/*************************************************************/ /* This file is generated from "iterationUtils.template.js". */ /*************************************************************/ /* eslint-disable indent */ function $c1c3e12524864241$export$7e7412b9f4f11a5c(bvh, side, ray, offset, count, intersections) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    for(let i = offset, end = offset + count; i < end; i++){
        let vi = _indirectBuffer ? _indirectBuffer[i] : i;
        (0, $7pS02.intersectTri)(geometry, side, ray, vi, intersections);
    }
}
function $c1c3e12524864241$export$dddff414156655a1(bvh, side, ray, offset, count) {
    const { geometry: geometry, _indirectBuffer: _indirectBuffer } = bvh;
    let dist = Infinity;
    let res = null;
    for(let i = offset, end = offset + count; i < end; i++){
        let intersection;
        intersection = (0, $7pS02.intersectTri)(geometry, side, ray, _indirectBuffer ? _indirectBuffer[i] : i);
        if (intersection && intersection.distance < dist) {
            res = intersection;
            dist = intersection.distance;
        }
    }
    return res;
}
function $c1c3e12524864241$export$dae1f8efdced590b(offset, count, bvh, intersectsTriangleFunc, contained, depth, triangle) {
    const { geometry: geometry } = bvh;
    const { index: index } = geometry;
    const pos = geometry.attributes.position;
    for(let i = offset, l = count + offset; i < l; i++){
        let tri;
        tri = bvh.resolveTriangleIndex(i);
        (0, $dRxiJ.setTriangle)(triangle, tri * 3, index, pos);
        triangle.needsUpdate = true;
        if (intersectsTriangleFunc(triangle, tri, contained, depth)) return true;
    }
    return false;
}

});

parcelRegister("iERXt", function(module, exports) {

$parcel$export(module.exports, "refit_indirect", () => $d955d16ddee6d2e4$export$40f4af49b81ca898);

var $alNGj = parcelRequire("alNGj");
/****************************************************/ /* This file is generated from "refit.template.js". */ /****************************************************/ function $d955d16ddee6d2e4$export$40f4af49b81ca898(bvh, nodeIndices = null) {
    if (nodeIndices && Array.isArray(nodeIndices)) nodeIndices = new Set(nodeIndices);
    const geometry = bvh.geometry;
    const indexArr = geometry.index ? geometry.index.array : null;
    const posAttr = geometry.attributes.position;
    let buffer, uint32Array, uint16Array, float32Array;
    let byteOffset = 0;
    const roots = bvh._roots;
    for(let i = 0, l = roots.length; i < l; i++){
        buffer = roots[i];
        uint32Array = new Uint32Array(buffer);
        uint16Array = new Uint16Array(buffer);
        float32Array = new Float32Array(buffer);
        _traverse(0, byteOffset);
        byteOffset += buffer.byteLength;
    }
    function _traverse(node32Index, byteOffset, force = false) {
        const node16Index = node32Index * 2;
        const isLeaf = uint16Array[node16Index + 15] === (0, $alNGj.IS_LEAFNODE_FLAG);
        if (isLeaf) {
            const offset = uint32Array[node32Index + 6];
            const count = uint16Array[node16Index + 14];
            let minx = Infinity;
            let miny = Infinity;
            let minz = Infinity;
            let maxx = -Infinity;
            let maxy = -Infinity;
            let maxz = -Infinity;
            for(let i = offset, l = offset + count; i < l; i++){
                const t = 3 * bvh.resolveTriangleIndex(i);
                for(let j = 0; j < 3; j++){
                    let index = t + j;
                    index = indexArr ? indexArr[index] : index;
                    const x = posAttr.getX(index);
                    const y = posAttr.getY(index);
                    const z = posAttr.getZ(index);
                    if (x < minx) minx = x;
                    if (x > maxx) maxx = x;
                    if (y < miny) miny = y;
                    if (y > maxy) maxy = y;
                    if (z < minz) minz = z;
                    if (z > maxz) maxz = z;
                }
            }
            if (float32Array[node32Index + 0] !== minx || float32Array[node32Index + 1] !== miny || float32Array[node32Index + 2] !== minz || float32Array[node32Index + 3] !== maxx || float32Array[node32Index + 4] !== maxy || float32Array[node32Index + 5] !== maxz) {
                float32Array[node32Index + 0] = minx;
                float32Array[node32Index + 1] = miny;
                float32Array[node32Index + 2] = minz;
                float32Array[node32Index + 3] = maxx;
                float32Array[node32Index + 4] = maxy;
                float32Array[node32Index + 5] = maxz;
                return true;
            } else return false;
        } else {
            const left = node32Index + 8;
            const right = uint32Array[node32Index + 6];
            // the identifying node indices provided by the shapecast function include offsets of all
            // root buffers to guarantee they're unique between roots so offset left and right indices here.
            const offsetLeft = left + byteOffset;
            const offsetRight = right + byteOffset;
            let forceChildren = force;
            let includesLeft = false;
            let includesRight = false;
            if (nodeIndices) // if we see that neither the left or right child are included in the set that need to be updated
            // then we assume that all children need to be updated.
            {
                if (!forceChildren) {
                    includesLeft = nodeIndices.has(offsetLeft);
                    includesRight = nodeIndices.has(offsetRight);
                    forceChildren = !includesLeft && !includesRight;
                }
            } else {
                includesLeft = true;
                includesRight = true;
            }
            const traverseLeft = forceChildren || includesLeft;
            const traverseRight = forceChildren || includesRight;
            let leftChange = false;
            if (traverseLeft) leftChange = _traverse(left, byteOffset, forceChildren);
            let rightChange = false;
            if (traverseRight) rightChange = _traverse(right, byteOffset, forceChildren);
            const didChange = leftChange || rightChange;
            if (didChange) for(let i = 0; i < 3; i++){
                const lefti = left + i;
                const righti = right + i;
                const minLeftValue = float32Array[lefti];
                const maxLeftValue = float32Array[lefti + 3];
                const minRightValue = float32Array[righti];
                const maxRightValue = float32Array[righti + 3];
                float32Array[node32Index + i] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
                float32Array[node32Index + i + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
            }
            return didChange;
        }
    }
}

});

parcelRegister("kNP8c", function(module, exports) {

$parcel$export(module.exports, "raycast_indirect", () => $f2500bdd73784d92$export$1999205ebe856279);

var $d4vta = parcelRequire("d4vta");

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");


var $gDpfV = parcelRequire("gDpfV");
/******************************************************/ /* This file is generated from "raycast.template.js". */ /******************************************************/ function $f2500bdd73784d92$export$1999205ebe856279(bvh, root, side, ray, intersects) {
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    $f2500bdd73784d92$var$_raycast(0, bvh, side, ray, intersects);
    (0, $xqrrD.BufferStack).clearBuffer();
}
function $f2500bdd73784d92$var$_raycast(nodeIndex32, bvh, side, ray, intersects) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    const nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        (0, $gDpfV.intersectTris_indirect)(bvh, side, ray, offset, count, intersects);
    } else {
        const leftIndex = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
        if ((0, $d4vta.intersectRay)(leftIndex, float32Array, ray)) $f2500bdd73784d92$var$_raycast(leftIndex, bvh, side, ray, intersects);
        const rightIndex = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
        if ((0, $d4vta.intersectRay)(rightIndex, float32Array, ray)) $f2500bdd73784d92$var$_raycast(rightIndex, bvh, side, ray, intersects);
    }
}

});

parcelRegister("ZxvHI", function(module, exports) {

$parcel$export(module.exports, "raycastFirst_indirect", () => $0b8fb114025d9d97$export$44e48d4cf2fe0609);

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");

var $d4vta = parcelRequire("d4vta");


var $gDpfV = parcelRequire("gDpfV");
/***********************************************************/ /* This file is generated from "raycastFirst.template.js". */ /***********************************************************/ const $0b8fb114025d9d97$var$_xyzFields = [
    "x",
    "y",
    "z"
];
function $0b8fb114025d9d97$export$44e48d4cf2fe0609(bvh, root, side, ray) {
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    const result = $0b8fb114025d9d97$var$_raycastFirst(0, bvh, side, ray);
    (0, $xqrrD.BufferStack).clearBuffer();
    return result;
}
function $0b8fb114025d9d97$var$_raycastFirst(nodeIndex32, bvh, side, ray) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    let nodeIndex16 = nodeIndex32 * 2;
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        return (0, $gDpfV.intersectClosestTri_indirect)(bvh, side, ray, offset, count);
    } else {
        // consider the position of the split plane with respect to the oncoming ray; whichever direction
        // the ray is coming from, look for an intersection among that side of the tree first
        const splitAxis = (0, $8x2iv.SPLIT_AXIS)(nodeIndex32, uint32Array);
        const xyzAxis = $0b8fb114025d9d97$var$_xyzFields[splitAxis];
        const rayDir = ray.direction[xyzAxis];
        const leftToRight = rayDir >= 0;
        // c1 is the child to check first
        let c1, c2;
        if (leftToRight) {
            c1 = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
            c2 = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
        } else {
            c1 = (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array);
            c2 = (0, $8x2iv.LEFT_NODE)(nodeIndex32);
        }
        const c1Intersection = (0, $d4vta.intersectRay)(c1, float32Array, ray);
        const c1Result = c1Intersection ? $0b8fb114025d9d97$var$_raycastFirst(c1, bvh, side, ray) : null;
        // if we got an intersection in the first node and it's closer than the second node's bounding
        // box, we don't need to consider the second node because it couldn't possibly be a better result
        if (c1Result) {
            // check if the point is within the second bounds
            // "point" is in the local frame of the bvh
            const point = c1Result.point[xyzAxis];
            const isOutside = leftToRight ? point <= float32Array[c2 + splitAxis] : point >= float32Array[c2 + splitAxis + 3]; // max bounding data
            if (isOutside) return c1Result;
        }
        // either there was no intersection in the first node, or there could still be a closer
        // intersection in the second, so check the second node and then take the better of the two
        const c2Intersection = (0, $d4vta.intersectRay)(c2, float32Array, ray);
        const c2Result = c2Intersection ? $0b8fb114025d9d97$var$_raycastFirst(c2, bvh, side, ray) : null;
        if (c1Result && c2Result) return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
        else return c1Result || c2Result || null;
    }
}

});

parcelRegister("bD1WL", function(module, exports) {

$parcel$export(module.exports, "intersectsGeometry_indirect", () => $8774d8cede10b4d0$export$80dca0df80ee0084);

var $ilwiq = parcelRequire("ilwiq");

var $lenTA = parcelRequire("lenTA");

var $8VYkb = parcelRequire("8VYkb");

var $dRxiJ = parcelRequire("dRxiJ");

var $eADNI = parcelRequire("eADNI");

var $8x2iv = parcelRequire("8x2iv");

var $xqrrD = parcelRequire("xqrrD");
/*****************************************************************/ /* This file is generated from "intersectsGeometry.template.js". */ /*****************************************************************/ /* eslint-disable indent */ const $8774d8cede10b4d0$var$boundingBox = /* @__PURE__ */ new (0, $ilwiq.Box3)();
const $8774d8cede10b4d0$var$triangle = /* @__PURE__ */ new (0, $8VYkb.ExtendedTriangle)();
const $8774d8cede10b4d0$var$triangle2 = /* @__PURE__ */ new (0, $8VYkb.ExtendedTriangle)();
const $8774d8cede10b4d0$var$invertedMat = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $8774d8cede10b4d0$var$obb = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $8774d8cede10b4d0$var$obb2 = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
function $8774d8cede10b4d0$export$80dca0df80ee0084(bvh, root, otherGeometry, geometryToBvh) {
    (0, $xqrrD.BufferStack).setBuffer(bvh._roots[root]);
    const result = $8774d8cede10b4d0$var$_intersectsGeometry(0, bvh, otherGeometry, geometryToBvh);
    (0, $xqrrD.BufferStack).clearBuffer();
    return result;
}
function $8774d8cede10b4d0$var$_intersectsGeometry(nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null) {
    const { float32Array: float32Array, uint16Array: uint16Array, uint32Array: uint32Array } = (0, $xqrrD.BufferStack);
    let nodeIndex16 = nodeIndex32 * 2;
    if (cachedObb === null) {
        if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
        $8774d8cede10b4d0$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
        cachedObb = $8774d8cede10b4d0$var$obb;
    }
    const isLeaf = (0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array);
    if (isLeaf) {
        const thisGeometry = bvh.geometry;
        const thisIndex = thisGeometry.index;
        const thisPos = thisGeometry.attributes.position;
        const index = otherGeometry.index;
        const pos = otherGeometry.attributes.position;
        const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
        const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
        // get the inverse of the geometry matrix so we can transform our triangles into the
        // geometry space we're trying to test. We assume there are fewer triangles being checked
        // here.
        $8774d8cede10b4d0$var$invertedMat.copy(geometryToBvh).invert();
        if (otherGeometry.boundsTree) {
            // if there's a bounds tree
            (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(nodeIndex32), float32Array, $8774d8cede10b4d0$var$obb2);
            $8774d8cede10b4d0$var$obb2.matrix.copy($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$obb2.needsUpdate = true;
            // TODO: use a triangle iteration function here
            const res = otherGeometry.boundsTree.shapecast({
                intersectsBounds: (box)=>$8774d8cede10b4d0$var$obb2.intersectsBox(box),
                intersectsTriangle: (tri)=>{
                    tri.a.applyMatrix4(geometryToBvh);
                    tri.b.applyMatrix4(geometryToBvh);
                    tri.c.applyMatrix4(geometryToBvh);
                    tri.needsUpdate = true;
                    for(let i = offset, l = count + offset; i < l; i++){
                        // this triangle needs to be transformed into the current BVH coordinate frame
                        (0, $dRxiJ.setTriangle)($8774d8cede10b4d0$var$triangle2, 3 * bvh.resolveTriangleIndex(i), thisIndex, thisPos);
                        $8774d8cede10b4d0$var$triangle2.needsUpdate = true;
                        if (tri.intersectsTriangle($8774d8cede10b4d0$var$triangle2)) return true;
                    }
                    return false;
                }
            });
            return res;
        } else // if we're just dealing with raw geometry
        for(let i = offset, l = count + offset; i < l; i++){
            // this triangle needs to be transformed into the current BVH coordinate frame
            const ti = bvh.resolveTriangleIndex(i);
            (0, $dRxiJ.setTriangle)($8774d8cede10b4d0$var$triangle, 3 * ti, thisIndex, thisPos);
            $8774d8cede10b4d0$var$triangle.a.applyMatrix4($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$triangle.b.applyMatrix4($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$triangle.c.applyMatrix4($8774d8cede10b4d0$var$invertedMat);
            $8774d8cede10b4d0$var$triangle.needsUpdate = true;
            for(let i2 = 0, l2 = index.count; i2 < l2; i2 += 3){
                (0, $dRxiJ.setTriangle)($8774d8cede10b4d0$var$triangle2, i2, index, pos);
                $8774d8cede10b4d0$var$triangle2.needsUpdate = true;
                if ($8774d8cede10b4d0$var$triangle.intersectsTriangle($8774d8cede10b4d0$var$triangle2)) return true;
            }
        }
    } else {
        const left = nodeIndex32 + 8;
        const right = uint32Array[nodeIndex32 + 6];
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(left), float32Array, $8774d8cede10b4d0$var$boundingBox);
        const leftIntersection = cachedObb.intersectsBox($8774d8cede10b4d0$var$boundingBox) && $8774d8cede10b4d0$var$_intersectsGeometry(left, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (leftIntersection) return true;
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(right), float32Array, $8774d8cede10b4d0$var$boundingBox);
        const rightIntersection = cachedObb.intersectsBox($8774d8cede10b4d0$var$boundingBox) && $8774d8cede10b4d0$var$_intersectsGeometry(right, bvh, otherGeometry, geometryToBvh, cachedObb);
        if (rightIntersection) return true;
        return false;
    }
}

});

parcelRegister("gUrAj", function(module, exports) {

$parcel$export(module.exports, "closestPointToGeometry_indirect", () => $c4f746093678aa23$export$334b669407b5ec06);

var $ilwiq = parcelRequire("ilwiq");

var $lenTA = parcelRequire("lenTA");

var $dRxiJ = parcelRequire("dRxiJ");

var $5Gkg5 = parcelRequire("5Gkg5");

var $7EZfU = parcelRequire("7EZfU");
/*********************************************************************/ /* This file is generated from "closestPointToGeometry.template.js". */ /*********************************************************************/ const $c4f746093678aa23$var$tempMatrix = /* @__PURE__ */ new (0, $ilwiq.Matrix4)();
const $c4f746093678aa23$var$obb = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $c4f746093678aa23$var$obb2 = /* @__PURE__ */ new (0, $lenTA.OrientedBox)();
const $c4f746093678aa23$var$temp1 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $c4f746093678aa23$var$temp2 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $c4f746093678aa23$var$temp3 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
const $c4f746093678aa23$var$temp4 = /* @__PURE__ */ new (0, $ilwiq.Vector3)();
function $c4f746093678aa23$export$334b669407b5ec06(bvh, otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
    if (!otherGeometry.boundingBox) otherGeometry.computeBoundingBox();
    $c4f746093678aa23$var$obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
    $c4f746093678aa23$var$obb.needsUpdate = true;
    const geometry = bvh.geometry;
    const pos = geometry.attributes.position;
    const index = geometry.index;
    const otherPos = otherGeometry.attributes.position;
    const otherIndex = otherGeometry.index;
    const triangle = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
    const triangle2 = (0, $7EZfU.ExtendedTrianglePool).getPrimitive();
    let tempTarget1 = $c4f746093678aa23$var$temp1;
    let tempTargetDest1 = $c4f746093678aa23$var$temp2;
    let tempTarget2 = null;
    let tempTargetDest2 = null;
    if (target2) {
        tempTarget2 = $c4f746093678aa23$var$temp3;
        tempTargetDest2 = $c4f746093678aa23$var$temp4;
    }
    let closestDistance = Infinity;
    let closestDistanceTriIndex = null;
    let closestDistanceOtherTriIndex = null;
    $c4f746093678aa23$var$tempMatrix.copy(geometryToBvh).invert();
    $c4f746093678aa23$var$obb2.matrix.copy($c4f746093678aa23$var$tempMatrix);
    bvh.shapecast({
        boundsTraverseOrder: (box)=>{
            return $c4f746093678aa23$var$obb.distanceToBox(box);
        },
        intersectsBounds: (box, isLeaf, score)=>{
            if (score < closestDistance && score < maxThreshold) {
                // if we know the triangles of this bounds will be intersected next then
                // save the bounds to use during triangle checks.
                if (isLeaf) {
                    $c4f746093678aa23$var$obb2.min.copy(box.min);
                    $c4f746093678aa23$var$obb2.max.copy(box.max);
                    $c4f746093678aa23$var$obb2.needsUpdate = true;
                }
                return true;
            }
            return false;
        },
        intersectsRange: (offset, count)=>{
            if (otherGeometry.boundsTree) {
                // if the other geometry has a bvh then use the accelerated path where we use shapecast to find
                // the closest bounds in the other geometry to check.
                const otherBvh = otherGeometry.boundsTree;
                return otherBvh.shapecast({
                    boundsTraverseOrder: (box)=>{
                        return $c4f746093678aa23$var$obb2.distanceToBox(box);
                    },
                    intersectsBounds: (box, isLeaf, score)=>{
                        return score < closestDistance && score < maxThreshold;
                    },
                    intersectsRange: (otherOffset, otherCount)=>{
                        for(let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2++){
                            const ti2 = otherBvh.resolveTriangleIndex(i2);
                            (0, $dRxiJ.setTriangle)(triangle2, 3 * ti2, otherIndex, otherPos);
                            triangle2.a.applyMatrix4(geometryToBvh);
                            triangle2.b.applyMatrix4(geometryToBvh);
                            triangle2.c.applyMatrix4(geometryToBvh);
                            triangle2.needsUpdate = true;
                            for(let i = offset, l = offset + count; i < l; i++){
                                const ti = bvh.resolveTriangleIndex(i);
                                (0, $dRxiJ.setTriangle)(triangle, 3 * ti, index, pos);
                                triangle.needsUpdate = true;
                                const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                                if (dist < closestDistance) {
                                    tempTargetDest1.copy(tempTarget1);
                                    if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                                    closestDistance = dist;
                                    closestDistanceTriIndex = i;
                                    closestDistanceOtherTriIndex = i2;
                                }
                                // stop traversal if we find a point that's under the given threshold
                                if (dist < minThreshold) return true;
                            }
                        }
                    }
                });
            } else {
                // If no bounds tree then we'll just check every triangle.
                const triCount = (0, $5Gkg5.getTriCount)(otherGeometry);
                for(let i2 = 0, l2 = triCount; i2 < l2; i2++){
                    (0, $dRxiJ.setTriangle)(triangle2, 3 * i2, otherIndex, otherPos);
                    triangle2.a.applyMatrix4(geometryToBvh);
                    triangle2.b.applyMatrix4(geometryToBvh);
                    triangle2.c.applyMatrix4(geometryToBvh);
                    triangle2.needsUpdate = true;
                    for(let i = offset, l = offset + count; i < l; i++){
                        const ti = bvh.resolveTriangleIndex(i);
                        (0, $dRxiJ.setTriangle)(triangle, 3 * ti, index, pos);
                        triangle.needsUpdate = true;
                        const dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);
                        if (dist < closestDistance) {
                            tempTargetDest1.copy(tempTarget1);
                            if (tempTargetDest2) tempTargetDest2.copy(tempTarget2);
                            closestDistance = dist;
                            closestDistanceTriIndex = i;
                            closestDistanceOtherTriIndex = i2;
                        }
                        // stop traversal if we find a point that's under the given threshold
                        if (dist < minThreshold) return true;
                    }
                }
            }
        }
    });
    (0, $7EZfU.ExtendedTrianglePool).releasePrimitive(triangle);
    (0, $7EZfU.ExtendedTrianglePool).releasePrimitive(triangle2);
    if (closestDistance === Infinity) return null;
    if (!target1.point) target1.point = tempTargetDest1.clone();
    else target1.point.copy(tempTargetDest1);
    target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;
    if (target2) {
        if (!target2.point) target2.point = tempTargetDest2.clone();
        else target2.point.copy(tempTargetDest2);
        target2.point.applyMatrix4($c4f746093678aa23$var$tempMatrix);
        tempTargetDest1.applyMatrix4($c4f746093678aa23$var$tempMatrix);
        target2.distance = tempTargetDest1.sub(target2.point).length();
        target2.faceIndex = closestDistanceOtherTriIndex;
    }
    return target1;
}

});

parcelRegister("cSOJe", function(module, exports) {

$parcel$export(module.exports, "isSharedArrayBufferSupported", () => $9611e0cfae405faf$export$9c28fa8114adc339);
$parcel$export(module.exports, "convertToBufferType", () => $9611e0cfae405faf$export$fadff02e9aa23f60);
function $9611e0cfae405faf$export$9c28fa8114adc339() {
    return typeof SharedArrayBuffer !== "undefined";
}
function $9611e0cfae405faf$export$fadff02e9aa23f60(array, BufferConstructor) {
    if (array === null) return array;
    else if (array.buffer) {
        const buffer = array.buffer;
        if (buffer.constructor === BufferConstructor) return array;
        const ArrayConstructor = array.constructor;
        const result = new ArrayConstructor(new BufferConstructor(buffer.byteLength));
        result.set(array);
        return result;
    } else {
        if (array.constructor === BufferConstructor) return array;
        const result = new BufferConstructor(array.byteLength);
        new Uint8Array(result).set(new Uint8Array(array));
        return result;
    }
}

});

parcelRegister("f1zUR", function(module, exports) {

$parcel$export(module.exports, "bvhcast", () => $af02cf38ee8e10da$export$a2253c6980b92559);

var $ilwiq = parcelRequire("ilwiq");

var $xqrrD = parcelRequire("xqrrD");

var $8x2iv = parcelRequire("8x2iv");

var $eADNI = parcelRequire("eADNI");

var $1l8b2 = parcelRequire("1l8b2");
const $af02cf38ee8e10da$var$_bufferStack1 = new (0, $xqrrD.BufferStack).constructor();
const $af02cf38ee8e10da$var$_bufferStack2 = new (0, $xqrrD.BufferStack).constructor();
const $af02cf38ee8e10da$var$_boxPool = new (0, $1l8b2.PrimitivePool)(()=>new (0, $ilwiq.Box3)());
const $af02cf38ee8e10da$var$_leftBox1 = new (0, $ilwiq.Box3)();
const $af02cf38ee8e10da$var$_rightBox1 = new (0, $ilwiq.Box3)();
const $af02cf38ee8e10da$var$_leftBox2 = new (0, $ilwiq.Box3)();
const $af02cf38ee8e10da$var$_rightBox2 = new (0, $ilwiq.Box3)();
let $af02cf38ee8e10da$var$_active = false;
function $af02cf38ee8e10da$export$a2253c6980b92559(bvh, otherBvh, matrixToLocal, intersectsRanges) {
    if ($af02cf38ee8e10da$var$_active) throw new Error("MeshBVH: Recursive calls to bvhcast not supported.");
    $af02cf38ee8e10da$var$_active = true;
    const roots = bvh._roots;
    const otherRoots = otherBvh._roots;
    let result;
    let offset1 = 0;
    let offset2 = 0;
    const invMat = new (0, $ilwiq.Matrix4)().copy(matrixToLocal).invert();
    // iterate over the first set of roots
    for(let i = 0, il = roots.length; i < il; i++){
        $af02cf38ee8e10da$var$_bufferStack1.setBuffer(roots[i]);
        offset2 = 0;
        // prep the initial root box
        const localBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(0), $af02cf38ee8e10da$var$_bufferStack1.float32Array, localBox);
        localBox.applyMatrix4(invMat);
        // iterate over the second set of roots
        for(let j = 0, jl = otherRoots.length; j < jl; j++){
            $af02cf38ee8e10da$var$_bufferStack2.setBuffer(otherRoots[i]);
            result = $af02cf38ee8e10da$var$_traverse(0, 0, matrixToLocal, invMat, intersectsRanges, offset1, offset2, 0, 0, localBox);
            $af02cf38ee8e10da$var$_bufferStack2.clearBuffer();
            offset2 += otherRoots[j].length;
            if (result) break;
        }
        // release stack info
        $af02cf38ee8e10da$var$_boxPool.releasePrimitive(localBox);
        $af02cf38ee8e10da$var$_bufferStack1.clearBuffer();
        offset1 += roots[i].length;
        if (result) break;
    }
    $af02cf38ee8e10da$var$_active = false;
    return result;
}
function $af02cf38ee8e10da$var$_traverse(node1Index32, node2Index32, matrix2to1, matrix1to2, intersectsRangesFunc, // offsets for ids
node1IndexByteOffset = 0, node2IndexByteOffset = 0, // tree depth
depth1 = 0, depth2 = 0, currBox = null, reversed = false) {
    // get the buffer stacks associated with the current indices
    let bufferStack1, bufferStack2;
    if (reversed) {
        bufferStack1 = $af02cf38ee8e10da$var$_bufferStack2;
        bufferStack2 = $af02cf38ee8e10da$var$_bufferStack1;
    } else {
        bufferStack1 = $af02cf38ee8e10da$var$_bufferStack1;
        bufferStack2 = $af02cf38ee8e10da$var$_bufferStack2;
    }
    // get the local instances of the typed buffers
    const float32Array1 = bufferStack1.float32Array, uint32Array1 = bufferStack1.uint32Array, uint16Array1 = bufferStack1.uint16Array, float32Array2 = bufferStack2.float32Array, uint32Array2 = bufferStack2.uint32Array, uint16Array2 = bufferStack2.uint16Array;
    const node1Index16 = node1Index32 * 2;
    const node2Index16 = node2Index32 * 2;
    const isLeaf1 = (0, $8x2iv.IS_LEAF)(node1Index16, uint16Array1);
    const isLeaf2 = (0, $8x2iv.IS_LEAF)(node2Index16, uint16Array2);
    let result = false;
    if (isLeaf2 && isLeaf1) {
        // if both bounds are leaf nodes then fire the callback if the boxes intersect
        if (reversed) result = intersectsRangesFunc((0, $8x2iv.OFFSET)(node2Index32, uint32Array2), (0, $8x2iv.COUNT)(node2Index32 * 2, uint16Array2), (0, $8x2iv.OFFSET)(node1Index32, uint32Array1), (0, $8x2iv.COUNT)(node1Index32 * 2, uint16Array1), depth2, node2IndexByteOffset + node2Index32, depth1, node1IndexByteOffset + node1Index32);
        else result = intersectsRangesFunc((0, $8x2iv.OFFSET)(node1Index32, uint32Array1), (0, $8x2iv.COUNT)(node1Index32 * 2, uint16Array1), (0, $8x2iv.OFFSET)(node2Index32, uint32Array2), (0, $8x2iv.COUNT)(node2Index32 * 2, uint16Array2), depth1, node1IndexByteOffset + node1Index32, depth2, node2IndexByteOffset + node2Index32);
    } else if (isLeaf2) {
        // SWAP
        // If we've traversed to the leaf node on the other bvh then we need to swap over
        // to traverse down the first one
        // get the new box to use
        const newBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(node2Index32), float32Array2, newBox);
        newBox.applyMatrix4(matrix2to1);
        // get the child bounds to check before traversal
        const cl1 = (0, $8x2iv.LEFT_NODE)(node1Index32);
        const cr1 = (0, $8x2iv.RIGHT_NODE)(node1Index32, uint32Array1);
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cl1), float32Array1, $af02cf38ee8e10da$var$_leftBox1);
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cr1), float32Array1, $af02cf38ee8e10da$var$_rightBox1);
        // precompute the intersections otherwise the global boxes will be modified during traversal
        const intersectCl1 = newBox.intersectsBox($af02cf38ee8e10da$var$_leftBox1);
        const intersectCr1 = newBox.intersectsBox($af02cf38ee8e10da$var$_rightBox1);
        result = intersectCl1 && $af02cf38ee8e10da$var$_traverse(node2Index32, cl1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed) || intersectCr1 && $af02cf38ee8e10da$var$_traverse(node2Index32, cr1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed);
        $af02cf38ee8e10da$var$_boxPool.releasePrimitive(newBox);
    } else {
        // if neither are leaves then we should swap if one of the children does not
        // intersect with the current bounds
        // get the child bounds to check
        const cl2 = (0, $8x2iv.LEFT_NODE)(node2Index32);
        const cr2 = (0, $8x2iv.RIGHT_NODE)(node2Index32, uint32Array2);
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cl2), float32Array2, $af02cf38ee8e10da$var$_leftBox2);
        (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cr2), float32Array2, $af02cf38ee8e10da$var$_rightBox2);
        const leftIntersects = currBox.intersectsBox($af02cf38ee8e10da$var$_leftBox2);
        const rightIntersects = currBox.intersectsBox($af02cf38ee8e10da$var$_rightBox2);
        if (leftIntersects && rightIntersects) // continue to traverse both children if they both intersect
        result = $af02cf38ee8e10da$var$_traverse(node1Index32, cl2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed) || $af02cf38ee8e10da$var$_traverse(node1Index32, cr2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed);
        else if (leftIntersects) {
            if (isLeaf1) // if the current box is a leaf then just continue
            result = $af02cf38ee8e10da$var$_traverse(node1Index32, cl2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed);
            else {
                // SWAP
                // if only one box intersects then we have to swap to the other bvh to continue
                const newBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
                newBox.copy($af02cf38ee8e10da$var$_leftBox2).applyMatrix4(matrix2to1);
                const cl1 = (0, $8x2iv.LEFT_NODE)(node1Index32);
                const cr1 = (0, $8x2iv.RIGHT_NODE)(node1Index32, uint32Array1);
                (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cl1), float32Array1, $af02cf38ee8e10da$var$_leftBox1);
                (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cr1), float32Array1, $af02cf38ee8e10da$var$_rightBox1);
                // precompute the intersections otherwise the global boxes will be modified during traversal
                const intersectCl1 = newBox.intersectsBox($af02cf38ee8e10da$var$_leftBox1);
                const intersectCr1 = newBox.intersectsBox($af02cf38ee8e10da$var$_rightBox1);
                result = intersectCl1 && $af02cf38ee8e10da$var$_traverse(cl2, cl1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed) || intersectCr1 && $af02cf38ee8e10da$var$_traverse(cl2, cr1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed);
                $af02cf38ee8e10da$var$_boxPool.releasePrimitive(newBox);
            }
        } else if (rightIntersects) {
            if (isLeaf1) // if the current box is a leaf then just continue
            result = $af02cf38ee8e10da$var$_traverse(node1Index32, cr2, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset, node2IndexByteOffset, depth1, depth2 + 1, currBox, reversed);
            else {
                // SWAP
                // if only one box intersects then we have to swap to the other bvh to continue
                const newBox = $af02cf38ee8e10da$var$_boxPool.getPrimitive();
                newBox.copy($af02cf38ee8e10da$var$_rightBox2).applyMatrix4(matrix2to1);
                const cl1 = (0, $8x2iv.LEFT_NODE)(node1Index32);
                const cr1 = (0, $8x2iv.RIGHT_NODE)(node1Index32, uint32Array1);
                (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cl1), float32Array1, $af02cf38ee8e10da$var$_leftBox1);
                (0, $eADNI.arrayToBox)((0, $8x2iv.BOUNDING_DATA_INDEX)(cr1), float32Array1, $af02cf38ee8e10da$var$_rightBox1);
                // precompute the intersections otherwise the global boxes will be modified during traversal
                const intersectCl1 = newBox.intersectsBox($af02cf38ee8e10da$var$_leftBox1);
                const intersectCr1 = newBox.intersectsBox($af02cf38ee8e10da$var$_rightBox1);
                result = intersectCl1 && $af02cf38ee8e10da$var$_traverse(cr2, cl1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed) || intersectCr1 && $af02cf38ee8e10da$var$_traverse(cr2, cr1, matrix1to2, matrix2to1, intersectsRangesFunc, node2IndexByteOffset, node1IndexByteOffset, depth2, depth1 + 1, newBox, !reversed);
                $af02cf38ee8e10da$var$_boxPool.releasePrimitive(newBox);
            }
        }
    }
    return result;
}

});


parcelRegister("dCCOj", function(module, exports) {

$parcel$export(module.exports, "NO_CHANGE", () => $9eacedee756f73b0$export$ddc917fcb8a0cb5e);
$parcel$export(module.exports, "GEOMETRY_ADJUSTED", () => $9eacedee756f73b0$export$9d0dec2f433c8a42);
$parcel$export(module.exports, "GEOMETRY_REBUILT", () => $9eacedee756f73b0$export$855d2b1d3a353384);
$parcel$export(module.exports, "StaticGeometryGenerator", () => $9eacedee756f73b0$export$3516980c1ea07296);

var $ilwiq = parcelRequire("ilwiq");

var $7V7xb = parcelRequire("7V7xb");

var $8LUnK = parcelRequire("8LUnK");

var $2b74x = parcelRequire("2b74x");
const $9eacedee756f73b0$export$ddc917fcb8a0cb5e = 0;
const $9eacedee756f73b0$export$9d0dec2f433c8a42 = 1;
const $9eacedee756f73b0$export$855d2b1d3a353384 = 2;
// iterate over only the meshes in the provided objects
function $9eacedee756f73b0$var$flatTraverseMeshes(objects, cb) {
    for(let i = 0, l = objects.length; i < l; i++){
        const object = objects[i];
        object.traverseVisible((o)=>{
            if (o.isMesh) cb(o);
        });
    }
}
// return the set of materials used by the provided meshes
function $9eacedee756f73b0$var$getMaterials(meshes) {
    const materials = [];
    for(let i = 0, l = meshes.length; i < l; i++){
        const mesh = meshes[i];
        if (Array.isArray(mesh.material)) materials.push(...mesh.material);
        else materials.push(mesh.material);
    }
    return materials;
}
function $9eacedee756f73b0$var$mergeGeometryList(geometries, target, options) {
    // If we have no geometry to merge then provide an empty geometry.
    if (geometries.length === 0) {
        // if there are no geometries then just create a fake empty geometry to provide
        target.setIndex(null);
        // remove all geometry
        const attrs = target.attributes;
        for(const key in attrs)target.deleteAttribute(key);
        // create dummy attributes
        for(const key in options.attributes)target.setAttribute(options.attributes[key], new (0, $ilwiq.BufferAttribute)(new Float32Array(0), 4, false));
    } else (0, $7V7xb.mergeGeometries)(geometries, options, target);
    // Mark all attributes as needing an update
    for(const key in target.attributes)target.attributes[key].needsUpdate = true;
}
class $9eacedee756f73b0$export$3516980c1ea07296 {
    constructor(objects){
        this.objects = null;
        this.useGroups = true;
        this.applyWorldTransforms = true;
        this.generateMissingAttributes = true;
        this.overwriteIndex = true;
        this.attributes = [
            "position",
            "normal",
            "color",
            "tangent",
            "uv",
            "uv2"
        ];
        this._intermediateGeometry = new Map();
        this._geometryMergeSets = new WeakMap();
        this._mergeOrder = [];
        this._dummyMesh = null;
        this.setObjects(objects || []);
    }
    _getDummyMesh() {
        // return a consistent dummy mesh
        if (!this._dummyMesh) {
            const dummyMaterial = new (0, $ilwiq.MeshBasicMaterial)();
            const emptyGeometry = new (0, $ilwiq.BufferGeometry)();
            emptyGeometry.setAttribute("position", new (0, $ilwiq.BufferAttribute)(new Float32Array(9), 3));
            this._dummyMesh = new (0, $ilwiq.Mesh)(emptyGeometry, dummyMaterial);
        }
        return this._dummyMesh;
    }
    _getMeshes() {
        // iterate over only the meshes in the provided objects
        const meshes = [];
        $9eacedee756f73b0$var$flatTraverseMeshes(this.objects, (mesh)=>{
            meshes.push(mesh);
        });
        // Sort the geometry so it's in a reliable order
        meshes.sort((a, b)=>{
            if (a.uuid > b.uuid) return 1;
            if (a.uuid < b.uuid) return -1;
            return 0;
        });
        if (meshes.length === 0) meshes.push(this._getDummyMesh());
        return meshes;
    }
    _updateIntermediateGeometries() {
        const { _intermediateGeometry: _intermediateGeometry } = this;
        const meshes = this._getMeshes();
        const unusedMeshKeys = new Set(_intermediateGeometry.keys());
        const convertOptions = {
            attributes: this.attributes,
            applyWorldTransforms: this.applyWorldTransforms
        };
        for(let i = 0, l = meshes.length; i < l; i++){
            const mesh = meshes[i];
            const meshKey = mesh.uuid;
            unusedMeshKeys.delete(meshKey);
            // initialize the intermediate geometry
            // if the mesh and source geometry have changed in such a way that they are no longer
            // compatible then regenerate the baked geometry from scratch
            let geom = _intermediateGeometry.get(meshKey);
            if (!geom || !geom.isCompatible(mesh, this.attributes)) {
                if (geom) geom.dispose();
                geom = new (0, $2b74x.BakedGeometry)();
                _intermediateGeometry.set(meshKey, geom);
            }
            // transform the geometry into the intermediate buffer geometry, saving whether
            // or not it changed.
            if (geom.updateFrom(mesh, convertOptions)) // TODO: provide option for only generating the set of attributes that are present
            // and are in the attributes array
            {
                if (this.generateMissingAttributes) (0, $8LUnK.setCommonAttributes)(geom, this.attributes);
            }
        }
        unusedMeshKeys.forEach((key)=>{
            _intermediateGeometry.delete(key);
        });
    }
    setObjects(objects) {
        if (Array.isArray(objects)) this.objects = [
            ...objects
        ];
        else this.objects = [
            objects
        ];
    }
    generate(targetGeometry = new (0, $ilwiq.BufferGeometry)()) {
        // track which attributes have been updated and which to skip to avoid unnecessary attribute copies
        const { useGroups: useGroups, overwriteIndex: overwriteIndex, _intermediateGeometry: _intermediateGeometry, _geometryMergeSets: _geometryMergeSets } = this;
        const meshes = this._getMeshes();
        const skipAssigningAttributes = [];
        const mergeGeometry = [];
        const previousMergeInfo = _geometryMergeSets.get(targetGeometry) || [];
        // update all the intermediate static geometry representations
        this._updateIntermediateGeometries();
        // get the list of geometries to merge
        let forceUpdate = false;
        if (meshes.length !== previousMergeInfo.length) forceUpdate = true;
        for(let i = 0, l = meshes.length; i < l; i++){
            const mesh = meshes[i];
            const geom = _intermediateGeometry.get(mesh.uuid);
            mergeGeometry.push(geom);
            const info = previousMergeInfo[i];
            if (!info || info.uuid !== geom.uuid) {
                skipAssigningAttributes.push(false);
                forceUpdate = true;
            } else if (info.version !== geom.version) skipAssigningAttributes.push(false);
            else skipAssigningAttributes.push(true);
        }
        // If we have no geometry to merge then provide an empty geometry.
        $9eacedee756f73b0$var$mergeGeometryList(mergeGeometry, targetGeometry, {
            useGroups: useGroups,
            forceUpdate: forceUpdate,
            skipAssigningAttributes: skipAssigningAttributes,
            overwriteIndex: overwriteIndex
        });
        // force update means the attribute buffer lengths have changed
        if (forceUpdate) targetGeometry.dispose();
        _geometryMergeSets.set(targetGeometry, mergeGeometry.map((g)=>({
                version: g.version,
                uuid: g.uuid
            })));
        let changeType = $9eacedee756f73b0$export$ddc917fcb8a0cb5e;
        if (forceUpdate) changeType = $9eacedee756f73b0$export$855d2b1d3a353384;
        else if (skipAssigningAttributes.includes(false)) changeType = $9eacedee756f73b0$export$9d0dec2f433c8a42;
        return {
            changeType: changeType,
            materials: $9eacedee756f73b0$var$getMaterials(meshes),
            geometry: targetGeometry
        };
    }
}

});
parcelRegister("7V7xb", function(module, exports) {

$parcel$export(module.exports, "mergeGeometries", () => $5c43b36cecf64594$export$f06f69b3bf41d25c);

var $ilwiq = parcelRequire("ilwiq");

var $iYpwh = parcelRequire("iYpwh");
function $5c43b36cecf64594$var$validateMergeability(geometries) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    if (!geometries[0].getAttribute("position")) throw new Error("StaticGeometryGenerator: position attribute is required.");
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) throw new Error("StaticGeometryGenerator: All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) throw new Error('StaticGeometryGenerator: All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) throw new Error("StaticGeometryGenerator: All geometries must have the same number of attributes.");
    }
}
function $5c43b36cecf64594$var$getTotalIndexCount(geometries) {
    let result = 0;
    for(let i = 0, l = geometries.length; i < l; i++)result += geometries[i].getIndex().count;
    return result;
}
function $5c43b36cecf64594$var$getTotalAttributeCount(geometries) {
    let result = 0;
    for(let i = 0, l = geometries.length; i < l; i++)result += geometries[i].getAttribute("position").count;
    return result;
}
function $5c43b36cecf64594$var$trimMismatchedAttributes(target, indexCount, attrCount) {
    if (target.index && target.index.count !== indexCount) target.setIndex(null);
    const attributes = target.attributes;
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.count !== attrCount) target.deleteAttribute(key);
    }
}
function $5c43b36cecf64594$export$f06f69b3bf41d25c(geometries, options = {}, targetGeometry = new (0, $ilwiq.BufferGeometry)()) {
    const { useGroups: useGroups = false, forceUpdate: forceUpdate = false, skipAssigningAttributes: skipAssigningAttributes = [], overwriteIndex: overwriteIndex = true } = options;
    // check if we can merge these geometries
    $5c43b36cecf64594$var$validateMergeability(geometries);
    const isIndexed = geometries[0].index !== null;
    const totalIndexCount = isIndexed ? $5c43b36cecf64594$var$getTotalIndexCount(geometries) : -1;
    const totalAttributeCount = $5c43b36cecf64594$var$getTotalAttributeCount(geometries);
    $5c43b36cecf64594$var$trimMismatchedAttributes(targetGeometry, totalIndexCount, totalAttributeCount);
    // set up groups
    if (useGroups) {
        let offset = 0;
        for(let i = 0, l = geometries.length; i < l; i++){
            const geometry = geometries[i];
            let primitiveCount;
            if (isIndexed) primitiveCount = geometry.getIndex().count;
            else primitiveCount = geometry.getAttribute("position").count;
            targetGeometry.addGroup(offset, primitiveCount, i);
            offset += primitiveCount;
        }
    }
    // generate the final geometry
    // skip the assigning any attributes for items in the above array
    if (isIndexed) {
        // set up the index if it doesn't exist
        let forceUpdateIndex = false;
        if (!targetGeometry.index) {
            targetGeometry.setIndex(new (0, $ilwiq.BufferAttribute)(new Uint32Array(totalIndexCount), 1, false));
            forceUpdateIndex = true;
        }
        if (forceUpdateIndex || overwriteIndex) {
            // copy the index data to the target geometry
            let targetOffset = 0;
            let indexOffset = 0;
            const targetIndex = targetGeometry.getIndex();
            for(let i = 0, l = geometries.length; i < l; i++){
                const geometry = geometries[i];
                const index = geometry.getIndex();
                const skip = !forceUpdate && !forceUpdateIndex && skipAssigningAttributes[i];
                if (!skip) for(let j = 0; j < index.count; ++j)targetIndex.setX(targetOffset + j, index.getX(j) + indexOffset);
                targetOffset += index.count;
                indexOffset += geometry.getAttribute("position").count;
            }
        }
    }
    // copy all the attribute data over
    const attributes = Object.keys(geometries[0].attributes);
    for(let i = 0, l = attributes.length; i < l; i++){
        let forceUpdateAttr = false;
        const key = attributes[i];
        if (!targetGeometry.getAttribute(key)) {
            const firstAttr = geometries[0].getAttribute(key);
            targetGeometry.setAttribute(key, (0, $iYpwh.createAttributeClone)(firstAttr, totalAttributeCount));
            forceUpdateAttr = true;
        }
        let offset = 0;
        const targetAttribute = targetGeometry.getAttribute(key);
        for(let g = 0, l = geometries.length; g < l; g++){
            const geometry = geometries[g];
            const skip = !forceUpdate && !forceUpdateAttr && skipAssigningAttributes[g];
            const attr = geometry.getAttribute(key);
            if (!skip) {
                if (key === "color" && targetAttribute.itemSize !== attr.itemSize) // make sure the color attribute is aligned with itemSize 3 to 4
                for(let index = offset, l = attr.count; index < l; index++)attr.setXYZW(index, targetAttribute.getX(index), targetAttribute.getY(index), targetAttribute.getZ(index), 1.0);
                else (0, $iYpwh.copyAttributeContents)(attr, targetAttribute, offset);
            }
            offset += attr.count;
        }
    }
}

});
parcelRegister("iYpwh", function(module, exports) {

$parcel$export(module.exports, "copyAttributeContents", () => $dd01a0424002e6a9$export$16ecced3bb0ee496);
$parcel$export(module.exports, "createAttributeClone", () => $dd01a0424002e6a9$export$f129ac5b0a0bbb35);
$parcel$export(module.exports, "validateAttributes", () => $dd01a0424002e6a9$export$87f0ba9cb6ea9964);

var $ilwiq = parcelRequire("ilwiq");
function $dd01a0424002e6a9$export$16ecced3bb0ee496(attr, target, targetOffset = 0) {
    if (attr.isInterleavedBufferAttribute) {
        const itemSize = attr.itemSize;
        for(let i = 0, l = attr.count; i < l; i++){
            const io = i + targetOffset;
            target.setX(io, attr.getX(i));
            if (itemSize >= 2) target.setY(io, attr.getY(i));
            if (itemSize >= 3) target.setZ(io, attr.getZ(i));
            if (itemSize >= 4) target.setW(io, attr.getW(i));
        }
    } else {
        const array = target.array;
        const cons = array.constructor;
        const byteOffset = array.BYTES_PER_ELEMENT * attr.itemSize * targetOffset;
        const temp = new cons(array.buffer, byteOffset, attr.array.length);
        temp.set(attr.array);
    }
}
function $dd01a0424002e6a9$export$f129ac5b0a0bbb35(attr, countOverride = null) {
    const cons = attr.array.constructor;
    const normalized = attr.normalized;
    const itemSize = attr.itemSize;
    const count = countOverride === null ? attr.count : countOverride;
    return new (0, $ilwiq.BufferAttribute)(new cons(itemSize * count), itemSize, normalized);
}
function $dd01a0424002e6a9$export$87f0ba9cb6ea9964(attr1, attr2) {
    if (!attr1 && !attr2) return true;
    if (Boolean(attr1) !== Boolean(attr2)) return false;
    const sameCount = attr1.count === attr2.count;
    const sameNormalized = attr1.normalized === attr2.normalized;
    const sameType = attr1.array.constructor === attr2.array.constructor;
    const sameItemSize = attr1.itemSize === attr2.itemSize;
    if (!sameCount || !sameNormalized || !sameType || !sameItemSize) return false;
    return true;
}

});


parcelRegister("8LUnK", function(module, exports) {

$parcel$export(module.exports, "updateMaterialIndexAttribute", () => $662e72ceb18db3d0$export$e7c7cc0a9714fa82);
$parcel$export(module.exports, "setCommonAttributes", () => $662e72ceb18db3d0$export$f5a01205d395aca);

var $ilwiq = parcelRequire("ilwiq");
function $662e72ceb18db3d0$export$e7c7cc0a9714fa82(geometry, materials, allMaterials) {
    const indexAttr = geometry.index;
    const posAttr = geometry.attributes.position;
    const vertCount = posAttr.count;
    const totalCount = indexAttr ? indexAttr.count : vertCount;
    let groups = geometry.groups;
    if (groups.length === 0) groups = [
        {
            count: totalCount,
            start: 0,
            materialIndex: 0
        }
    ];
    let materialIndexAttribute = geometry.getAttribute("materialIndex");
    if (!materialIndexAttribute || materialIndexAttribute.count !== vertCount) {
        // use an array with the minimum precision required to store all material id references.
        let array;
        if (allMaterials.length <= 255) array = new Uint8Array(vertCount);
        else array = new Uint16Array(vertCount);
        materialIndexAttribute = new (0, $ilwiq.BufferAttribute)(array, 1, false);
        geometry.deleteAttribute("materialIndex");
        geometry.setAttribute("materialIndex", materialIndexAttribute);
    }
    const materialArray = materialIndexAttribute.array;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const start = group.start;
        const count = group.count;
        const endCount = Math.min(count, totalCount - start);
        const mat = Array.isArray(materials) ? materials[group.materialIndex] : materials;
        const materialIndex = allMaterials.indexOf(mat);
        for(let j = 0; j < endCount; j++){
            let index = start + j;
            if (indexAttr) index = indexAttr.getX(index);
            materialArray[index] = materialIndex;
        }
    }
}
function $662e72ceb18db3d0$export$f5a01205d395aca(geometry, attributes) {
    if (!geometry.index) {
        // TODO: compute a typed array
        const indexCount = geometry.attributes.position.count;
        const array = new Array(indexCount);
        for(let i = 0; i < indexCount; i++)array[i] = i;
        geometry.setIndex(array);
    }
    if (!geometry.attributes.normal && attributes && attributes.includes("normal")) geometry.computeVertexNormals();
    if (!geometry.attributes.uv && attributes && attributes.includes("uv")) {
        const vertCount = geometry.attributes.position.count;
        geometry.setAttribute("uv", new (0, $ilwiq.BufferAttribute)(new Float32Array(vertCount * 2), 2, false));
    }
    if (!geometry.attributes.uv2 && attributes && attributes.includes("uv2")) {
        const vertCount = geometry.attributes.position.count;
        geometry.setAttribute("uv2", new (0, $ilwiq.BufferAttribute)(new Float32Array(vertCount * 2), 2, false));
    }
    if (!geometry.attributes.tangent && attributes && attributes.includes("tangent")) {
        // compute tangents requires a uv and normal buffer
        if (geometry.attributes.uv && geometry.attributes.normal) geometry.computeTangents();
        else {
            const vertCount = geometry.attributes.position.count;
            geometry.setAttribute("tangent", new (0, $ilwiq.BufferAttribute)(new Float32Array(vertCount * 4), 4, false));
        }
    }
    if (!geometry.attributes.color && attributes && attributes.includes("color")) {
        const vertCount = geometry.attributes.position.count;
        const array = new Float32Array(vertCount * 4);
        array.fill(1.0);
        geometry.setAttribute("color", new (0, $ilwiq.BufferAttribute)(array, 4));
    }
}

});

parcelRegister("2b74x", function(module, exports) {

$parcel$export(module.exports, "BakedGeometry", () => $1962183cefca0848$export$93d9a3230423d56b);

var $ilwiq = parcelRequire("ilwiq");

var $ddiur = parcelRequire("ddiur");

var $gz5pJ = parcelRequire("gz5pJ");

var $iYpwh = parcelRequire("iYpwh");
class $1962183cefca0848$export$93d9a3230423d56b extends (0, $ilwiq.BufferGeometry) {
    constructor(){
        super();
        this.version = 0;
        this.hash = null;
        this._diff = new (0, $ddiur.MeshDiff)();
    }
    // returns whether the passed mesh is compatible with this baked geometry
    // such that it can be updated without resizing attributes
    isCompatible(mesh, attributes) {
        const geometry = mesh.geometry;
        for(let i = 0; i < attributes.length; i++){
            const key = attributes[i];
            const attr1 = geometry.attributes[key];
            const attr2 = this.attributes[key];
            if (attr1 && !(0, $iYpwh.validateAttributes)(attr1, attr2)) return false;
        }
        return true;
    }
    updateFrom(mesh, options) {
        const diff = this._diff;
        if (diff.didChange(mesh)) {
            (0, $gz5pJ.convertToStaticGeometry)(mesh, options, this);
            diff.updateFrom(mesh);
            this.version++;
            this.hash = `${this.uuid}_${this.version}`;
            return true;
        } else return false;
    }
}

});
parcelRegister("ddiur", function(module, exports) {

$parcel$export(module.exports, "MeshDiff", () => $99ead4f72dcbbc3d$export$507d8b359822d42d);

var $ilwiq = parcelRequire("ilwiq");

var $6ply6 = parcelRequire("6ply6");
function $99ead4f72dcbbc3d$var$getGeometryHash(geometry) {
    let hash = geometry.uuid;
    const attributes = Object.values(geometry.attributes);
    if (geometry.index) {
        attributes.push(geometry.index);
        hash += `index|${geometry.index.version}`;
    }
    const keys = Object.keys(attributes).sort();
    for (const key of keys){
        const attr = attributes[key];
        hash += `${key}_${attr.version}|`;
    }
    return hash;
}
function $99ead4f72dcbbc3d$var$getSkeletonHash(mesh) {
    const skeleton = mesh.skeleton;
    if (skeleton) {
        if (!skeleton.boneTexture) skeleton.computeBoneTexture();
        // we can't use the texture version here because it will change even
        // when the bones haven't
        const dataHash = (0, $6ply6.bufferToHash)(skeleton.boneTexture.image.data.buffer);
        return `${dataHash}_${skeleton.boneTexture.uuid}`;
    } else return null;
}
class $99ead4f72dcbbc3d$export$507d8b359822d42d {
    constructor(mesh = null){
        this.matrixWorld = new (0, $ilwiq.Matrix4)();
        this.geometryHash = null;
        this.skeletonHash = null;
        this.primitiveCount = -1;
        if (mesh !== null) this.updateFrom(mesh);
    }
    updateFrom(mesh) {
        const geometry = mesh.geometry;
        const primitiveCount = (geometry.index ? geometry.index.count : geometry.attributes.position.count) / 3;
        this.matrixWorld.copy(mesh.matrixWorld);
        this.geometryHash = $99ead4f72dcbbc3d$var$getGeometryHash(geometry);
        this.primitiveCount = primitiveCount;
        this.skeletonHash = $99ead4f72dcbbc3d$var$getSkeletonHash(mesh);
    }
    didChange(mesh) {
        const geometry = mesh.geometry;
        const primitiveCount = (geometry.index ? geometry.index.count : geometry.attributes.position.count) / 3;
        const identical = this.matrixWorld.equals(mesh.matrixWorld) && this.geometryHash === $99ead4f72dcbbc3d$var$getGeometryHash(geometry) && this.skeletonHash === $99ead4f72dcbbc3d$var$getSkeletonHash(mesh) && this.primitiveCount === primitiveCount;
        return !identical;
    }
}

});
parcelRegister("6ply6", function(module, exports) {

$parcel$export(module.exports, "bufferToHash", () => $4aa5cb15510fc60f$export$d10cf98ed3bc976d);
// https://www.geeksforgeeks.org/how-to-create-hash-from-string-in-javascript/
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
function $4aa5cb15510fc60f$export$d10cf98ed3bc976d(buffer) {
    let hash = 0;
    if (buffer.byteLength !== 0) {
        const uintArray = new Uint8Array(buffer);
        for(let i = 0; i < buffer.byteLength; i++){
            const byte = uintArray[i];
            hash = (hash << 5) - hash + byte;
            hash |= 0;
        }
    }
    return hash;
}

});


parcelRegister("gz5pJ", function(module, exports) {

$parcel$export(module.exports, "convertToStaticGeometry", () => $c0f41d5980ac4a7a$export$8ed71501c410233d);

var $ilwiq = parcelRequire("ilwiq");

var $iYpwh = parcelRequire("iYpwh");
const $c0f41d5980ac4a7a$var$_positionVector = /*@__PURE__*/ new (0, $ilwiq.Vector3)();
const $c0f41d5980ac4a7a$var$_normalVector = /*@__PURE__*/ new (0, $ilwiq.Vector3)();
const $c0f41d5980ac4a7a$var$_tangentVector = /*@__PURE__*/ new (0, $ilwiq.Vector3)();
const $c0f41d5980ac4a7a$var$_tangentVector4 = /*@__PURE__*/ new (0, $ilwiq.Vector4)();
const $c0f41d5980ac4a7a$var$_morphVector = /*@__PURE__*/ new (0, $ilwiq.Vector3)();
const $c0f41d5980ac4a7a$var$_temp = /*@__PURE__*/ new (0, $ilwiq.Vector3)();
const $c0f41d5980ac4a7a$var$_skinIndex = /*@__PURE__*/ new (0, $ilwiq.Vector4)();
const $c0f41d5980ac4a7a$var$_skinWeight = /*@__PURE__*/ new (0, $ilwiq.Vector4)();
const $c0f41d5980ac4a7a$var$_matrix = /*@__PURE__*/ new (0, $ilwiq.Matrix4)();
const $c0f41d5980ac4a7a$var$_boneMatrix = /*@__PURE__*/ new (0, $ilwiq.Matrix4)();
// A version of "SkinnedMesh.boneTransform" for normals
function $c0f41d5980ac4a7a$var$boneNormalTransform(mesh, index, target) {
    const skeleton = mesh.skeleton;
    const geometry = mesh.geometry;
    const bones = skeleton.bones;
    const boneInverses = skeleton.boneInverses;
    $c0f41d5980ac4a7a$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
    $c0f41d5980ac4a7a$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
    $c0f41d5980ac4a7a$var$_matrix.elements.fill(0);
    for(let i = 0; i < 4; i++){
        const weight = $c0f41d5980ac4a7a$var$_skinWeight.getComponent(i);
        if (weight !== 0) {
            const boneIndex = $c0f41d5980ac4a7a$var$_skinIndex.getComponent(i);
            $c0f41d5980ac4a7a$var$_boneMatrix.multiplyMatrices(bones[boneIndex].matrixWorld, boneInverses[boneIndex]);
            $c0f41d5980ac4a7a$var$addScaledMatrix($c0f41d5980ac4a7a$var$_matrix, $c0f41d5980ac4a7a$var$_boneMatrix, weight);
        }
    }
    $c0f41d5980ac4a7a$var$_matrix.multiply(mesh.bindMatrix).premultiply(mesh.bindMatrixInverse);
    target.transformDirection($c0f41d5980ac4a7a$var$_matrix);
    return target;
}
// Applies the morph target data to the target vector
function $c0f41d5980ac4a7a$var$applyMorphTarget(morphData, morphInfluences, morphTargetsRelative, i, target) {
    $c0f41d5980ac4a7a$var$_morphVector.set(0, 0, 0);
    for(let j = 0, jl = morphData.length; j < jl; j++){
        const influence = morphInfluences[j];
        const morphAttribute = morphData[j];
        if (influence === 0) continue;
        $c0f41d5980ac4a7a$var$_temp.fromBufferAttribute(morphAttribute, i);
        if (morphTargetsRelative) $c0f41d5980ac4a7a$var$_morphVector.addScaledVector($c0f41d5980ac4a7a$var$_temp, influence);
        else $c0f41d5980ac4a7a$var$_morphVector.addScaledVector($c0f41d5980ac4a7a$var$_temp.sub(target), influence);
    }
    target.add($c0f41d5980ac4a7a$var$_morphVector);
}
// Adds the "matrix" multiplied by "scale" to "target"
function $c0f41d5980ac4a7a$var$addScaledMatrix(target, matrix, scale) {
    const targetArray = target.elements;
    const matrixArray = matrix.elements;
    for(let i = 0, l = matrixArray.length; i < l; i++)targetArray[i] += matrixArray[i] * scale;
}
// inverts the geometry in place
function $c0f41d5980ac4a7a$var$invertGeometry(geometry) {
    const { index: index, attributes: attributes } = geometry;
    if (index) for(let i = 0, l = index.count; i < l; i += 3){
        const v0 = index.getX(i);
        const v2 = index.getX(i + 2);
        index.setX(i, v2);
        index.setX(i + 2, v0);
    }
    else for(const key in attributes){
        const attr = attributes[key];
        const itemSize = attr.itemSize;
        for(let i = 0, l = attr.count; i < l; i += 3)for(let j = 0; j < itemSize; j++){
            const v0 = attr.getComponent(i, j);
            const v2 = attr.getComponent(i + 2, j);
            attr.setComponent(i, j, v2);
            attr.setComponent(i + 2, j, v0);
        }
    }
    return geometry;
}
function $c0f41d5980ac4a7a$export$8ed71501c410233d(mesh, options = {}, targetGeometry = new (0, $ilwiq.BufferGeometry)()) {
    options = {
        applyWorldTransforms: true,
        attributes: [],
        ...options
    };
    const geometry = mesh.geometry;
    const applyWorldTransforms = options.applyWorldTransforms;
    const includeNormal = options.attributes.includes("normal");
    const includeTangent = options.attributes.includes("tangent");
    const attributes = geometry.attributes;
    const targetAttributes = targetGeometry.attributes;
    // strip any unused and unneeded attributes
    for(const key in targetGeometry.attributes)if (!options.attributes.includes(key) || !(key in geometry.attributes)) targetGeometry.deleteAttribute(key);
    // initialize the attributes if they don't exist
    if (!targetGeometry.index && geometry.index) targetGeometry.index = geometry.index.clone();
    if (!targetAttributes.position) targetGeometry.setAttribute("position", (0, $iYpwh.createAttributeClone)(attributes.position));
    if (includeNormal && !targetAttributes.normal && attributes.normal) targetGeometry.setAttribute("normal", (0, $iYpwh.createAttributeClone)(attributes.normal));
    if (includeTangent && !targetAttributes.tangent && attributes.tangent) targetGeometry.setAttribute("tangent", (0, $iYpwh.createAttributeClone)(attributes.tangent));
    // ensure the attributes are consistent
    (0, $iYpwh.validateAttributes)(geometry.index, targetGeometry.index);
    (0, $iYpwh.validateAttributes)(attributes.position, targetAttributes.position);
    if (includeNormal) (0, $iYpwh.validateAttributes)(attributes.normal, targetAttributes.normal);
    if (includeTangent) (0, $iYpwh.validateAttributes)(attributes.tangent, targetAttributes.tangent);
    // generate transformed vertex attribute data
    const position = attributes.position;
    const normal = includeNormal ? attributes.normal : null;
    const tangent = includeTangent ? attributes.tangent : null;
    const morphPosition = geometry.morphAttributes.position;
    const morphNormal = geometry.morphAttributes.normal;
    const morphTangent = geometry.morphAttributes.tangent;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const morphInfluences = mesh.morphTargetInfluences;
    const normalMatrix = new (0, $ilwiq.Matrix3)();
    normalMatrix.getNormalMatrix(mesh.matrixWorld);
    // copy the index
    if (geometry.index) targetGeometry.index.array.set(geometry.index.array);
    // copy and apply other attributes
    for(let i = 0, l = attributes.position.count; i < l; i++){
        $c0f41d5980ac4a7a$var$_positionVector.fromBufferAttribute(position, i);
        if (normal) $c0f41d5980ac4a7a$var$_normalVector.fromBufferAttribute(normal, i);
        if (tangent) {
            $c0f41d5980ac4a7a$var$_tangentVector4.fromBufferAttribute(tangent, i);
            $c0f41d5980ac4a7a$var$_tangentVector.fromBufferAttribute(tangent, i);
        }
        // apply morph target transform
        if (morphInfluences) {
            if (morphPosition) $c0f41d5980ac4a7a$var$applyMorphTarget(morphPosition, morphInfluences, morphTargetsRelative, i, $c0f41d5980ac4a7a$var$_positionVector);
            if (morphNormal) $c0f41d5980ac4a7a$var$applyMorphTarget(morphNormal, morphInfluences, morphTargetsRelative, i, $c0f41d5980ac4a7a$var$_normalVector);
            if (morphTangent) $c0f41d5980ac4a7a$var$applyMorphTarget(morphTangent, morphInfluences, morphTargetsRelative, i, $c0f41d5980ac4a7a$var$_tangentVector);
        }
        // apply bone transform
        if (mesh.isSkinnedMesh) {
            mesh.applyBoneTransform(i, $c0f41d5980ac4a7a$var$_positionVector);
            if (normal) $c0f41d5980ac4a7a$var$boneNormalTransform(mesh, i, $c0f41d5980ac4a7a$var$_normalVector);
            if (tangent) $c0f41d5980ac4a7a$var$boneNormalTransform(mesh, i, $c0f41d5980ac4a7a$var$_tangentVector);
        }
        // update the vectors of the attributes
        if (applyWorldTransforms) $c0f41d5980ac4a7a$var$_positionVector.applyMatrix4(mesh.matrixWorld);
        targetAttributes.position.setXYZ(i, $c0f41d5980ac4a7a$var$_positionVector.x, $c0f41d5980ac4a7a$var$_positionVector.y, $c0f41d5980ac4a7a$var$_positionVector.z);
        if (normal) {
            if (applyWorldTransforms) $c0f41d5980ac4a7a$var$_normalVector.applyNormalMatrix(normalMatrix);
            targetAttributes.normal.setXYZ(i, $c0f41d5980ac4a7a$var$_normalVector.x, $c0f41d5980ac4a7a$var$_normalVector.y, $c0f41d5980ac4a7a$var$_normalVector.z);
        }
        if (tangent) {
            if (applyWorldTransforms) $c0f41d5980ac4a7a$var$_tangentVector.transformDirection(mesh.matrixWorld);
            targetAttributes.tangent.setXYZW(i, $c0f41d5980ac4a7a$var$_tangentVector.x, $c0f41d5980ac4a7a$var$_tangentVector.y, $c0f41d5980ac4a7a$var$_tangentVector.z, $c0f41d5980ac4a7a$var$_tangentVector4.w);
        }
    }
    // copy other attributes over
    for(const i in options.attributes){
        const key = options.attributes[i];
        if (key === "position" || key === "tangent" || key === "normal" || !(key in attributes)) continue;
        if (!targetAttributes[key]) targetGeometry.setAttribute(key, (0, $iYpwh.createAttributeClone)(attributes[key]));
        (0, $iYpwh.validateAttributes)(attributes[key], targetAttributes[key]);
        (0, $iYpwh.copyAttributeContents)(attributes[key], targetAttributes[key]);
    }
    if (mesh.matrixWorld.determinant() < 0) $c0f41d5980ac4a7a$var$invertGeometry(targetGeometry);
    return targetGeometry;
}

});




parcelRegister("2vjHu", function(module, exports) {

var $7rn9W = parcelRequire("7rn9W");

var $b78om = parcelRequire("b78om");

var $eL5d2 = parcelRequire("eL5d2");

var $fFvuX = parcelRequire("fFvuX");
$parcel$exportWildcard(module.exports, $7rn9W);
$parcel$exportWildcard(module.exports, $b78om);
$parcel$exportWildcard(module.exports, $eL5d2);
$parcel$exportWildcard(module.exports, $fFvuX);

});
parcelRegister("7rn9W", function(module, exports) {

$parcel$export(module.exports, "common_functions", () => $56ad0500f946240e$export$25a1e84cdffa9fe9);
const $56ad0500f946240e$export$25a1e84cdffa9fe9 = /* glsl */ `

// A stack of uint32 indices can can store the indices for
// a perfectly balanced tree with a depth up to 31. Lower stack
// depth gets higher performance.
//
// However not all trees are balanced. Best value to set this to
// is the trees max depth.
#ifndef BVH_STACK_DEPTH
#define BVH_STACK_DEPTH 60
#endif

#ifndef INFINITY
#define INFINITY 1e20
#endif

// Utilities
uvec4 uTexelFetch1D( usampler2D tex, uint index ) {

	uint width = uint( textureSize( tex, 0 ).x );
	uvec2 uv;
	uv.x = index % width;
	uv.y = index / width;

	return texelFetch( tex, ivec2( uv ), 0 );

}

ivec4 iTexelFetch1D( isampler2D tex, uint index ) {

	uint width = uint( textureSize( tex, 0 ).x );
	uvec2 uv;
	uv.x = index % width;
	uv.y = index / width;

	return texelFetch( tex, ivec2( uv ), 0 );

}

vec4 texelFetch1D( sampler2D tex, uint index ) {

	uint width = uint( textureSize( tex, 0 ).x );
	uvec2 uv;
	uv.x = index % width;
	uv.y = index / width;

	return texelFetch( tex, ivec2( uv ), 0 );

}

vec4 textureSampleBarycoord( sampler2D tex, vec3 barycoord, uvec3 faceIndices ) {

	return
		barycoord.x * texelFetch1D( tex, faceIndices.x ) +
		barycoord.y * texelFetch1D( tex, faceIndices.y ) +
		barycoord.z * texelFetch1D( tex, faceIndices.z );

}

void ndcToCameraRay(
	vec2 coord, mat4 cameraWorld, mat4 invProjectionMatrix,
	out vec3 rayOrigin, out vec3 rayDirection
) {

	// get camera look direction and near plane for camera clipping
	vec4 lookDirection = cameraWorld * vec4( 0.0, 0.0, - 1.0, 0.0 );
	vec4 nearVector = invProjectionMatrix * vec4( 0.0, 0.0, - 1.0, 1.0 );
	float near = abs( nearVector.z / nearVector.w );

	// get the camera direction and position from camera matrices
	vec4 origin = cameraWorld * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec4 direction = invProjectionMatrix * vec4( coord, 0.5, 1.0 );
	direction /= direction.w;
	direction = cameraWorld * direction - origin;

	// slide the origin along the ray until it sits at the near clip plane position
	origin.xyz += direction.xyz * near / dot( direction, lookDirection );

	rayOrigin = origin.xyz;
	rayDirection = direction.xyz;

}
`;

});

parcelRegister("b78om", function(module, exports) {

$parcel$export(module.exports, "bvh_distance_functions", () => $8176db9d094041c0$export$ae4e12e8c7af5f08);
// Distance to Point
const $8176db9d094041c0$export$ae4e12e8c7af5f08 = /* glsl */ `

float dot2( vec3 v ) {

	return dot( v, v );

}

// https://www.shadertoy.com/view/ttfGWl
vec3 closestPointToTriangle( vec3 p, vec3 v0, vec3 v1, vec3 v2, out vec3 barycoord ) {

    vec3 v10 = v1 - v0;
    vec3 v21 = v2 - v1;
    vec3 v02 = v0 - v2;

	vec3 p0 = p - v0;
	vec3 p1 = p - v1;
	vec3 p2 = p - v2;

    vec3 nor = cross( v10, v02 );

    // method 2, in barycentric space
    vec3  q = cross( nor, p0 );
    float d = 1.0 / dot2( nor );
    float u = d * dot( q, v02 );
    float v = d * dot( q, v10 );
    float w = 1.0 - u - v;

	if( u < 0.0 ) {

		w = clamp( dot( p2, v02 ) / dot2( v02 ), 0.0, 1.0 );
		u = 0.0;
		v = 1.0 - w;

	} else if( v < 0.0 ) {

		u = clamp( dot( p0, v10 ) / dot2( v10 ), 0.0, 1.0 );
		v = 0.0;
		w = 1.0 - u;

	} else if( w < 0.0 ) {

		v = clamp( dot( p1, v21 ) / dot2( v21 ), 0.0, 1.0 );
		w = 0.0;
		u = 1.0-v;

	}

	barycoord = vec3( u, v, w );
    return u * v1 + v * v2 + w * v0;

}

float distanceToTriangles(
	// geometry info and triangle range
	sampler2D positionAttr, usampler2D indexAttr, uint offset, uint count,

	// point and cut off range
	vec3 point, float closestDistanceSquared,

	// outputs
	inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord, inout float side, inout vec3 outPoint
) {

	bool found = false;
	vec3 localBarycoord;
	for ( uint i = offset, l = offset + count; i < l; i ++ ) {

		uvec3 indices = uTexelFetch1D( indexAttr, i ).xyz;
		vec3 a = texelFetch1D( positionAttr, indices.x ).rgb;
		vec3 b = texelFetch1D( positionAttr, indices.y ).rgb;
		vec3 c = texelFetch1D( positionAttr, indices.z ).rgb;

		// get the closest point and barycoord
		vec3 closestPoint = closestPointToTriangle( point, a, b, c, localBarycoord );
		vec3 delta = point - closestPoint;
		float sqDist = dot2( delta );
		if ( sqDist < closestDistanceSquared ) {

			// set the output results
			closestDistanceSquared = sqDist;
			faceIndices = uvec4( indices.xyz, i );
			faceNormal = normalize( cross( a - b, b - c ) );
			barycoord = localBarycoord;
			outPoint = closestPoint;
			side = sign( dot( faceNormal, delta ) );

		}

	}

	return closestDistanceSquared;

}

float distanceSqToBounds( vec3 point, vec3 boundsMin, vec3 boundsMax ) {

	vec3 clampedPoint = clamp( point, boundsMin, boundsMax );
	vec3 delta = point - clampedPoint;
	return dot( delta, delta );

}

float distanceSqToBVHNodeBoundsPoint( vec3 point, sampler2D bvhBounds, uint currNodeIndex ) {

	uint cni2 = currNodeIndex * 2u;
	vec3 boundsMin = texelFetch1D( bvhBounds, cni2 ).xyz;
	vec3 boundsMax = texelFetch1D( bvhBounds, cni2 + 1u ).xyz;
	return distanceSqToBounds( point, boundsMin, boundsMax );

}

// use a macro to hide the fact that we need to expand the struct into separate fields
#define\
	bvhClosestPointToPoint(\
		bvh,\
		point, faceIndices, faceNormal, barycoord, side, outPoint\
	)\
	_bvhClosestPointToPoint(\
		bvh.position, bvh.index, bvh.bvhBounds, bvh.bvhContents,\
		point, faceIndices, faceNormal, barycoord, side, outPoint\
	)

float _bvhClosestPointToPoint(
	// bvh info
	sampler2D bvh_position, usampler2D bvh_index, sampler2D bvh_bvhBounds, usampler2D bvh_bvhContents,

	// point to check
	vec3 point,

	// output variables
	inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord,
	inout float side, inout vec3 outPoint
 ) {

	// stack needs to be twice as long as the deepest tree we expect because
	// we push both the left and right child onto the stack every traversal
	int ptr = 0;
	uint stack[ BVH_STACK_DEPTH ];
	stack[ 0 ] = 0u;

	float closestDistanceSquared = pow( 100000.0, 2.0 );
	bool found = false;
	while ( ptr > - 1 && ptr < BVH_STACK_DEPTH ) {

		uint currNodeIndex = stack[ ptr ];
		ptr --;

		// check if we intersect the current bounds
		float boundsHitDistance = distanceSqToBVHNodeBoundsPoint( point, bvh_bvhBounds, currNodeIndex );
		if ( boundsHitDistance > closestDistanceSquared ) {

			continue;

		}

		uvec2 boundsInfo = uTexelFetch1D( bvh_bvhContents, currNodeIndex ).xy;
		bool isLeaf = bool( boundsInfo.x & 0xffff0000u );
		if ( isLeaf ) {

			uint count = boundsInfo.x & 0x0000ffffu;
			uint offset = boundsInfo.y;
			closestDistanceSquared = distanceToTriangles(
				bvh_position, bvh_index, offset, count, point, closestDistanceSquared,

				// outputs
				faceIndices, faceNormal, barycoord, side, outPoint
			);

		} else {

			uint leftIndex = currNodeIndex + 1u;
			uint splitAxis = boundsInfo.x & 0x0000ffffu;
			uint rightIndex = boundsInfo.y;
			bool leftToRight = distanceSqToBVHNodeBoundsPoint( point, bvh_bvhBounds, leftIndex ) < distanceSqToBVHNodeBoundsPoint( point, bvh_bvhBounds, rightIndex );//rayDirection[ splitAxis ] >= 0.0;
			uint c1 = leftToRight ? leftIndex : rightIndex;
			uint c2 = leftToRight ? rightIndex : leftIndex;

			// set c2 in the stack so we traverse it later. We need to keep track of a pointer in
			// the stack while we traverse. The second pointer added is the one that will be
			// traversed first
			ptr ++;
			stack[ ptr ] = c2;
			ptr ++;
			stack[ ptr ] = c1;

		}

	}

	return sqrt( closestDistanceSquared );

}
`;

});

parcelRegister("eL5d2", function(module, exports) {

$parcel$export(module.exports, "bvh_ray_functions", () => $abe97ef051d4d2c5$export$3c2bc5470251fe4a);
const $abe97ef051d4d2c5$export$3c2bc5470251fe4a = /* glsl */ `

#ifndef TRI_INTERSECT_EPSILON
#define TRI_INTERSECT_EPSILON 1e-5
#endif

// Raycasting
bool intersectsBounds( vec3 rayOrigin, vec3 rayDirection, vec3 boundsMin, vec3 boundsMax, out float dist ) {

	// https://www.reddit.com/r/opengl/comments/8ntzz5/fast_glsl_ray_box_intersection/
	// https://tavianator.com/2011/ray_box.html
	vec3 invDir = 1.0 / rayDirection;

	// find intersection distances for each plane
	vec3 tMinPlane = invDir * ( boundsMin - rayOrigin );
	vec3 tMaxPlane = invDir * ( boundsMax - rayOrigin );

	// get the min and max distances from each intersection
	vec3 tMinHit = min( tMaxPlane, tMinPlane );
	vec3 tMaxHit = max( tMaxPlane, tMinPlane );

	// get the furthest hit distance
	vec2 t = max( tMinHit.xx, tMinHit.yz );
	float t0 = max( t.x, t.y );

	// get the minimum hit distance
	t = min( tMaxHit.xx, tMaxHit.yz );
	float t1 = min( t.x, t.y );

	// set distance to 0.0 if the ray starts inside the box
	dist = max( t0, 0.0 );

	return t1 >= dist;

}

bool intersectsTriangle(
	vec3 rayOrigin, vec3 rayDirection, vec3 a, vec3 b, vec3 c,
	out vec3 barycoord, out vec3 norm, out float dist, out float side
) {

	// https://stackoverflow.com/questions/42740765/intersection-between-line-and-triangle-in-3d
	vec3 edge1 = b - a;
	vec3 edge2 = c - a;
	norm = cross( edge1, edge2 );

	float det = - dot( rayDirection, norm );
	float invdet = 1.0 / det;

	vec3 AO = rayOrigin - a;
	vec3 DAO = cross( AO, rayDirection );

	vec4 uvt;
	uvt.x = dot( edge2, DAO ) * invdet;
	uvt.y = - dot( edge1, DAO ) * invdet;
	uvt.z = dot( AO, norm ) * invdet;
	uvt.w = 1.0 - uvt.x - uvt.y;

	// set the hit information
	barycoord = uvt.wxy; // arranged in A, B, C order
	dist = uvt.z;
	side = sign( det );
	norm = side * normalize( norm );

	// add an epsilon to avoid misses between triangles
	uvt += vec4( TRI_INTERSECT_EPSILON );

	return all( greaterThanEqual( uvt, vec4( 0.0 ) ) );

}

bool intersectTriangles(
	// geometry info and triangle range
	sampler2D positionAttr, usampler2D indexAttr, uint offset, uint count,

	// ray
	vec3 rayOrigin, vec3 rayDirection,

	// outputs
	inout float minDistance, inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord,
	inout float side, inout float dist
) {

	bool found = false;
	vec3 localBarycoord, localNormal;
	float localDist, localSide;
	for ( uint i = offset, l = offset + count; i < l; i ++ ) {

		uvec3 indices = uTexelFetch1D( indexAttr, i ).xyz;
		vec3 a = texelFetch1D( positionAttr, indices.x ).rgb;
		vec3 b = texelFetch1D( positionAttr, indices.y ).rgb;
		vec3 c = texelFetch1D( positionAttr, indices.z ).rgb;

		if (
			intersectsTriangle( rayOrigin, rayDirection, a, b, c, localBarycoord, localNormal, localDist, localSide )
			&& localDist < minDistance
		) {

			found = true;
			minDistance = localDist;

			faceIndices = uvec4( indices.xyz, i );
			faceNormal = localNormal;

			side = localSide;
			barycoord = localBarycoord;
			dist = localDist;

		}

	}

	return found;

}

bool intersectsBVHNodeBounds( vec3 rayOrigin, vec3 rayDirection, sampler2D bvhBounds, uint currNodeIndex, out float dist ) {

	uint cni2 = currNodeIndex * 2u;
	vec3 boundsMin = texelFetch1D( bvhBounds, cni2 ).xyz;
	vec3 boundsMax = texelFetch1D( bvhBounds, cni2 + 1u ).xyz;
	return intersectsBounds( rayOrigin, rayDirection, boundsMin, boundsMax, dist );

}

// use a macro to hide the fact that we need to expand the struct into separate fields
#define\
	bvhIntersectFirstHit(\
		bvh,\
		rayOrigin, rayDirection, faceIndices, faceNormal, barycoord, side, dist\
	)\
	_bvhIntersectFirstHit(\
		bvh.position, bvh.index, bvh.bvhBounds, bvh.bvhContents,\
		rayOrigin, rayDirection, faceIndices, faceNormal, barycoord, side, dist\
	)

bool _bvhIntersectFirstHit(
	// bvh info
	sampler2D bvh_position, usampler2D bvh_index, sampler2D bvh_bvhBounds, usampler2D bvh_bvhContents,

	// ray
	vec3 rayOrigin, vec3 rayDirection,

	// output variables split into separate variables due to output precision
	inout uvec4 faceIndices, inout vec3 faceNormal, inout vec3 barycoord,
	inout float side, inout float dist
) {

	// stack needs to be twice as long as the deepest tree we expect because
	// we push both the left and right child onto the stack every traversal
	int ptr = 0;
	uint stack[ BVH_STACK_DEPTH ];
	stack[ 0 ] = 0u;

	float triangleDistance = INFINITY;
	bool found = false;
	while ( ptr > - 1 && ptr < BVH_STACK_DEPTH ) {

		uint currNodeIndex = stack[ ptr ];
		ptr --;

		// check if we intersect the current bounds
		float boundsHitDistance;
		if (
			! intersectsBVHNodeBounds( rayOrigin, rayDirection, bvh_bvhBounds, currNodeIndex, boundsHitDistance )
			|| boundsHitDistance > triangleDistance
		) {

			continue;

		}

		uvec2 boundsInfo = uTexelFetch1D( bvh_bvhContents, currNodeIndex ).xy;
		bool isLeaf = bool( boundsInfo.x & 0xffff0000u );

		if ( isLeaf ) {

			uint count = boundsInfo.x & 0x0000ffffu;
			uint offset = boundsInfo.y;

			found = intersectTriangles(
				bvh_position, bvh_index, offset, count,
				rayOrigin, rayDirection, triangleDistance,
				faceIndices, faceNormal, barycoord, side, dist
			) || found;

		} else {

			uint leftIndex = currNodeIndex + 1u;
			uint splitAxis = boundsInfo.x & 0x0000ffffu;
			uint rightIndex = boundsInfo.y;

			bool leftToRight = rayDirection[ splitAxis ] >= 0.0;
			uint c1 = leftToRight ? leftIndex : rightIndex;
			uint c2 = leftToRight ? rightIndex : leftIndex;

			// set c2 in the stack so we traverse it later. We need to keep track of a pointer in
			// the stack while we traverse. The second pointer added is the one that will be
			// traversed first
			ptr ++;
			stack[ ptr ] = c2;

			ptr ++;
			stack[ ptr ] = c1;

		}

	}

	return found;

}
`;

});

parcelRegister("fFvuX", function(module, exports) {

$parcel$export(module.exports, "bvh_struct_definitions", () => $b6831e42db74378f$export$5e276bbaa046dbad);
// Note that a struct cannot be used for the hit record including faceIndices, faceNormal, barycoord,
// side, and dist because on some mobile GPUS (such as Adreno) numbers are afforded less precision specifically
// when in a struct leading to inaccurate hit results. See KhronosGroup/WebGL#3351 for more details.
const $b6831e42db74378f$export$5e276bbaa046dbad = /* glsl */ `
struct BVH {

	usampler2D index;
	sampler2D position;

	sampler2D bvhBounds;
	usampler2D bvhContents;

};
`;

});


parcelRegister("3mzmA", function(module, exports) {

$parcel$export(module.exports, "MeshBVHUniformStruct", () => $272edb95ce0a48ac$export$4dc20da53fccce35);

var $ilwiq = parcelRequire("ilwiq");

var $hN8zD = parcelRequire("hN8zD");

var $alNGj = parcelRequire("alNGj");

var $8x2iv = parcelRequire("8x2iv");

var $5Gkg5 = parcelRequire("5Gkg5");
class $272edb95ce0a48ac$export$4dc20da53fccce35 {
    constructor(){
        this.index = new (0, $hN8zD.UIntVertexAttributeTexture)();
        this.position = new (0, $hN8zD.FloatVertexAttributeTexture)();
        this.bvhBounds = new (0, $ilwiq.DataTexture)();
        this.bvhContents = new (0, $ilwiq.DataTexture)();
        this._cachedIndexAttr = null;
        this.index.overrideItemSize = 3;
    }
    updateFrom(bvh) {
        const { geometry: geometry } = bvh;
        $272edb95ce0a48ac$var$bvhToTextures(bvh, this.bvhBounds, this.bvhContents);
        this.position.updateFrom(geometry.attributes.position);
        // dereference a new index attribute if we're using indirect storage
        if (bvh.indirect) {
            const indirectBuffer = bvh._indirectBuffer;
            if (this._cachedIndexAttr === null || this._cachedIndexAttr.count !== indirectBuffer.length) {
                if (geometry.index) this._cachedIndexAttr = geometry.index.clone();
                else {
                    const array = (0, $5Gkg5.getIndexArray)((0, $5Gkg5.getVertexCount)(geometry));
                    this._cachedIndexAttr = new (0, $ilwiq.BufferAttribute)(array, 1, false);
                }
            }
            $272edb95ce0a48ac$var$dereferenceIndex(geometry, indirectBuffer, this._cachedIndexAttr);
            this.index.updateFrom(this._cachedIndexAttr);
        } else this.index.updateFrom(geometry.index);
    }
    dispose() {
        const { index: index, position: position, bvhBounds: bvhBounds, bvhContents: bvhContents } = this;
        if (index) index.dispose();
        if (position) position.dispose();
        if (bvhBounds) bvhBounds.dispose();
        if (bvhContents) bvhContents.dispose();
    }
}
function $272edb95ce0a48ac$var$dereferenceIndex(geometry, indirectBuffer, target) {
    const unpacked = target.array;
    const indexArray = geometry.index ? geometry.index.array : null;
    for(let i = 0, l = indirectBuffer.length; i < l; i++){
        const i3 = 3 * i;
        const v3 = 3 * indirectBuffer[i];
        for(let c = 0; c < 3; c++)unpacked[i3 + c] = indexArray ? indexArray[v3 + c] : v3 + c;
    }
}
function $272edb95ce0a48ac$var$bvhToTextures(bvh, boundsTexture, contentsTexture) {
    const roots = bvh._roots;
    if (roots.length !== 1) throw new Error("MeshBVHUniformStruct: Multi-root BVHs not supported.");
    const root = roots[0];
    const uint16Array = new Uint16Array(root);
    const uint32Array = new Uint32Array(root);
    const float32Array = new Float32Array(root);
    // Both bounds need two elements per node so compute the height so it's twice as long as
    // the width so we can expand the row by two and still have a square texture
    const nodeCount = root.byteLength / (0, $alNGj.BYTES_PER_NODE);
    const boundsDimension = 2 * Math.ceil(Math.sqrt(nodeCount / 2));
    const boundsArray = new Float32Array(4 * boundsDimension * boundsDimension);
    const contentsDimension = Math.ceil(Math.sqrt(nodeCount));
    const contentsArray = new Uint32Array(2 * contentsDimension * contentsDimension);
    for(let i = 0; i < nodeCount; i++){
        const nodeIndex32 = i * (0, $alNGj.BYTES_PER_NODE) / 4;
        const nodeIndex16 = nodeIndex32 * 2;
        const boundsIndex = (0, $8x2iv.BOUNDING_DATA_INDEX)(nodeIndex32);
        for(let b = 0; b < 3; b++){
            boundsArray[8 * i + 0 + b] = float32Array[boundsIndex + 0 + b];
            boundsArray[8 * i + 4 + b] = float32Array[boundsIndex + 3 + b];
        }
        if ((0, $8x2iv.IS_LEAF)(nodeIndex16, uint16Array)) {
            const count = (0, $8x2iv.COUNT)(nodeIndex16, uint16Array);
            const offset = (0, $8x2iv.OFFSET)(nodeIndex32, uint32Array);
            const mergedLeafCount = 0xffff0000 | count;
            contentsArray[i * 2 + 0] = mergedLeafCount;
            contentsArray[i * 2 + 1] = offset;
        } else {
            const rightIndex = 4 * (0, $8x2iv.RIGHT_NODE)(nodeIndex32, uint32Array) / (0, $alNGj.BYTES_PER_NODE);
            const splitAxis = (0, $8x2iv.SPLIT_AXIS)(nodeIndex32, uint32Array);
            contentsArray[i * 2 + 0] = splitAxis;
            contentsArray[i * 2 + 1] = rightIndex;
        }
    }
    boundsTexture.image.data = boundsArray;
    boundsTexture.image.width = boundsDimension;
    boundsTexture.image.height = boundsDimension;
    boundsTexture.format = (0, $ilwiq.RGBAFormat);
    boundsTexture.type = (0, $ilwiq.FloatType);
    boundsTexture.internalFormat = "RGBA32F";
    boundsTexture.minFilter = (0, $ilwiq.NearestFilter);
    boundsTexture.magFilter = (0, $ilwiq.NearestFilter);
    boundsTexture.generateMipmaps = false;
    boundsTexture.needsUpdate = true;
    boundsTexture.dispose();
    contentsTexture.image.data = contentsArray;
    contentsTexture.image.width = contentsDimension;
    contentsTexture.image.height = contentsDimension;
    contentsTexture.format = (0, $ilwiq.RGIntegerFormat);
    contentsTexture.type = (0, $ilwiq.UnsignedIntType);
    contentsTexture.internalFormat = "RG32UI";
    contentsTexture.minFilter = (0, $ilwiq.NearestFilter);
    contentsTexture.magFilter = (0, $ilwiq.NearestFilter);
    contentsTexture.generateMipmaps = false;
    contentsTexture.needsUpdate = true;
    contentsTexture.dispose();
}

});
parcelRegister("hN8zD", function(module, exports) {

$parcel$export(module.exports, "UIntVertexAttributeTexture", () => $cf3da9d49bbdbfb4$export$de036370a093ef);
$parcel$export(module.exports, "FloatVertexAttributeTexture", () => $cf3da9d49bbdbfb4$export$5444fd0f1815741f);

var $ilwiq = parcelRequire("ilwiq");
function $cf3da9d49bbdbfb4$var$countToStringFormat(count) {
    switch(count){
        case 1:
            return "R";
        case 2:
            return "RG";
        case 3:
            return "RGBA";
        case 4:
            return "RGBA";
    }
    throw new Error();
}
function $cf3da9d49bbdbfb4$var$countToFormat(count) {
    switch(count){
        case 1:
            return 0, $ilwiq.RedFormat;
        case 2:
            return 0, $ilwiq.RGFormat;
        case 3:
            return 0, $ilwiq.RGBAFormat;
        case 4:
            return 0, $ilwiq.RGBAFormat;
    }
}
function $cf3da9d49bbdbfb4$var$countToIntFormat(count) {
    switch(count){
        case 1:
            return 0, $ilwiq.RedIntegerFormat;
        case 2:
            return 0, $ilwiq.RGIntegerFormat;
        case 3:
            return 0, $ilwiq.RGBAIntegerFormat;
        case 4:
            return 0, $ilwiq.RGBAIntegerFormat;
    }
}
class $cf3da9d49bbdbfb4$export$2ba8de89bc26b001 extends (0, $ilwiq.DataTexture) {
    constructor(){
        super();
        this.minFilter = (0, $ilwiq.NearestFilter);
        this.magFilter = (0, $ilwiq.NearestFilter);
        this.generateMipmaps = false;
        this.overrideItemSize = null;
        this._forcedType = null;
    }
    updateFrom(attr) {
        const overrideItemSize = this.overrideItemSize;
        const originalItemSize = attr.itemSize;
        const originalCount = attr.count;
        if (overrideItemSize !== null) {
            if (originalItemSize * originalCount % overrideItemSize !== 0.0) throw new Error("VertexAttributeTexture: overrideItemSize must divide evenly into buffer length.");
            attr.itemSize = overrideItemSize;
            attr.count = originalCount * originalItemSize / overrideItemSize;
        }
        const itemSize = attr.itemSize;
        const count = attr.count;
        const normalized = attr.normalized;
        const originalBufferCons = attr.array.constructor;
        const byteCount = originalBufferCons.BYTES_PER_ELEMENT;
        let targetType = this._forcedType;
        let finalStride = itemSize;
        // derive the type of texture this should be in the shader
        if (targetType === null) switch(originalBufferCons){
            case Float32Array:
                targetType = (0, $ilwiq.FloatType);
                break;
            case Uint8Array:
            case Uint16Array:
            case Uint32Array:
                targetType = (0, $ilwiq.UnsignedIntType);
                break;
            case Int8Array:
            case Int16Array:
            case Int32Array:
                targetType = (0, $ilwiq.IntType);
                break;
        }
        // get the target format to store the texture as
        let type, format, normalizeValue, targetBufferCons;
        let internalFormat = $cf3da9d49bbdbfb4$var$countToStringFormat(itemSize);
        switch(targetType){
            case 0, $ilwiq.FloatType:
                normalizeValue = 1.0;
                format = $cf3da9d49bbdbfb4$var$countToFormat(itemSize);
                if (normalized && byteCount === 1) {
                    targetBufferCons = originalBufferCons;
                    internalFormat += "8";
                    if (originalBufferCons === Uint8Array) type = (0, $ilwiq.UnsignedByteType);
                    else {
                        type = (0, $ilwiq.ByteType);
                        internalFormat += "_SNORM";
                    }
                } else {
                    targetBufferCons = Float32Array;
                    internalFormat += "32F";
                    type = (0, $ilwiq.FloatType);
                }
                break;
            case 0, $ilwiq.IntType:
                internalFormat += byteCount * 8 + "I";
                normalizeValue = normalized ? Math.pow(2, originalBufferCons.BYTES_PER_ELEMENT * 8 - 1) : 1.0;
                format = $cf3da9d49bbdbfb4$var$countToIntFormat(itemSize);
                if (byteCount === 1) {
                    targetBufferCons = Int8Array;
                    type = (0, $ilwiq.ByteType);
                } else if (byteCount === 2) {
                    targetBufferCons = Int16Array;
                    type = (0, $ilwiq.ShortType);
                } else {
                    targetBufferCons = Int32Array;
                    type = (0, $ilwiq.IntType);
                }
                break;
            case 0, $ilwiq.UnsignedIntType:
                internalFormat += byteCount * 8 + "UI";
                normalizeValue = normalized ? Math.pow(2, originalBufferCons.BYTES_PER_ELEMENT * 8 - 1) : 1.0;
                format = $cf3da9d49bbdbfb4$var$countToIntFormat(itemSize);
                if (byteCount === 1) {
                    targetBufferCons = Uint8Array;
                    type = (0, $ilwiq.UnsignedByteType);
                } else if (byteCount === 2) {
                    targetBufferCons = Uint16Array;
                    type = (0, $ilwiq.UnsignedShortType);
                } else {
                    targetBufferCons = Uint32Array;
                    type = (0, $ilwiq.UnsignedIntType);
                }
                break;
        }
        // there will be a mismatch between format length and final length because
        // RGBFormat and RGBIntegerFormat was removed
        if (finalStride === 3 && (format === (0, $ilwiq.RGBAFormat) || format === (0, $ilwiq.RGBAIntegerFormat))) finalStride = 4;
        // copy the data over to the new texture array
        const dimension = Math.ceil(Math.sqrt(count)) || 1;
        const length = finalStride * dimension * dimension;
        const dataArray = new targetBufferCons(length);
        // temporarily set the normalized state to false since we have custom normalization logic
        const originalNormalized = attr.normalized;
        attr.normalized = false;
        for(let i = 0; i < count; i++){
            const ii = finalStride * i;
            dataArray[ii] = attr.getX(i) / normalizeValue;
            if (itemSize >= 2) dataArray[ii + 1] = attr.getY(i) / normalizeValue;
            if (itemSize >= 3) {
                dataArray[ii + 2] = attr.getZ(i) / normalizeValue;
                if (finalStride === 4) dataArray[ii + 3] = 1.0;
            }
            if (itemSize >= 4) dataArray[ii + 3] = attr.getW(i) / normalizeValue;
        }
        attr.normalized = originalNormalized;
        this.internalFormat = internalFormat;
        this.format = format;
        this.type = type;
        this.image.width = dimension;
        this.image.height = dimension;
        this.image.data = dataArray;
        this.needsUpdate = true;
        this.dispose();
        attr.itemSize = originalItemSize;
        attr.count = originalCount;
    }
}
class $cf3da9d49bbdbfb4$export$de036370a093ef extends $cf3da9d49bbdbfb4$export$2ba8de89bc26b001 {
    constructor(){
        super();
        this._forcedType = (0, $ilwiq.UnsignedIntType);
    }
}
class $cf3da9d49bbdbfb4$export$7a0619b1bafd353c extends $cf3da9d49bbdbfb4$export$2ba8de89bc26b001 {
    constructor(){
        super();
        this._forcedType = (0, $ilwiq.IntType);
    }
}
class $cf3da9d49bbdbfb4$export$5444fd0f1815741f extends $cf3da9d49bbdbfb4$export$2ba8de89bc26b001 {
    constructor(){
        super();
        this._forcedType = (0, $ilwiq.FloatType);
    }
}

});


parcelRegister("laA5G", function(module, exports) {

$parcel$export(module.exports, "MATERIAL_PIXELS", () => $f69686fae5159582$export$c4a81a0bfb84e9fe);
$parcel$export(module.exports, "MaterialsTexture", () => $f69686fae5159582$export$ae96f3619813ce17);

var $ilwiq = parcelRequire("ilwiq");

var $9wqOU = parcelRequire("9wqOU");

var $6ply6 = parcelRequire("6ply6");
const $f69686fae5159582$export$c4a81a0bfb84e9fe = 47;
const $f69686fae5159582$var$MATERIAL_STRIDE = $f69686fae5159582$export$c4a81a0bfb84e9fe * 4;
class $f69686fae5159582$var$MaterialFeatures {
    constructor(){
        this._features = {};
    }
    isUsed(feature) {
        return feature in this._features;
    }
    setUsed(feature, used = true) {
        if (used === false) delete this._features[feature];
        else this._features[feature] = true;
    }
    reset() {
        this._features = {};
    }
}
class $f69686fae5159582$export$ae96f3619813ce17 extends (0, $ilwiq.DataTexture) {
    constructor(){
        super(new Float32Array(4), 1, 1);
        this.format = (0, $ilwiq.RGBAFormat);
        this.type = (0, $ilwiq.FloatType);
        this.wrapS = (0, $ilwiq.ClampToEdgeWrapping);
        this.wrapT = (0, $ilwiq.ClampToEdgeWrapping);
        this.minFilter = (0, $ilwiq.NearestFilter);
        this.magFilter = (0, $ilwiq.NearestFilter);
        this.generateMipmaps = false;
        this.features = new $f69686fae5159582$var$MaterialFeatures();
    }
    updateFrom(materials, textures) {
        function getTexture(material, key, def = -1) {
            if (key in material && material[key]) {
                const hash = (0, $9wqOU.getTextureHash)(material[key]);
                return textureLookUp[hash];
            } else return def;
        }
        function getField(material, key, def) {
            return key in material ? material[key] : def;
        }
        function writeTextureMatrixToArray(material, textureKey, array, offset) {
            const texture = material[textureKey] && material[textureKey].isTexture ? material[textureKey] : null;
            // check if texture exists
            if (texture) {
                if (texture.matrixAutoUpdate) texture.updateMatrix();
                const elements = texture.matrix.elements;
                let i = 0;
                // first row
                array[offset + i++] = elements[0];
                array[offset + i++] = elements[3];
                array[offset + i++] = elements[6];
                i++;
                // second row
                array[offset + i++] = elements[1];
                array[offset + i++] = elements[4];
                array[offset + i++] = elements[7];
                i++;
            }
            return 8;
        }
        let index = 0;
        const pixelCount = materials.length * $f69686fae5159582$export$c4a81a0bfb84e9fe;
        const dimension = Math.ceil(Math.sqrt(pixelCount)) || 1;
        const { image: image, features: features } = this;
        // index the list of textures based on shareable source
        const textureLookUp = {};
        for(let i = 0, l = textures.length; i < l; i++)textureLookUp[(0, $9wqOU.getTextureHash)(textures[i])] = i;
        if (image.width !== dimension) {
            this.dispose();
            image.data = new Float32Array(dimension * dimension * 4);
            image.width = dimension;
            image.height = dimension;
        }
        const floatArray = image.data;
        // on some devices (Google Pixel 6) the "floatBitsToInt" function does not work correctly so we
        // can't encode texture ids that way.
        // const intArray = new Int32Array( floatArray.buffer );
        features.reset();
        for(let i = 0, l = materials.length; i < l; i++){
            const m = materials[i];
            if (m.isFogVolumeMaterial) {
                features.setUsed("FOG");
                for(let j = 0; j < $f69686fae5159582$var$MATERIAL_STRIDE; j++)floatArray[index + j] = 0;
                // sample 0 .rgb
                floatArray[index + 0 + 0] = m.color.r;
                floatArray[index + 0 + 1] = m.color.g;
                floatArray[index + 0 + 2] = m.color.b;
                // sample 2 .a
                floatArray[index + 8 + 3] = getField(m, "emissiveIntensity", 0.0);
                // sample 3 .rgb
                floatArray[index + 12 + 0] = m.emissive.r;
                floatArray[index + 12 + 1] = m.emissive.g;
                floatArray[index + 12 + 2] = m.emissive.b;
                // sample 13 .g
                // reusing opacity field
                floatArray[index + 52 + 1] = m.density;
                // side
                floatArray[index + 52 + 3] = 0.0;
                // sample 14 .b
                floatArray[index + 56 + 2] = 4;
                index += $f69686fae5159582$var$MATERIAL_STRIDE;
                continue;
            }
            // sample 0
            // color
            floatArray[index++] = m.color.r;
            floatArray[index++] = m.color.g;
            floatArray[index++] = m.color.b;
            floatArray[index++] = getTexture(m, "map");
            // sample 1
            // metalness & roughness
            floatArray[index++] = getField(m, "metalness", 0.0);
            floatArray[index++] = getTexture(m, "metalnessMap");
            floatArray[index++] = getField(m, "roughness", 0.0);
            floatArray[index++] = getTexture(m, "roughnessMap");
            // sample 2
            // transmission & emissiveIntensity
            // three.js assumes a default f0 of 0.04 if no ior is provided which equates to an ior of 1.5
            floatArray[index++] = getField(m, "ior", 1.5);
            floatArray[index++] = getField(m, "transmission", 0.0);
            floatArray[index++] = getTexture(m, "transmissionMap");
            floatArray[index++] = getField(m, "emissiveIntensity", 0.0);
            // sample 3
            // emission
            if ("emissive" in m) {
                floatArray[index++] = m.emissive.r;
                floatArray[index++] = m.emissive.g;
                floatArray[index++] = m.emissive.b;
            } else {
                floatArray[index++] = 0.0;
                floatArray[index++] = 0.0;
                floatArray[index++] = 0.0;
            }
            floatArray[index++] = getTexture(m, "emissiveMap");
            // sample 4
            // normals
            floatArray[index++] = getTexture(m, "normalMap");
            if ("normalScale" in m) {
                floatArray[index++] = m.normalScale.x;
                floatArray[index++] = m.normalScale.y;
            } else {
                floatArray[index++] = 1;
                floatArray[index++] = 1;
            }
            // clearcoat
            floatArray[index++] = getField(m, "clearcoat", 0.0);
            floatArray[index++] = getTexture(m, "clearcoatMap"); // sample 5
            floatArray[index++] = getField(m, "clearcoatRoughness", 0.0);
            floatArray[index++] = getTexture(m, "clearcoatRoughnessMap");
            floatArray[index++] = getTexture(m, "clearcoatNormalMap");
            // sample 6
            if ("clearcoatNormalScale" in m) {
                floatArray[index++] = m.clearcoatNormalScale.x;
                floatArray[index++] = m.clearcoatNormalScale.y;
            } else {
                floatArray[index++] = 1;
                floatArray[index++] = 1;
            }
            index++;
            floatArray[index++] = getField(m, "sheen", 0.0);
            // sample 7
            // sheen
            if ("sheenColor" in m) {
                floatArray[index++] = m.sheenColor.r;
                floatArray[index++] = m.sheenColor.g;
                floatArray[index++] = m.sheenColor.b;
            } else {
                floatArray[index++] = 0.0;
                floatArray[index++] = 0.0;
                floatArray[index++] = 0.0;
            }
            floatArray[index++] = getTexture(m, "sheenColorMap");
            // sample 8
            floatArray[index++] = getField(m, "sheenRoughness", 0.0);
            floatArray[index++] = getTexture(m, "sheenRoughnessMap");
            // iridescence
            floatArray[index++] = getTexture(m, "iridescenceMap");
            floatArray[index++] = getTexture(m, "iridescenceThicknessMap");
            // sample 9
            floatArray[index++] = getField(m, "iridescence", 0.0);
            floatArray[index++] = getField(m, "iridescenceIOR", 1.3);
            const iridescenceThicknessRange = getField(m, "iridescenceThicknessRange", [
                100,
                400
            ]);
            floatArray[index++] = iridescenceThicknessRange[0];
            floatArray[index++] = iridescenceThicknessRange[1];
            // sample 10
            // specular color
            if ("specularColor" in m) {
                floatArray[index++] = m.specularColor.r;
                floatArray[index++] = m.specularColor.g;
                floatArray[index++] = m.specularColor.b;
            } else {
                floatArray[index++] = 1.0;
                floatArray[index++] = 1.0;
                floatArray[index++] = 1.0;
            }
            floatArray[index++] = getTexture(m, "specularColorMap");
            // sample 11
            // specular intensity
            floatArray[index++] = getField(m, "specularIntensity", 1.0);
            floatArray[index++] = getTexture(m, "specularIntensityMap");
            // isThinFilm
            const isThinFilm = getField(m, "thickness", 0.0) === 0.0 && getField(m, "attenuationDistance", Infinity) === Infinity;
            floatArray[index++] = Number(isThinFilm);
            index++;
            // sample 12
            if ("attenuationColor" in m) {
                floatArray[index++] = m.attenuationColor.r;
                floatArray[index++] = m.attenuationColor.g;
                floatArray[index++] = m.attenuationColor.b;
            } else {
                floatArray[index++] = 1.0;
                floatArray[index++] = 1.0;
                floatArray[index++] = 1.0;
            }
            floatArray[index++] = getField(m, "attenuationDistance", Infinity);
            // sample 13
            // alphaMap
            floatArray[index++] = getTexture(m, "alphaMap");
            // side & matte
            floatArray[index++] = m.opacity;
            floatArray[index++] = m.alphaTest;
            if (!isThinFilm && m.transmission > 0.0) floatArray[index++] = 0;
            else switch(m.side){
                case 0, $ilwiq.FrontSide:
                    floatArray[index++] = 1;
                    break;
                case 0, $ilwiq.BackSide:
                    floatArray[index++] = -1;
                    break;
                case 0, $ilwiq.DoubleSide:
                    floatArray[index++] = 0;
                    break;
            }
            // sample 14
            floatArray[index++] = Number(getField(m, "matte", false)); // matte
            floatArray[index++] = Number(getField(m, "castShadow", true)); // shadow
            floatArray[index++] = Number(m.vertexColors) | Number(m.flatShading) << 1; // vertexColors & flatShading
            floatArray[index++] = Number(m.transparent); // transparent
            // map transform 15
            index += writeTextureMatrixToArray(m, "map", floatArray, index);
            // metalnessMap transform 17
            index += writeTextureMatrixToArray(m, "metalnessMap", floatArray, index);
            // roughnessMap transform 19
            index += writeTextureMatrixToArray(m, "roughnessMap", floatArray, index);
            // transmissionMap transform 21
            index += writeTextureMatrixToArray(m, "transmissionMap", floatArray, index);
            // emissiveMap transform 22
            index += writeTextureMatrixToArray(m, "emissiveMap", floatArray, index);
            // normalMap transform 25
            index += writeTextureMatrixToArray(m, "normalMap", floatArray, index);
            // clearcoatMap transform 27
            index += writeTextureMatrixToArray(m, "clearcoatMap", floatArray, index);
            // clearcoatNormalMap transform 29
            index += writeTextureMatrixToArray(m, "clearcoatNormalMap", floatArray, index);
            // clearcoatRoughnessMap transform 31
            index += writeTextureMatrixToArray(m, "clearcoatRoughnessMap", floatArray, index);
            // sheenColorMap transform 33
            index += writeTextureMatrixToArray(m, "sheenColorMap", floatArray, index);
            // sheenRoughnessMap transform 35
            index += writeTextureMatrixToArray(m, "sheenRoughnessMap", floatArray, index);
            // iridescenceMap transform 37
            index += writeTextureMatrixToArray(m, "iridescenceMap", floatArray, index);
            // iridescenceThicknessMap transform 39
            index += writeTextureMatrixToArray(m, "iridescenceThicknessMap", floatArray, index);
            // specularColorMap transform 41
            index += writeTextureMatrixToArray(m, "specularColorMap", floatArray, index);
            // specularIntensityMap transform 43
            index += writeTextureMatrixToArray(m, "specularIntensityMap", floatArray, index);
            // alphaMap transform 45
            index += writeTextureMatrixToArray(m, "alphaMap", floatArray, index);
        }
        // check if the contents have changed
        const hash = (0, $6ply6.bufferToHash)(floatArray.buffer);
        if (this.hash !== hash) {
            this.hash = hash;
            this.needsUpdate = true;
            return true;
        }
        return false;
    }
}

});
parcelRegister("9wqOU", function(module, exports) {

$parcel$export(module.exports, "getTextureHash", () => $6eebe81d767f0e44$export$62c3d260e4e2abca);
$parcel$export(module.exports, "getIesTextures", () => $6eebe81d767f0e44$export$b22c535c66112848);
$parcel$export(module.exports, "getTextures", () => $6eebe81d767f0e44$export$560c941db545ef55);
$parcel$export(module.exports, "getLights", () => $6eebe81d767f0e44$export$3ae1ccb94aa877f9);
function $6eebe81d767f0e44$var$uuidSort(a, b) {
    if (a.uuid < b.uuid) return 1;
    if (a.uuid > b.uuid) return -1;
    return 0;
}
function $6eebe81d767f0e44$export$62c3d260e4e2abca(t) {
    return `${t.source.uuid}:${t.colorSpace}`;
}
// reduce the set of textures to just those with a unique source while retaining
// the order of the textures.
function $6eebe81d767f0e44$var$reduceTexturesToUniqueSources(textures) {
    const sourceSet = new Set();
    const result = [];
    for(let i = 0, l = textures.length; i < l; i++){
        const tex = textures[i];
        const hash = $6eebe81d767f0e44$export$62c3d260e4e2abca(tex);
        if (!sourceSet.has(hash)) {
            sourceSet.add(hash);
            result.push(tex);
        }
    }
    return result;
}
function $6eebe81d767f0e44$export$b22c535c66112848(lights) {
    const textures = lights.map((l)=>l.iesMap || null).filter((t)=>t);
    const textureSet = new Set(textures);
    return Array.from(textureSet).sort($6eebe81d767f0e44$var$uuidSort);
}
function $6eebe81d767f0e44$export$560c941db545ef55(materials) {
    const textureSet = new Set();
    for(let i = 0, l = materials.length; i < l; i++){
        const material = materials[i];
        for(const key in material){
            const value = material[key];
            if (value && value.isTexture) textureSet.add(value);
        }
    }
    const textureArray = Array.from(textureSet);
    return $6eebe81d767f0e44$var$reduceTexturesToUniqueSources(textureArray).sort($6eebe81d767f0e44$var$uuidSort);
}
function $6eebe81d767f0e44$export$3ae1ccb94aa877f9(scene) {
    const lights = [];
    scene.traverse((c)=>{
        if (c.visible) {
            if (c.isRectAreaLight || c.isSpotLight || c.isPointLight || c.isDirectionalLight) lights.push(c);
        }
    });
    return lights.sort($6eebe81d767f0e44$var$uuidSort);
}

});


parcelRegister("1r4sY", function(module, exports) {

$parcel$export(module.exports, "material_struct", () => $10bbc6f618708662$export$f47304f32d084e8b);
const $10bbc6f618708662$export$f47304f32d084e8b = /* glsl */ `

	struct Material {

		vec3 color;
		int map;

		float metalness;
		int metalnessMap;

		float roughness;
		int roughnessMap;

		float ior;
		float transmission;
		int transmissionMap;

		float emissiveIntensity;
		vec3 emissive;
		int emissiveMap;

		int normalMap;
		vec2 normalScale;

		float clearcoat;
		int clearcoatMap;
		int clearcoatNormalMap;
		vec2 clearcoatNormalScale;
		float clearcoatRoughness;
		int clearcoatRoughnessMap;

		int iridescenceMap;
		int iridescenceThicknessMap;
		float iridescence;
		float iridescenceIor;
		float iridescenceThicknessMinimum;
		float iridescenceThicknessMaximum;

		vec3 specularColor;
		int specularColorMap;

		float specularIntensity;
		int specularIntensityMap;
		bool thinFilm;

		vec3 attenuationColor;
		float attenuationDistance;

		int alphaMap;

		bool castShadow;
		float opacity;
		float alphaTest;

		float side;
		bool matte;

		float sheen;
		vec3 sheenColor;
		int sheenColorMap;
		float sheenRoughness;
		int sheenRoughnessMap;

		bool vertexColors;
		bool flatShading;
		bool transparent;
		bool fogVolume;

		mat3 mapTransform;
		mat3 metalnessMapTransform;
		mat3 roughnessMapTransform;
		mat3 transmissionMapTransform;
		mat3 emissiveMapTransform;
		mat3 normalMapTransform;
		mat3 clearcoatMapTransform;
		mat3 clearcoatNormalMapTransform;
		mat3 clearcoatRoughnessMapTransform;
		mat3 sheenColorMapTransform;
		mat3 sheenRoughnessMapTransform;
		mat3 iridescenceMapTransform;
		mat3 iridescenceThicknessMapTransform;
		mat3 specularColorMapTransform;
		mat3 specularIntensityMapTransform;
		mat3 alphaMapTransform;

	};

	mat3 readTextureTransform( sampler2D tex, uint index ) {

		mat3 textureTransform;

		vec4 row1 = texelFetch1D( tex, index );
		vec4 row2 = texelFetch1D( tex, index + 1u );

		textureTransform[0] = vec3(row1.r, row2.r, 0.0);
		textureTransform[1] = vec3(row1.g, row2.g, 0.0);
		textureTransform[2] = vec3(row1.b, row2.b, 1.0);

		return textureTransform;

	}

	Material readMaterialInfo( sampler2D tex, uint index ) {

		uint i = index * uint( MATERIAL_PIXELS );

		vec4 s0 = texelFetch1D( tex, i + 0u );
		vec4 s1 = texelFetch1D( tex, i + 1u );
		vec4 s2 = texelFetch1D( tex, i + 2u );
		vec4 s3 = texelFetch1D( tex, i + 3u );
		vec4 s4 = texelFetch1D( tex, i + 4u );
		vec4 s5 = texelFetch1D( tex, i + 5u );
		vec4 s6 = texelFetch1D( tex, i + 6u );
		vec4 s7 = texelFetch1D( tex, i + 7u );
		vec4 s8 = texelFetch1D( tex, i + 8u );
		vec4 s9 = texelFetch1D( tex, i + 9u );
		vec4 s10 = texelFetch1D( tex, i + 10u );
		vec4 s11 = texelFetch1D( tex, i + 11u );
		vec4 s12 = texelFetch1D( tex, i + 12u );
		vec4 s13 = texelFetch1D( tex, i + 13u );
		vec4 s14 = texelFetch1D( tex, i + 14u );

		Material m;
		m.color = s0.rgb;
		m.map = int( round( s0.a ) );

		m.metalness = s1.r;
		m.metalnessMap = int( round( s1.g ) );
		m.roughness = s1.b;
		m.roughnessMap = int( round( s1.a ) );

		m.ior = s2.r;
		m.transmission = s2.g;
		m.transmissionMap = int( round( s2.b ) );
		m.emissiveIntensity = s2.a;

		m.emissive = s3.rgb;
		m.emissiveMap = int( round( s3.a ) );

		m.normalMap = int( round( s4.r ) );
		m.normalScale = s4.gb;

		m.clearcoat = s4.a;
		m.clearcoatMap = int( round( s5.r ) );
		m.clearcoatRoughness = s5.g;
		m.clearcoatRoughnessMap = int( round( s5.b ) );
		m.clearcoatNormalMap = int( round( s5.a ) );
		m.clearcoatNormalScale = s6.rg;

		m.sheen = s6.a;
		m.sheenColor = s7.rgb;
		m.sheenColorMap = int( round( s7.a ) );
		m.sheenRoughness = s8.r;
		m.sheenRoughnessMap = int( round( s8.g ) );

		m.iridescenceMap = int( round( s8.b ) );
		m.iridescenceThicknessMap = int( round( s8.a ) );
		m.iridescence = s9.r;
		m.iridescenceIor = s9.g;
		m.iridescenceThicknessMinimum = s9.b;
		m.iridescenceThicknessMaximum = s9.a;

		m.specularColor = s10.rgb;
		m.specularColorMap = int( round( s10.a ) );

		m.specularIntensity = s11.r;
		m.specularIntensityMap = int( round( s11.g ) );
		m.thinFilm = bool( s11.b );

		m.attenuationColor = s12.rgb;
		m.attenuationDistance = s12.a;

		m.alphaMap = int( round( s13.r ) );

		m.opacity = s13.g;
		m.alphaTest = s13.b;
		m.side = s13.a;

		m.matte = bool( s14.r );
		m.castShadow = bool( s14.g );
		m.vertexColors = bool( int( s14.b ) & 1 );
		m.flatShading = bool( int( s14.b ) & 2 );
		m.fogVolume = bool( int( s14.b ) & 4 );
		m.transparent = bool( s14.a );

		uint firstTextureTransformIdx = i + 15u;

		// mat3( 1.0 ) is an identity matrix
		m.mapTransform = m.map == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx );
		m.metalnessMapTransform = m.metalnessMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 2u );
		m.roughnessMapTransform = m.roughnessMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 4u );
		m.transmissionMapTransform = m.transmissionMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 6u );
		m.emissiveMapTransform = m.emissiveMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 8u );
		m.normalMapTransform = m.normalMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 10u );
		m.clearcoatMapTransform = m.clearcoatMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 12u );
		m.clearcoatNormalMapTransform = m.clearcoatNormalMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 14u );
		m.clearcoatRoughnessMapTransform = m.clearcoatRoughnessMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 16u );
		m.sheenColorMapTransform = m.sheenColorMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 18u );
		m.sheenRoughnessMapTransform = m.sheenRoughnessMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 20u );
		m.iridescenceMapTransform = m.iridescenceMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 22u );
		m.iridescenceThicknessMapTransform = m.iridescenceThicknessMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 24u );
		m.specularColorMapTransform = m.specularColorMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 26u );
		m.specularIntensityMapTransform = m.specularIntensityMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 28u );
		m.alphaMapTransform = m.alphaMap == - 1 ? mat3( 1.0 ) : readTextureTransform( tex, firstTextureTransformIdx + 30u );

		return m;

	}

`;

});

parcelRegister("cp6U0", function(module, exports) {

$parcel$export(module.exports, "shape_sampling_functions", () => $907d2c82b3e6ae31$export$4d6021b7971af115);
const $907d2c82b3e6ae31$export$4d6021b7971af115 = /* glsl */ `

	vec3 sampleHemisphere( vec3 n, vec2 uv ) {

		// https://www.rorydriscoll.com/2009/01/07/better-sampling/
		// https://graphics.pixar.com/library/OrthonormalB/paper.pdf
		float sign = n.z == 0.0 ? 1.0 : sign( n.z );
		float a = - 1.0 / ( sign + n.z );
		float b = n.x * n.y * a;
		vec3 b1 = vec3( 1.0 + sign * n.x * n.x * a, sign * b, - sign * n.x );
		vec3 b2 = vec3( b, sign + n.y * n.y * a, - n.y );

		float r = sqrt( uv.x );
		float theta = 2.0 * PI * uv.y;
		float x = r * cos( theta );
		float y = r * sin( theta );
		return x * b1 + y * b2 + sqrt( 1.0 - uv.x ) * n;

	}

	vec2 sampleTriangle( vec2 a, vec2 b, vec2 c, vec2 r ) {

		// get the edges of the triangle and the diagonal across the
		// center of the parallelogram
		vec2 e1 = a - b;
		vec2 e2 = c - b;
		vec2 diag = normalize( e1 + e2 );

		// pick the point in the parallelogram
		if ( r.x + r.y > 1.0 ) {

			r = vec2( 1.0 ) - r;

		}

		return e1 * r.x + e2 * r.y;

	}

	vec2 sampleCircle( vec2 uv ) {

		float angle = 2.0 * PI * uv.x;
		float radius = sqrt( uv.y );
		return vec2( cos( angle ), sin( angle ) ) * radius;

	}

	vec3 sampleSphere( vec2 uv ) {

		float u = ( uv.x - 0.5 ) * 2.0;
		float t = uv.y * PI * 2.0;
		float f = sqrt( 1.0 - u * u );

		return vec3( f * cos( t ), f * sin( t ), u );

	}

	vec2 sampleRegularPolygon( int sides, vec3 uvw ) {

		sides = max( sides, 3 );

		vec3 r = uvw;
		float anglePerSegment = 2.0 * PI / float( sides );
		float segment = floor( float( sides ) * r.x );

		float angle1 = anglePerSegment * segment;
		float angle2 = angle1 + anglePerSegment;
		vec2 a = vec2( sin( angle1 ), cos( angle1 ) );
		vec2 b = vec2( 0.0, 0.0 );
		vec2 c = vec2( sin( angle2 ), cos( angle2 ) );

		return sampleTriangle( a, b, c, r.yz );

	}

	// samples an aperture shape with the given number of sides. 0 means circle
	vec2 sampleAperture( int blades, vec3 uvw ) {

		return blades == 0 ?
			sampleCircle( uvw.xy ) :
			sampleRegularPolygon( blades, uvw );

	}


`;

});

parcelRegister("kmALz", function(module, exports) {

$parcel$export(module.exports, "pcg_functions", () => $ed3261c1debf969a$export$c7fd8b12fd4f43be);
const $ed3261c1debf969a$export$c7fd8b12fd4f43be = /* glsl */ `

	// https://www.shadertoy.com/view/wltcRS
	uvec4 WHITE_NOISE_SEED;

	void rng_initialize( vec2 p, int frame ) {

		// white noise seed
		WHITE_NOISE_SEED = uvec4( p, uint( frame ), uint( p.x ) + uint( p.y ) );

	}

	// https://www.pcg-random.org/
	void pcg4d( inout uvec4 v ) {

		v = v * 1664525u + 1013904223u;
		v.x += v.y * v.w;
		v.y += v.z * v.x;
		v.z += v.x * v.y;
		v.w += v.y * v.z;
		v = v ^ ( v >> 16u );
		v.x += v.y*v.w;
		v.y += v.z*v.x;
		v.z += v.x*v.y;
		v.w += v.y*v.z;

	}

	// returns [ 0, 1 ]
	float pcgRand() {

		pcg4d( WHITE_NOISE_SEED );
		return float( WHITE_NOISE_SEED.x ) / float( 0xffffffffu );

	}

	vec2 pcgRand2() {

		pcg4d( WHITE_NOISE_SEED );
		return vec2( WHITE_NOISE_SEED.xy ) / float(0xffffffffu);

	}

	vec3 pcgRand3() {

		pcg4d( WHITE_NOISE_SEED );
		return vec3( WHITE_NOISE_SEED.xyz ) / float( 0xffffffffu );

	}

	vec4 pcgRand4() {

		pcg4d( WHITE_NOISE_SEED );
		return vec4( WHITE_NOISE_SEED ) / float( 0xffffffffu );

	}
`;

});


//# sourceMappingURL=aoRender.d33f21b3.js.map
